window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function ($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function () {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function () {
    $('a[href*=#]').on('click', function (evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function (options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function (evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function (options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function () {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function (array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function (array, key, value) {
    var i = array.length;
    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function (array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function (value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function () {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function () {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function () {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function (index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function () {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {

    if (src) {
      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

      if (match) {
        return match[1];
      } else {
        return null;
      }
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    theme.current.variant = this.currentVariant;

    // Trigger to check variant availability on page load
    this.$container.trigger({
      type: 'variantChange',
      variant: this.currentVariant
    });

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function () {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function (element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function () {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function (variant) {
        var satisfied = true;

        selectedValues.forEach(function (option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function () {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function (variant) {
      var variantImage = variant.featured_media || {};
      var currentVariantImage = this.currentVariant.featured_media || {};

      if (!variant.featured_media || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function (variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function (variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function (variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
      $(this.originalSelectorId, this.$container).find(`option[value="${variant.id}"]`)[0].selected = true;
    }
  });

  return Variants;
})();


/*================ Global ================*/
/*============================================================================
  Helper utilities
==============================================================================*/
window.theme = window.theme || {};

theme.utils = {
  /**
   * Turns a string into a handle. Mimics Shopify's format.
   */
  handleize: function (str) {
    return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
  },

  /**
   * Cross-browser URL query param getter
   */
  getQueryParams: function (qs) {
    qs = qs || document.location.search;

    if (!qs) {
      return;
    }

    qs = qs.split('+').join(' ');

    var params = {},
      tokens,
      re = /[?&]?([^=]+)=([^&]*)/g;

    while (tokens = re.exec(qs)) {
      params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
    }

    return params;
  },

  updateQueryStringParameter: function (key, value, url) {
    if (!url) url = window.location.href;

    var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
      hash;

    if (re.test(url)) {
      if (typeof value !== 'undefined' && value !== null)
        return url.replace(re, '$1' + key + "=" + value + '$2$3');
      else {
        hash = url.split('#');
        url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
        if (typeof hash[1] !== 'undefined' && hash[1] !== null)
          url += '#' + hash[1];
        return url;
      }
    } else {
      if (typeof value !== 'undefined' && value !== null) {
        var separator = url.indexOf('?') !== -1 ? '&' : '?';
        hash = url.split('#');
        url = hash[0] + separator + key + '=' + value;
        if (typeof hash[1] !== 'undefined' && hash[1] !== null)
          url += '#' + hash[1];
        return url;
      }
      else
        return url;
    }
  },

  removeQueryStringParameter: function (parameter, url) {
    //prefer to use l.search if you have a location/link object
    var urlparts = url.split('?');
    if (urlparts.length >= 2) {
      var prefix = encodeURIComponent(parameter) + '=';
      var pars = urlparts[1].split(/[&;]/g);

      //reverse iteration as may be destructive
      for (var i = pars.length; i-- > 0;) {
        //idiom for string.startsWith
        if (pars[i].lastIndexOf(prefix, 0) !== -1) {
          pars.splice(i, 1);
        }
      }

      return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
    }

    return url;
  },

  updateSelectWidth: function (elem) {
    var $this = $(elem);
    var arrowWidth = 10;
    // create test element
    var text = $this.find('option:selected').text();
    var $test = $('<span>').html(text);

    // add to body, get width, and get out
    $test.appendTo('body');
    var width = $test.width();
    $test.remove();

    // set select width
    $this.width(width + 5 + arrowWidth);
  },

  flash: function (elements, color, duration) {
    var opacity = 100;
    var color = color || '255, 255, 136';
    var duration = duration || 2000;
    var interval = setInterval(function () {
      opacity -= 2.5;
      if (opacity <= 0) {
        clearInterval(interval);
        return;
      }
      $(elements).css({ background: "rgba(" + color + ", " + opacity / 100 + ")" });
    }, duration / 40);
  },

  getProductInventory: function (sku, callback) {
    $.ajax({
      url: "https://shopify.retailexpress.com.au/api/shopify_stores/matchbox-78/outlets?variant_ids=" + sku,
      // url: "https://remote.matchbox.com.au/stocklevels/MbStockLevelServerISAPI.dll/" + sku,
      // url: "https://do.positionrelative.net/matchbox/get-stock.php?sku=" + sku,
      // headers: {'X-Requested-With': 'XMLHttpRequest'}
    }).done(function (data) {
      if (typeof callback === 'function') {
        data = theme.utils.formatProductData(data);
        callback(data);
      }
    });
  },

  formatProductData: function (data) {
    var output = {}, outletCode, locationKeyName;

    for (var i = 0; i < data.outlets.length; i++) {
      for (var key in data.outlets[i].stock) {
        if (data.outlets[i].stock.hasOwnProperty(key)) {

          if (data.outlets[i].name == 'Abbotsford') {
            outletCode = 'INTERNET';
          } else {
            outletCode = data.outlets[i].name;
            locationKeyName = data.outlets[i].name.replace(' ', '_');
            if (theme.shop.locations[locationKeyName]) {
              theme.shop.locations[locationKeyName].id = data.outlets[i].external_id;
            }
          }

          output[key] = output[key] || {};
          output[key][outletCode] = parseInt(data.outlets[i].stock[key]);
        }
      }
    }

    return output;
  },

  addStockInformation: function (product, data) {
    var selectedStore, onlineStoreName = 'INTERNET', onlineInventoryOffset = 0, inventoryCount;
    if (theme.shop.locations.favourite) {
      selectedStore = theme.shop.locations.favourite;
    } else {
      selectedStore = onlineStoreName;
    }

    selectedStore = selectedStore.replace('_', ' ');

    for (var key in product.variants) {
      inventoryCount = 0;

      if (product.variants.hasOwnProperty(key)) {
        var sku = product.variants[key].id;
        product.variants[key].available = false;
        product.variants[key].inventory_source = onlineStoreName;

        var internetStock = data[sku][onlineStoreName];

        if (product.type == "Gift Card") {
          product.variants[key].available = true;
          product.variants[key].inventory_quantity = 999;
          product.variants[key].inventory_policy = "continue";
          product.variants[key].inventory_details = { "INTERNET": 999 };
        } else {
          product.variants[key].inventory_quantity = 0;
          product.variants[key].inventory_policy = "deny";
          product.variants[key].inventory_details = {};
          product.variants[key].store_availability_count = 0;

          var keys = Object.keys(data[sku]);
          for (var j = 0; j < keys.length; j++) {
            var item = keys[j].replace(' ', '_');

            if (data[sku][keys[j]] > 0) {
              inventoryCount += data[sku][keys[j]];
            }

            if (item != onlineStoreName) {
              product.variants[key].inventory_details[item] = data[sku][keys[j]];
            } else {
              product.variants[key].inventory_details[item] = internetStock;
            }
          }

          if (product.variants[key].inventory_details !== undefined) {
            for (var index in product.variants[key].inventory_details) {
              if (product.variants[key].inventory_details.hasOwnProperty(index)) {
                if (parseInt(product.variants[key].inventory_details[index]) > 0 && index != onlineStoreName && theme.shop.locations[index] !== undefined) {
                  product.variants[key].store_availability_count++;
                }
              }
            }

            var internetStores = ['RICHMOND', 'DONCASTER', 'EASTLAND', 'NUNAWADING', 'KNOX CITY', 'CHADSTONE', 'MOORABBIN'];
            // var internetStock = 0;
            // if (data[sku][onlineStoreName] !== undefined) {
            //   internetStock += parseInt(data[sku][onlineStoreName]);
            // } else {
            //   data[sku][onlineStoreName] = 0;
            // }

            // internetStock = internetStock + onlineInventoryOffset;
            product.variants[key].inventory_quantity_online = internetStock;

            data[sku][onlineStoreName] = internetStock;

            if (data[sku][selectedStore] === undefined || data[sku][selectedStore] == false || parseInt(data[sku][selectedStore]) <= 0) {
              selectedStore = onlineStoreName;
            }

            if (internetStock > 0 || data[sku][selectedStore] > 0) {
              product.variants[key].available = true;
              // product.variants[key].inventory_quantity = data[sku][selectedStore] ? Math.max(parseInt(data[sku][selectedStore]), 0) : 0;
              if (selectedStore != onlineStoreName) {
                product.variants[key].inventory_quantity = data[sku]['INTERNET'] ? Math.max(parseInt(data[sku][selectedStore]), 0) : 0;
              } else {
                product.variants[key].inventory_quantity = internetStock;
              }

              product.variants[key].inventory_source = selectedStore;
            }
          }
        }
      }

      product.variants[key].inventory_quantity_max = inventoryCount;
    }
    product.first_available_variant = product.variants[0];

    if (theme.shop.locations.favourite){
      if(product.first_available_variant.inventory_details[theme.shop.locations.favourite] > 0){
        product.first_available_variant.pickup = true;
      }
      product.first_available_variant.pickupName = theme.shop.locations.favourite;
      
    }
    if(product.first_available_variant.inventory_details['INTERNET'] > 0){
      product.first_available_variant.delivery = true;
    }
    return product;
  }

};

/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function () {
  function Drawer(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('html').add('body'),
      $page: $('#PageContent')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }


    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    //     slate.a11y.trapFocus({
    //       $container: this.$drawer,
    //       namespace: 'drawer_focus'
    //     });

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof this.config.onDrawerOpen === 'function') {
      //       if (!externalCall) {
      this.config.onDrawerOpen();
      //       }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    //     slate.a11y.removeTrapFocus({
    //       $container: this.$drawer,
    //       namespace: 'drawer_focus'
    //     });

    this.unbindEvents();
  };

  Drawer.prototype.bindEvents = function () {
    this.nodes.$parent.on('keyup.drawer', $.proxy(function (evt) {
      // close on 'esc' keypress
      if (evt.keyCode === 27) {
        this.close();
        return false;
      } else {
        return true;
      }
    }, this));

    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function () {
      return false;
    });

    this.nodes.$page.on('click.drawer', $.proxy(function () {
      this.close();
      return false;
    }, this));
  };

  Drawer.prototype.unbindEvents = function () {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  return Drawer;
})();

/*============================================================================
  Modal modules
==============================================================================*/
theme.Modals = (function () {
  function Modal(id, name, options) {
    var defaults = {
      close: '.js-modal-close',
      open: '.js-modal-open-' + name,
      openClass: 'modal--is-active'
    };

    this.$modal = $(id);

    if (!this.$modal.length) {
      return false;
    }

    this.nodes = {
      $parent: $('html').add('body')
    };
    this.config = $.extend(defaults, options);
    this.modalIsOpen = false;
    // eslint-disable-next-line shopify/jquery-dollar-sign-reference
    this.$focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$modal;
    this.init();
  }

  Modal.prototype.init = function () {
    var $openBtn = $(this.config.open);

    // Add aria controls
    $openBtn.attr('aria-expanded', 'false');

    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$modal.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Modal.prototype.open = function (evt) {
    // Keep track if modal was opened from a click, or called by another function
    var externalCall = false;

    // don't open an opened modal
    if (this.modalIsOpen) {
      return;
    }

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the modal opens, the click event bubbles up to $nodes.page
    // which closes the modal.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.modalIsOpen && !externalCall) {
      this.close();
    }

    this.$modal.addClass(this.config.openClass);
    this.nodes.$parent.addClass(this.config.openClass);

    this.modalIsOpen = true;

    // Set focus on modal
    slate.a11y.trapFocus({
      $container: this.$modal,
      $elementToFocus: this.$focusOnOpen,
      namespace: 'modal_focus'
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();
  };

  Modal.prototype.close = function () {
    // don't close a closed modal
    if (!this.modalIsOpen) {
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    this.$modal.removeClass(this.config.openClass);
    this.nodes.$parent.removeClass(this.config.openClass);

    this.modalIsOpen = false;

    // Remove focus on modal
    slate.a11y.removeTrapFocus({
      $container: this.$modal,
      namespace: 'modal_focus'
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false').focus();
    }

    this.unbindEvents();
  };

  Modal.prototype.bindEvents = function () {
    // Pressing escape closes modal
    this.nodes.$parent.on('keyup.modal', $.proxy(function (evt) {
      if (evt.keyCode === 27) {
        this.close();
      }
    }, this));
  };

  Modal.prototype.unbindEvents = function () {
    this.nodes.$parent.off('.modal');
  };

  return Modal;
})();

(function () {
  var selectors = {
    tabContainer: '.tabs-container',
    tabHandles: '.tabs-menu a',
    tabContent: '.tab-content',
    tabContentInner: '.tab-content__inner',
    tabCurrent: '.tabs-menu li.current'
  };

  var classes = {
    qtySelector: 'js-qty-select',
    tabContainerAccordionActive: 'tabs-container--accordion-active',
  };

  var $tabContainers = $(selectors.tabContainer);

  if (!$tabContainers.length) {
    return;
  }

  $tabContainers.each(function () {
    $container = $(this);

    var $tabHandles = $(selectors.tabHandles, $container);

    if (!$tabHandles.length) {
      return;
    }

    var cache = {
      inactiveTabHeight: $('.tab-content', $container).not('.active').outerHeight()
    };

    var $tabContents = $(selectors.tabContent, $container);

    if ($(window).width() > 767) {

      var lw = $('.tabs-menu li.current').width();
      var lof = $('.tabs-menu li.current').offset().left;
      var low = $container.offset().left;
      var flof = lof - low;
      var $marker = $('li.marker', $container);

      $marker.css({
        'width': lw + 'px',
        'transform': 'translate3d(' + flof + 'px, 0, 0)'
      });

      $tabHandles.on('click', function (evt) {
        evt.preventDefault();
        var $this = $(this);
        $this.parent().addClass('current');

        var lw = $this.parent().width();
        var lof = $this.parent().offset().left;
        var low = $('.tabs-container').offset().left;
        var flof = lof - low;

        $this.parent().siblings().removeClass('current');
        var $tab = $($this.attr('href'));
        $(selectors.tabContent, $container).not($tab).removeClass('active').find(selectors.tabContentInner).css('max-height', '0px');
        $tab.addClass('active');
        var $tabContentInner = $(selectors.tabContentInner, $tab);
        // $tabContentInner.css('max-height', $tabContentInner.get(0).scrollHeight);
        $tabContentInner.css('max-height', 'unset');

        $marker.css({
          'width': lw + 'px',
          'transform': 'translate3d(' + flof + 'px, 0, 0)'
        });
      });

    } else {
      $container.addClass(classes.tabContainerAccordionActive);
      $('.tab h2').removeClass('visually-hidden');

      $(".tab").accordion({
        active: false,
        collapsible: true,
        heightStyle: "content",
        activate: function (event, ui) {
          var skipScroll = $(".tab").attr('data-scroll') == 'true';
          if (!$.isEmptyObject(ui.newHeader.offset()) && skipScroll) {
            $('html:not(:animated), body:not(:animated)').animate({ scrollTop: ui.newHeader.offset().top }, 'slow');
          }
          else {
            $(".tab").attr('data-scroll', 'true');
          }
        }
      });

      $(".tab h2:first-child").trigger('click');

    }


    // $tabContents.on('click', function(evt) {
    //   var $tab = $(this);
    //   var $tabContentInner = $(selectors.tabContentInner, $tab);

    //   if ($tab.hasClass('active')) {
    //     // TODO: Chris's change will take priority when merging
    //     // $tab.removeClass('active');
    //     // $tabContentInner.css('max-height', '0px');
    //   } else {
    //     $(selectors.tabContent, $container).not($tab).removeClass('active').find(selectors.tabContentInner).css('max-height', '0px');
    //     $tab.addClass('active');
    //     $tabContentInner.css('max-height', $tabContentInner.get(0).scrollHeight);
    //     $('html, body').animate({scrollTop: $container.offset().top + (cache.inactiveTabHeight * $tab.index())}, 350);
    //   }
    // });
  });

})();

(function () {

  if ($('[data-tab]').length == 0) {
    return;
  }

  $('[data-tab]:not(.hidden)').find('.ui.accordion').accordion({
    header: ".title",
    heightStyle: "content",
  });

  $('[data-tab-target]').on('click', function () {

    $('[data-tab]').addClass('hidden');
    $('[data-tab-target]').removeClass('active');

    var target = $(this).attr('data-tab-target');
    $('[data-tab="' + target + '"]').removeClass('hidden');
    $('[data-tab-target="' + target + '"]').addClass('active');

    $('[data-tab="' + target + '"]').find('.ui.accordion').accordion({
      header: ".title",
      heightStyle: "content",
    });

  });

})();

/*============================================================================
  Quantity Selectors
==============================================================================*/
window.theme = window.theme || {};

theme.QuantitySelectors = (function () {
  var selectors = {
    qtyInputs: 'input[type="number"]',
    excludeInputs: '#cart input[type="number"]',
    qtySelector: '.js-qty-select',
    qtyButtonAdd: '.js-qty-select-add',
    qtyButtonSubtract: '.js-qty-select-sub',
  };

  var classes = {
    qtySelector: 'js-qty-select',
    qtyButtonAdd: 'js-qty-select-add',
    qtyButtonSubtract: 'js-qty-select-sub',
  };

  $(document).on('click.qtySelector', selectors.qtySelector + ' button', function (evt) {
    evt.preventDefault();
    var $button = $(this);
    var $input = $button.siblings(selectors.qtyInputs);
    var oldValue = $input.val();
    var maxQty = parseInt($input.prop('max'));
    var minQty = parseInt($input.prop('min'));
    var newValue = minQty;

    if ($button.hasClass(classes.qtyButtonAdd)) {
      newValue = parseFloat(oldValue) + 1;
      if (maxQty && newValue >= maxQty) {
        $button.prop('disabled', true);
      }
    } else {
      if (oldValue > minQty) {
        newValue = parseFloat(oldValue) - 1;
        if (maxQty && newValue < maxQty) {
          $button.siblings(selectors.qtyButtonAdd).prop('disabled', false);
        }
      }
    }

    $input.val(newValue);
    $input.trigger('update.qtySelector');
  });

  var $qtyInputs = $(selectors.qtyInputs).not(selectors.excludeInputs);

  if ($qtyInputs.length) {
    $qtyInputs.each(function () {
      var $el = $(this);
      init($el);
    });
  }

  function init($el) {
    if (!$el.length) {
      return false;
    }

    var $wrapper = $el.wrap('<div class="' + classes.qtySelector + '"></div>').parent();
    var value = parseInt($el.val());
    var maxQty = parseInt($el.prop('max'));

    $wrapper.prepend('<button title="Subtract" class="' + classes.qtyButtonSubtract + '">&ndash;</button>');

    if (maxQty == 1 && value == 1) {
      $wrapper.append('<button title="Add" class="' + classes.qtyButtonAdd + '" disabled>+</button>');
    } else {
      $wrapper.append('<button title="Add" class="' + classes.qtyButtonAdd + '">+</button>');
    }
  }

  return {
    init: init
  };
})();

(function () {
  var classes = {
    notificationHidden: 'notification-message--hidden'
  };

  var queryParams = theme.utils.getQueryParams();

  if (queryParams === undefined || queryParams.status === undefined) {
    return;
  }

  $('[data-notification="' + queryParams.status + '"]').removeClass(classes.notificationHidden);

})();

/*
 * Currency tools
 *
 * Copyright (c) 2015 Caroline Schnapp (mllegeorgesand@gmail.com)
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/mit-license.php
 *
 */

if (typeof Currency === 'undefined') {
  var Currency = {};
}

Currency.cookie = {
  configuration: {
    expires: 365,
    path: '/',
    domain: window.location.hostname
  },
  name: 'currency',
  write: function (currency) {
    jQuery.cookie(this.name, currency, this.configuration);
  },
  read: function () {
    return jQuery.cookie(this.name);
  },
  destroy: function () {
    jQuery.cookie(this.name, null, this.configuration);
  }
};

Currency.moneyFormats = {
  "USD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "${{amount}} USD"
  },
  "EUR": {
    "money_format": "&euro;{{amount}}",
    "money_with_currency_format": "&euro;{{amount}} EUR"
  },
  "GBP": {
    "money_format": "&pound;{{amount}}",
    "money_with_currency_format": "&pound;{{amount}} GBP"
  },
  "CAD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "${{amount}} CAD"
  },
  "ALL": {
    "money_format": "Lek {{amount}}",
    "money_with_currency_format": "Lek {{amount}} ALL"
  },
  "DZD": {
    "money_format": "DA {{amount}}",
    "money_with_currency_format": "DA {{amount}} DZD"
  },
  "AOA": {
    "money_format": "Kz{{amount}}",
    "money_with_currency_format": "Kz{{amount}} AOA"
  },
  "ARS": {
    "money_format": "${{amount_with_comma_separator}}",
    "money_with_currency_format": "${{amount_with_comma_separator}} ARS"
  },
  "AMD": {
    "money_format": "{{amount}} AMD",
    "money_with_currency_format": "{{amount}} AMD"
  },
  "AWG": {
    "money_format": "Afl{{amount}}",
    "money_with_currency_format": "Afl{{amount}} AWG"
  },
  "AUD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "${{amount}} AUD"
  },
  "BBD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "${{amount}} Bds"
  },
  "AZN": {
    "money_format": "m.{{amount}}",
    "money_with_currency_format": "m.{{amount}} AZN"
  },
  "BDT": {
    "money_format": "Tk {{amount}}",
    "money_with_currency_format": "Tk {{amount}} BDT"
  },
  "BSD": {
    "money_format": "BS${{amount}}",
    "money_with_currency_format": "BS${{amount}} BSD"
  },
  "BHD": {
    "money_format": "{{amount}}0 BD",
    "money_with_currency_format": "{{amount}}0 BHD"
  },
  "BYR": {
    "money_format": "Br {{amount}}",
    "money_with_currency_format": "Br {{amount}} BYR"
  },
  "BZD": {
    "money_format": "BZ${{amount}}",
    "money_with_currency_format": "BZ${{amount}} BZD"
  },
  "BTN": {
    "money_format": "Nu {{amount}}",
    "money_with_currency_format": "Nu {{amount}} BTN"
  },
  "BAM": {
    "money_format": "KM {{amount_with_comma_separator}}",
    "money_with_currency_format": "KM {{amount_with_comma_separator}} BAM"
  },
  "BRL": {
    "money_format": "R$ {{amount_with_comma_separator}}",
    "money_with_currency_format": "R$ {{amount_with_comma_separator}} BRL"
  },
  "BOB": {
    "money_format": "Bs{{amount_with_comma_separator}}",
    "money_with_currency_format": "Bs{{amount_with_comma_separator}} BOB"
  },
  "BWP": {
    "money_format": "P{{amount}}",
    "money_with_currency_format": "P{{amount}} BWP"
  },
  "BND": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "${{amount}} BND"
  },
  "BGN": {
    "money_format": "{{amount}} лв",
    "money_with_currency_format": "{{amount}} лв BGN"
  },
  "MMK": {
    "money_format": "K{{amount}}",
    "money_with_currency_format": "K{{amount}} MMK"
  },
  "KHR": {
    "money_format": "KHR{{amount}}",
    "money_with_currency_format": "KHR{{amount}}"
  },
  "KYD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "${{amount}} KYD"
  },
  "XAF": {
    "money_format": "FCFA{{amount}}",
    "money_with_currency_format": "FCFA{{amount}} XAF"
  },
  "CLP": {
    "money_format": "${{amount_no_decimals}}",
    "money_with_currency_format": "${{amount_no_decimals}} CLP"
  },
  "CNY": {
    "money_format": "&#165;{{amount}}",
    "money_with_currency_format": "&#165;{{amount}} CNY"
  },
  "COP": {
    "money_format": "${{amount_with_comma_separator}}",
    "money_with_currency_format": "${{amount_with_comma_separator}} COP"
  },
  "CRC": {
    "money_format": "&#8353; {{amount_with_comma_separator}}",
    "money_with_currency_format": "&#8353; {{amount_with_comma_separator}} CRC"
  },
  "HRK": {
    "money_format": "{{amount_with_comma_separator}} kn",
    "money_with_currency_format": "{{amount_with_comma_separator}} kn HRK"
  },
  "CZK": {
    "money_format": "{{amount_with_comma_separator}} K&#269;",
    "money_with_currency_format": "{{amount_with_comma_separator}} K&#269;"
  },
  "DKK": {
    "money_format": "{{amount_with_comma_separator}}",
    "money_with_currency_format": "kr.{{amount_with_comma_separator}}"
  },
  "DOP": {
    "money_format": "RD$ {{amount}}",
    "money_with_currency_format": "RD$ {{amount}}"
  },
  "XCD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "EC${{amount}}"
  },
  "EGP": {
    "money_format": "LE {{amount}}",
    "money_with_currency_format": "LE {{amount}} EGP"
  },
  "ETB": {
    "money_format": "Br{{amount}}",
    "money_with_currency_format": "Br{{amount}} ETB"
  },
  "XPF": {
    "money_format": "{{amount_no_decimals_with_comma_separator}} XPF",
    "money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} XPF"
  },
  "FJD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "FJ${{amount}}"
  },
  "GMD": {
    "money_format": "D {{amount}}",
    "money_with_currency_format": "D {{amount}} GMD"
  },
  "GHS": {
    "money_format": "GH&#8373;{{amount}}",
    "money_with_currency_format": "GH&#8373;{{amount}}"
  },
  "GTQ": {
    "money_format": "Q{{amount}}",
    "money_with_currency_format": "{{amount}} GTQ"
  },
  "GYD": {
    "money_format": "G${{amount}}",
    "money_with_currency_format": "${{amount}} GYD"
  },
  "GEL": {
    "money_format": "{{amount}} GEL",
    "money_with_currency_format": "{{amount}} GEL"
  },
  "HNL": {
    "money_format": "L {{amount}}",
    "money_with_currency_format": "L {{amount}} HNL"
  },
  "HKD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "HK${{amount}}"
  },
  "HUF": {
    "money_format": "{{amount_no_decimals_with_comma_separator}}",
    "money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} Ft"
  },
  "ISK": {
    "money_format": "{{amount_no_decimals}} kr",
    "money_with_currency_format": "{{amount_no_decimals}} kr ISK"
  },
  "INR": {
    "money_format": "Rs. {{amount}}",
    "money_with_currency_format": "Rs. {{amount}}"
  },
  "IDR": {
    "money_format": "{{amount_with_comma_separator}}",
    "money_with_currency_format": "Rp {{amount_with_comma_separator}}"
  },
  "ILS": {
    "money_format": "{{amount}} NIS",
    "money_with_currency_format": "{{amount}} NIS"
  },
  "JMD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "${{amount}} JMD"
  },
  "JPY": {
    "money_format": "&#165;{{amount_no_decimals}}",
    "money_with_currency_format": "&#165;{{amount_no_decimals}} JPY"
  },
  "JEP": {
    "money_format": "&pound;{{amount}}",
    "money_with_currency_format": "&pound;{{amount}} JEP"
  },
  "JOD": {
    "money_format": "{{amount}}0 JD",
    "money_with_currency_format": "{{amount}}0 JOD"
  },
  "KZT": {
    "money_format": "{{amount}} KZT",
    "money_with_currency_format": "{{amount}} KZT"
  },
  "KES": {
    "money_format": "KSh{{amount}}",
    "money_with_currency_format": "KSh{{amount}}"
  },
  "KWD": {
    "money_format": "{{amount}}0 KD",
    "money_with_currency_format": "{{amount}}0 KWD"
  },
  "KGS": {
    "money_format": "лв{{amount}}",
    "money_with_currency_format": "лв{{amount}}"
  },
  "LVL": {
    "money_format": "Ls {{amount}}",
    "money_with_currency_format": "Ls {{amount}} LVL"
  },
  "LBP": {
    "money_format": "L&pound;{{amount}}",
    "money_with_currency_format": "L&pound;{{amount}} LBP"
  },
  "LTL": {
    "money_format": "{{amount}} Lt",
    "money_with_currency_format": "{{amount}} Lt"
  },
  "MGA": {
    "money_format": "Ar {{amount}}",
    "money_with_currency_format": "Ar {{amount}} MGA"
  },
  "MKD": {
    "money_format": "ден {{amount}}",
    "money_with_currency_format": "ден {{amount}} MKD"
  },
  "MOP": {
    "money_format": "MOP${{amount}}",
    "money_with_currency_format": "MOP${{amount}}"
  },
  "MVR": {
    "money_format": "Rf{{amount}}",
    "money_with_currency_format": "Rf{{amount}} MRf"
  },
  "MXN": {
    "money_format": "$ {{amount}}",
    "money_with_currency_format": "$ {{amount}} MXN"
  },
  "MYR": {
    "money_format": "RM{{amount}} MYR",
    "money_with_currency_format": "RM{{amount}} MYR"
  },
  "MUR": {
    "money_format": "Rs {{amount}}",
    "money_with_currency_format": "Rs {{amount}} MUR"
  },
  "MDL": {
    "money_format": "{{amount}} MDL",
    "money_with_currency_format": "{{amount}} MDL"
  },
  "MAD": {
    "money_format": "{{amount}} dh",
    "money_with_currency_format": "Dh {{amount}} MAD"
  },
  "MNT": {
    "money_format": "{{amount_no_decimals}} &#8366",
    "money_with_currency_format": "{{amount_no_decimals}} MNT"
  },
  "MZN": {
    "money_format": "{{amount}} Mt",
    "money_with_currency_format": "Mt {{amount}} MZN"
  },
  "NAD": {
    "money_format": "N${{amount}}",
    "money_with_currency_format": "N${{amount}} NAD"
  },
  "NPR": {
    "money_format": "Rs{{amount}}",
    "money_with_currency_format": "Rs{{amount}} NPR"
  },
  "ANG": {
    "money_format": "&fnof;{{amount}}",
    "money_with_currency_format": "{{amount}} NA&fnof;"
  },
  "NZD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "${{amount}} NZD"
  },
  "NIO": {
    "money_format": "C${{amount}}",
    "money_with_currency_format": "C${{amount}} NIO"
  },
  "NGN": {
    "money_format": "&#8358;{{amount}}",
    "money_with_currency_format": "&#8358;{{amount}} NGN"
  },
  "NOK": {
    "money_format": "kr {{amount_with_comma_separator}}",
    "money_with_currency_format": "kr {{amount_with_comma_separator}} NOK"
  },
  "OMR": {
    "money_format": "{{amount_with_comma_separator}} OMR",
    "money_with_currency_format": "{{amount_with_comma_separator}} OMR"
  },
  "PKR": {
    "money_format": "Rs.{{amount}}",
    "money_with_currency_format": "Rs.{{amount}} PKR"
  },
  "PGK": {
    "money_format": "K {{amount}}",
    "money_with_currency_format": "K {{amount}} PGK"
  },
  "PYG": {
    "money_format": "Gs. {{amount_no_decimals_with_comma_separator}}",
    "money_with_currency_format": "Gs. {{amount_no_decimals_with_comma_separator}} PYG"
  },
  "PEN": {
    "money_format": "S/. {{amount}}",
    "money_with_currency_format": "S/. {{amount}} PEN"
  },
  "PHP": {
    "money_format": "&#8369;{{amount}}",
    "money_with_currency_format": "&#8369;{{amount}} PHP"
  },
  "PLN": {
    "money_format": "{{amount_with_comma_separator}} zl",
    "money_with_currency_format": "{{amount_with_comma_separator}} zl PLN"
  },
  "QAR": {
    "money_format": "QAR {{amount_with_comma_separator}}",
    "money_with_currency_format": "QAR {{amount_with_comma_separator}}"
  },
  "RON": {
    "money_format": "{{amount_with_comma_separator}} lei",
    "money_with_currency_format": "{{amount_with_comma_separator}} lei RON"
  },
  "RUB": {
    "money_format": "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
    "money_with_currency_format": "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB"
  },
  "RWF": {
    "money_format": "{{amount_no_decimals}} RF",
    "money_with_currency_format": "{{amount_no_decimals}} RWF"
  },
  "WST": {
    "money_format": "WS$ {{amount}}",
    "money_with_currency_format": "WS$ {{amount}} WST"
  },
  "SAR": {
    "money_format": "{{amount}} SR",
    "money_with_currency_format": "{{amount}} SAR"
  },
  "STD": {
    "money_format": "Db {{amount}}",
    "money_with_currency_format": "Db {{amount}} STD"
  },
  "RSD": {
    "money_format": "{{amount}} RSD",
    "money_with_currency_format": "{{amount}} RSD"
  },
  "SCR": {
    "money_format": "Rs {{amount}}",
    "money_with_currency_format": "Rs {{amount}} SCR"
  },
  "SGD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "${{amount}} SGD"
  },
  "SYP": {
    "money_format": "S&pound;{{amount}}",
    "money_with_currency_format": "S&pound;{{amount}} SYP"
  },
  "ZAR": {
    "money_format": "R {{amount}}",
    "money_with_currency_format": "R {{amount}} ZAR"
  },
  "KRW": {
    "money_format": "&#8361;{{amount_no_decimals}}",
    "money_with_currency_format": "&#8361;{{amount_no_decimals}} KRW"
  },
  "LKR": {
    "money_format": "Rs {{amount}}",
    "money_with_currency_format": "Rs {{amount}} LKR"
  },
  "SEK": {
    "money_format": "{{amount_no_decimals}} kr",
    "money_with_currency_format": "{{amount_no_decimals}} kr SEK"
  },
  "CHF": {
    "money_format": "SFr. {{amount}}",
    "money_with_currency_format": "SFr. {{amount}} CHF"
  },
  "TWD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "${{amount}} TWD"
  },
  "THB": {
    "money_format": "{{amount}} &#xe3f;",
    "money_with_currency_format": "{{amount}} &#xe3f; THB"
  },
  "TZS": {
    "money_format": "{{amount}} TZS",
    "money_with_currency_format": "{{amount}} TZS"
  },
  "TTD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "${{amount}} TTD"
  },
  "TND": {
    "money_format": "{{amount}}",
    "money_with_currency_format": "{{amount}} DT"
  },
  "TRY": {
    "money_format": "{{amount}}TL",
    "money_with_currency_format": "{{amount}}TL"
  },
  "UGX": {
    "money_format": "Ush {{amount_no_decimals}}",
    "money_with_currency_format": "Ush {{amount_no_decimals}} UGX"
  },
  "UAH": {
    "money_format": "₴{{amount}}",
    "money_with_currency_format": "₴{{amount}} UAH"
  },
  "AED": {
    "money_format": "Dhs. {{amount}}",
    "money_with_currency_format": "Dhs. {{amount}} AED"
  },
  "UYU": {
    "money_format": "${{amount_with_comma_separator}}",
    "money_with_currency_format": "${{amount_with_comma_separator}} UYU"
  },
  "VUV": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "${{amount}}VT"
  },
  "VEF": {
    "money_format": "Bs. {{amount_with_comma_separator}}",
    "money_with_currency_format": "Bs. {{amount_with_comma_separator}} VEF"
  },
  "VND": {
    "money_format": "{{amount_no_decimals_with_comma_separator}}&#8363;",
    "money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} VND"
  },
  "XBT": {
    "money_format": "{{amount_no_decimals}} BTC",
    "money_with_currency_format": "{{amount_no_decimals}} BTC"
  },
  "XOF": {
    "money_format": "CFA{{amount}}",
    "money_with_currency_format": "CFA{{amount}} XOF"
  },
  "ZMW": {
    "money_format": "K{{amount_no_decimals_with_comma_separator}}",
    "money_with_currency_format": "ZMW{{amount_no_decimals_with_comma_separator}}"
  }
};

Currency.formatMoney = function (cents, format) {
  if (typeof Shopify.formatMoney === 'function') {
    return Shopify.formatMoney(cents, format);
  }
  if (typeof cents == 'string') { cents = cents.replace('.', ''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || '${{amount}}';
  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) { return 0; }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
};

Currency.currentCurrency = '';

Currency.format = 'money_with_currency_format';

Currency.convertAll = function (oldCurrency, newCurrency, selector, format) {
  if (newCurrency !== undefined) {
    $(selector || 'span.money').each(function () {
      // If the amount has already been converted, we leave it alone.
      if ($(this).attr('data-currency') === newCurrency) return;
      // If we are converting to a currency that we have saved, we will use the saved amount.
      if ($(this).attr('data-currency-' + newCurrency)) {
        $(this).html($(this).attr('data-currency-' + newCurrency));
      }
      else {
        // Converting to Y for the first time? Let's get to it!
        var cents = 0.0;
        var oldFormat = Currency.moneyFormats[oldCurrency][format || Currency.format] || '{{amount}}';
        var newFormat = Currency.moneyFormats[newCurrency][format || Currency.format] || '{{amount}}';
        if (oldFormat.indexOf('amount_no_decimals') !== -1) {
          cents = Currency.convert(parseInt($(this).html().replace(/[^0-9]/g, ''), 10) * 100, oldCurrency, newCurrency);
        }
        else if (oldCurrency === 'JOD' || oldCurrency == 'KWD' || oldCurrency == 'BHD') {
          cents = Currency.convert(parseInt($(this).html().replace(/[^0-9]/g, ''), 10) / 10, oldCurrency, newCurrency);
        }
        else {
          cents = Currency.convert(parseInt($(this).html().replace(/[^0-9]/g, ''), 10), oldCurrency, newCurrency);
        }
        var newFormattedAmount = Currency.formatMoney(cents, newFormat);
        $(this).html(newFormattedAmount);
        $(this).attr('data-currency-' + newCurrency, newFormattedAmount);
      }
      // We record the new currency locally.
      $(this).attr('data-currency', newCurrency);
    });
    this.currentFormat = Currency.moneyFormats[newCurrency][format || Currency.format] || '{{amount}}';
    this.currentCurrency = newCurrency;
    this.cookie.write(newCurrency);
  }
};

/**
* Toggles & Switches
* ------------------
* A declarative pattern for applying CSS states
* and animations based on user interaction
*
* @author Digital Surgeons
*/

(function () {

  "use strict";

  // switch constructor
  function Switch(opts) {

    this.type = opts.type;
    this.element = opts.element;
    this.target = opts.target;
    this.event = opts.event || 'click';
    this.onEvent = opts.onEvent || false;
    this.offEvent = opts.offEvent || false;
    this.className = opts.class || 'active';
    this.add = opts.add || 'active';
    this.remove = opts.remove || 'inactive';
    this.self = opts.self || false;
    this.stopPropagation = opts.stopPropagation || false;
    this.events = {};

    // if target is empty default to element itself
    this.target = this.target ? document.querySelectorAll(this.target) : [this.element];

    // mark this element as initialised
    this.element.setAttribute('data-toggle-switch', 'switch');

    // set up switch custom events
    _createCustomEvents.apply(this);

    // set up switch event listeners
    this.bindEventListeners();
  }

  // toggle constructor
  function Toggle(opts) {

    this.type = opts.type;
    this.element = opts.element;
    this.target = opts.target;
    this.className = opts.class || 'active';
    this.add = opts.add || 'active';
    this.remove = opts.remove || 'inactive';
    this.event = opts.event || 'click';
    this.self = opts.self || false;
    this.stopPropagation = opts.stopPropagation || false;
    this.events = {};

    // if target is empty default to element itself
    this.target = this.target ? document.querySelectorAll(this.target) : [this.element];

    // mark this element as initialised
    this.element.setAttribute('data-toggle-switch', 'toggle');

    // set up toggle custom events
    _createCustomEvents.apply(this);

    // set up toggle event listeners
    this.bindEventListeners();
  }

  // initialize custom events
  // spotty support for CustomEvent :/
  function _createCustomEvents() {
    // create 4 types of event
    this.events = {
      'toggled': document.createEvent('Event'),
      'added': document.createEvent('Event'),
      'removed': document.createEvent('Event'),
      'replaced': document.createEvent('Event')
    };

    this.events.toggled.initEvent('ToggleSwitch.toggled', true, true);
    this.events.added.initEvent('ToggleSwitch.added', true, true);
    this.events.removed.initEvent('ToggleSwitch.removed', true, true);
    this.events.replaced.initEvent('ToggleSwitch.replaced', true, true);
  }

  // cross browser event trigger
  function _triggerEvent(event) {
    // no event name supplied or invalid
    // instance has no element
    if (!event || typeof event !== 'string' || !this.element) {
      return false;
    }

    // check event exists
    var evt = this.events[event];
    if (!evt) {
      return false;
    }

    // trigger event
    this.element.dispatchEvent(evt);
  }

  // bind a single event listener
  function _bindEventListener(event) {
    this.element.addEventListener(event, function (e) {
      e.preventDefault();

      // optional propagation halt
      if (this.stopPropagation) {
        e.stopPropagation();
      }

      this.fire();
    }.bind(this));
  }

  // add class of className to target
  function _addClass() {
    // could be single or multiple targets
    [].forEach.call(this.target, function (el) {
      if (el.classList.contains(this.className)) {
        return false;
      }

      el.classList.add(this.className);
      _triggerEvent.apply(this, ['added']);
    }.bind(this));

    // optionally add class to element itself
    if (this.self) {
      this.element.classList.add(this.className);
    }
  }

  // remove class of className from target
  function _removeClass() {
    // could be single or multiple targets
    [].forEach.call(this.target, function (el) {
      if (!el.classList.contains(this.className)) {
        return false;
      }

      el.classList.remove(this.className);
      _triggerEvent.apply(this, ['removed']);
    }.bind(this));

    // optionally add class to element itself
    if (this.self) {
      this.element.classList.remove(this.className);
    }
  }

  // toggle class of className on target
  function _toggleClass() {
    // could be single or multiple targets
    [].forEach.call(this.target, function (el) {
      el.classList.toggle(this.className);
      _triggerEvent.apply(this, ['toggled']);
    }.bind(this));

    // optionally add class to element itself
    if (this.self) {
      this.element.classList.toggle(this.className);
    }
  }

  Switch.prototype.bindEventListeners = function () {

    var events;

    // custom on switch events
    if (this.type === 'on' && this.onEvent) {

      events = this.onEvent.split(',');

      // custom off switch events
    } else if (this.type === 'off' && this.offEvent) {

      events = this.offEvent.split(',');

      // shared on/off events
    } else {
      events = this.event.split(',');
    }

    // will be array of length 1 if single event
    events.forEach(function (event) {
      _bindEventListener.apply(this, [event]);
    }.bind(this));
  };

  // switch specific replace class logic
  Switch.prototype.replaceClass = function () {
    [].forEach.call(this.target, function (el) {
      el.classList.remove(this.remove);
      el.classList.add(this.add);
      _triggerEvent.apply(this, ['replaced']);
    }.bind(this));
  };

  Toggle.prototype.bindEventListeners = function () {
    var events = this.event.split(',');

    // will be array of length 1 if single event
    events.forEach(function (event) {
      _bindEventListener.apply(this, [event]);
    }.bind(this));
  };

  // toggle specific replace class logic
  Toggle.prototype.replaceClass = function () {
    [].forEach.call(this.target, function (el) {
      // element contains neither class
      // or element contains class that should be removed
      if ((!el.classList.contains(this.remove) && !el.classList.contains(this.add)) ||
        el.classList.contains(this.remove)) {

        el.classList.remove(this.remove);
        el.classList.add(this.add);

        // element contains that was added so reverse logic
      } else if (el.classList.contains(this.add)) {
        el.classList.add(this.remove);
        el.classList.remove(this.add);
      }

      _triggerEvent.apply(this, ['replaced']);
    }.bind(this));
  };

  // fire switch
  Switch.prototype.fire = function () {
    // this is a replace switch so replace
    if (this.type === 'replace') {

      this.replaceClass();

      // class not applied this is an on switch so add
    } else if (this.type === 'on') {

      _addClass.apply(this);

      // class applied this is an off switch so remove
    } else if (this.type === 'off') {

      _removeClass.apply(this);
    }
  };

  // fire toggle
  Toggle.prototype.fire = function () {
    if (this.type === 'replace') {
      this.replaceClass();
    } else {
      _toggleClass.apply(this);
    }
  };

  // data attr API initializers
  var initializers = {
    toggles: function (t) {
      // required params
      var opts = {
        element: t,
        target: t.getAttribute('data-toggle')
      };

      // optional params
      if (t.hasAttribute('data-toggle-class')) {
        opts.class = t.getAttribute('data-toggle-class');
      }

      if (t.hasAttribute('data-toggle-event')) {
        opts.event = t.getAttribute('data-toggle-event');
      }

      if (t.hasAttribute('data-toggle-self')) {
        opts.self = true;
      }

      if (t.hasAttribute('data-toggle-stop-propagation')) {
        opts.stopPropagation = true;
      }

      new Toggle(opts);
    },

    togglesReplace: function (t) {
      // required params
      var opts = {
        type: 'replace',
        element: t,
        target: t.getAttribute('data-toggle-replace'),
        add: t.getAttribute('data-toggle-add'),
        remove: t.getAttribute('data-toggle-remove')
      };

      // optional params
      if (t.hasAttribute('data-toggle-stop-propagation')) {
        opts.stopPropagation = true;
      }

      if (t.hasAttribute('data-toggle-event')) {
        opts.event = t.getAttribute('data-toggle-event');
      }

      new Toggle(opts);
    },

    switchesOn: function (s) {
      // required params
      var opts = {
        type: 'on',
        element: s,
        target: s.getAttribute('data-switch-on')
      };

      // optional params
      if (s.hasAttribute('data-switch-class')) {
        opts.class = s.getAttribute('data-switch-class');
      }

      if (s.hasAttribute('data-switch-event')) {
        opts.event = s.getAttribute('data-switch-event');
      }

      if (s.hasAttribute('data-switch-on-event')) {
        opts.onEvent = s.getAttribute('data-switch-on-event');
      }

      if (s.hasAttribute('data-switch-self')) {
        opts.self = true;
      }

      if (s.hasAttribute('data-switch-stop-propagation')) {
        opts.stopPropagation = true;
      }

      new Switch(opts);
    },

    switchesOff: function (s) {
      // required params
      var opts = {
        type: 'off',
        element: s,
        target: s.getAttribute('data-switch-off')
      };

      // optional params
      if (s.hasAttribute('data-switch-class')) {
        opts.class = s.getAttribute('data-switch-class');
      }

      if (s.hasAttribute('data-switch-event')) {
        opts.event = s.getAttribute('data-switch-event');
      }

      if (s.hasAttribute('data-switch-off-event')) {
        opts.offEvent = s.getAttribute('data-switch-off-event');
      }

      if (s.hasAttribute('data-switch-self')) {
        opts.self = true;
      }

      if (s.hasAttribute('data-switch-stop-propagation')) {
        opts.stopPropagation = true;
      }

      new Switch(opts);
    },

    switchesReplace: function (s) {
      // required params
      var opts = {
        type: 'replace',
        element: s,
        target: s.getAttribute('data-switch-replace'),
        add: s.getAttribute('data-switch-add'),
        remove: s.getAttribute('data-switch-remove')
      };

      // optional params
      if (s.hasAttribute('data-switch-stop-propagation')) {
        opts.stopPropagation = true;
      }

      if (s.hasAttribute('data-switch-event')) {
        opts.event = s.getAttribute('data-switch-event');
      }

      new Switch(opts);
    }
  };

  // select all toggles & switches in provided node and initialize
  function initialize(containerNode) {
    var // use not selector to ensure initialized toggles & switches aren't touched
      notInitialized = ':not([data-toggle-switch])',
      toggles = containerNode.querySelectorAll('[data-toggle]' + notInitialized),
      togglesReplace = containerNode.querySelectorAll('[data-toggle-replace]' + notInitialized),
      switchesOn = containerNode.querySelectorAll('[data-switch-on]' + notInitialized),
      switchesOff = containerNode.querySelectorAll('[data-switch-off]' + notInitialized),
      switchesReplace = containerNode.querySelectorAll('[data-switch-replace]' + notInitialized);

    // set up toggles & switches
    [].forEach.call(toggles, initializers.toggles);
    [].forEach.call(togglesReplace, initializers.togglesReplace);
    [].forEach.call(switchesOn, initializers.switchesOn);
    [].forEach.call(switchesOff, initializers.switchesOff);
    [].forEach.call(switchesReplace, initializers.switchesReplace);
  }

  // create mutation observers for watchers
  (function () {
    // check for mutation observers before using, IE11 only
    if (window.MutationObserver == undefined) {
      return;
    }

    [].forEach.call(document.querySelectorAll('[data-toggle-switch-watch]'), function (w) {
      var observer = new MutationObserver(function (mutations) {
        // target will match between all mutations so just use first
        initialize(mutations[0].target);
      });

      observer.observe(w, {
        childList: true
      });
    });
  })();

  // initialize toggles & switches in entire document
  initialize(document);

})();

window.theme = window.theme || {};

theme.NewsletterModal = (function () {

  var selectors = {
    modalContainer: '#newsletter-modal',
    successMessage: '.form-success',
  };

  function init() {

    if (!$(selectors.modalContainer).length) {
      return;
    }

    var activationDelay = parseInt($(selectors.modalContainer).attr('data-delay')),
      cookieExpiry = $(selectors.modalContainer).attr('data-expiry'),
      forceModal = JSON.parse($(selectors.modalContainer).attr('data-force-modal')),
      userHasVisited = $.cookie('newsletterModalViewed') || false,
      formSubmittedSuccessfully = $(selectors.successMessage, selectors.modalContainer).length;

    if (forceModal) {
      activationDelay = 0;
    }

    if ((!userHasVisited || forceModal) && !formSubmittedSuccessfully) {
      activateModal(activationDelay, cookieExpiry);
    } else if (formSubmittedSuccessfully) {
      openModal();
    }

    function activateModal(activationDelay, cookieExpiry) {

      $(document).on('scroll.newsletterModal', function () {
        window.setTimeout(function () {
          openModal();

          $.cookie('newsletterModalViewed', 'true', { expires: cookieExpiry, path: '/' });
        }, activationDelay);

        $(document).off('scroll.newsletterModal');
      });

    }

    function openModal() {
      if ($(window).width() > 767) {
        $.featherlight($(selectors.modalContainer), {
          variant: 'newsletter-modal',
          otherClose: '.od-modal__close',
        });
      }
    }

  }

  return init();

})();

/*================ Modules ================*/
window.theme = window.theme || {};

theme.AjaxCart = (function () {
  var selectors = {
    addToCartBtn: '[type="submit"]',
    addToCartForm: 'form[action="/cart/add"]',
    cartCount: '.site-header__cart',
    cartToggle: '.cart__toggle',
    cartDrawer: '.cart-drawer',
    cartDrawerOpen: '.cart-drawer--open'
  };

  var settings = {
    // 'aboveForm' for top of add to cart form,
    // 'belowForm' for below the add to cart form,
    // 'nextButton' for next to add to cart button and
    // 'afterBody' for after the main body content (used for fixed notifications).
    feedbackPosition: 'afterBody'
  };

  var options = {
    requestBodyClass: 'cart-loading',
    moneyFormat: window.shop.moneyFormat,
    moneyWithCurrencyFormat: window.shop.moneyWithCurrencyFormat,
    weightUnit: 'kg', // g, kg, oz, lb
    weightPrecision: 0,
    rivetsModels: {
      customer: window.shop.customer,
      shop: window.theme.shop,
      strings: window.theme.strings
    }
  };

  var cache = {
    previousCartItems: [],
    updatedItems: []
  };

  function init() {
    if (!$(selectors.cartDrawer).length) {
      return;
    }

    $(document).on('click', '[data-add-to-cart], [data-cart-add], [data-cart-update], [data-cart-remove]', function (evt) {
      var $this = $(this);
      var progressElementSelector = $this.data('progress-element');
      var $progressElement = progressElementSelector ? $(progressElementSelector) : $this;

      if ($this.is('[data-opens-cart-drawer]')) {
        $('body').addClass('cart-loader--opens-cart-drawer');
      }

      if (!$this.is('.disabled') && progressElementSelector !== undefined && !$(document.body).hasClass(options.requestBodyClass)) {
        $progressElement.addClass('cart-loader loading');
      } else {
        $progressElement.addClass('error');
        window.setTimeout(function () {
          $progressElement.removeClass('error');
        }, 1500);
      }

      if ($(evt.target).parents('[data-add-to-cart]').length > 0 || $(evt.target).hasClass('product-quick-view-add-to-cart')) {
        var $form = $(evt.target).parents('form');
        var selectedDropdown = $form.find('select[data-product-select]')[0];
        var variantId = parseInt(selectedDropdown.options[selectedDropdown.selectedIndex].value);
        var addingQty = parseInt($form.find('input[name="quantity"]').val());
        var productData = JSON.parse($form.find('input[name="properties[_inventoryJSON]"]').val());
        var variantInventory = parseInt(productData[Object.keys(productData)[0]]['INTERNET']);
        var variantInternetInventory = parseInt(productData[Object.keys(productData)[0]]['INTERNET']);

        if (theme.shop.clickAndCollect.selected != '' && theme.shop.clickAndCollect.selected) {
          if (theme.shop.locations.favourite) {
            variantInventory = parseInt(productData[Object.keys(productData)[0]][theme.shop.locations.favourite]);

          }
        }


        let addToCart = false;

        if(theme.shop.cart.items.length > 0){
          let matchInCart = false;
          for (var i = 0; i < theme.shop.cart.items.length; i++) {
            if (theme.shop.cart.items[i].variant_id == variantId) {
              var qtyInCart = CartJS.cart.items[i].quantity;
              var newTotalInCart = addingQty + qtyInCart;
              matchInCart = true;

              if (newTotalInCart > variantInventory) {
                evt.preventDefault();
                evt.stopPropagation();
                
                if (variantInventory > 0) {
                  CartJS.updateItemById(variantId, variantInventory, {}, {
                    "success": function (data, textStatus, jqXHR) {
                      showFeedback('error', 'Maximum quantity already in cart!');
                      theme.CartDrawer.open();
                      if ($(evt.target).parents('.product-quick-view').length > 0){
                        $form.parents('.od-modal').find('.od-modal-close').click();
                      }
                    }
                  });
                }
                else {
                  showFeedback('error', 'Maximum quantity already in cart!');
                  $progressElement.removeClass('cart-loader loading');
                  theme.CartDrawer.open();
                  if ($(evt.target).parents('.product-quick-view').length > 0){
                    $form.parents('.od-modal').find('.od-modal-close').click();
                  }
                  
                }
              }
              break;
            }
       
          }

          if (!matchInCart){
            addToCart = true;
          }

        }
        else {
          addToCart = true;
        }
        
        if(addToCart && variantInternetInventory == 0 && $(evt.target).parents('.product-quick-view').length > 0){
          let itemProperties = {};
          let properties = $form[0].querySelectorAll('.product-properties');
          for (var i = properties.length - 1; i >= 0; i--) {
            let name = properties[i].name.split('[')[1].split(']')[0];
            itemProperties[name] = properties[i].value;
          }
          CartJS.addItem(variantId, addingQty, itemProperties, {
            "success": function (data, textStatus, jqXHR) {
              theme.CartDrawer.open();
              $progressElement.removeClass('cart-loader loading');
              if ($(evt.target).parents('.product-quick-view').length > 0){
                $form.parents('.od-modal').find('.od-modal-close').click();
              }
            },
            "error": function (data, textStatus, jqXHR) {
              showFeedback('error', 'Maximum quantity already in cart!');
              theme.CartDrawer.open();
            },
          });
        }
      }
      
      

      if ($this.is('.disabled')) {
        evt.preventDefault();
        evt.stopPropagation();

        var highlightElements = $this.data('enable-requirements');
        if (highlightElements) {
          theme.utils.flash(highlightElements);
        }
      }
    });

    initDrawer();

    // Override CartJS error handling
    // Uses extra code from https://github.com/discolabs/cartjs/issues/68#issuecomment-261418409
    CartJS.errorHandling = {
      cartError: function (error) {
        showFeedback('error', error.description);
      }
    };

    CartJS.init(theme.shop.cart, options);

    // #sorrynotsorry
    for (var e = 0, i = 0; i < CartJS.cart.items.length; i++)e -= "click-collect" == CartJS.cart.items[i].handle ? CartJS.cart.items[i].quantity : 0;
    theme.shop.cartCount = CartJS.cart.item_count + e;

    $('.cart-drawer__shipping input[type="radio"]').on('change', function (evt) {
      updateClickCollectProductInCart();
    });

    theme.shop.clickAndCollect.isUpdating = false;

    function updateClickCollectProductInCart(callback) {
      if (theme.shop.clickAndCollect.isUpdating) {
        return;
      }

      theme.shop.clickAndCollect.isUpdating = true;

      $('.cart-drawer__submit').attr('disabled', true).addClass('loading');
      var shippingProductInCart = false;
      var shippingProductLineId = false;
      var lineProperties;

      if (theme.shop.clickAndCollect.selected != '' && theme.shop.clickAndCollect.selected) {
        if (theme.shop.locations.favourite === undefined || !theme.shop.locations.favourite) {
          theme.StoreLocator.open();
        }
      }

      if (theme.shop.locations.favourite !== undefined && theme.shop.locations.favourite != null && theme.shop.locations.favourite && theme.shop.locations.favourite != 'INTERNET') {
        lineProperties = { 'Store': theme.shop.locations[theme.shop.locations.favourite].title };
      } else {
        lineProperties = {};
      }

      for (var i = 0; i < CartJS.cart.items.length; i++) {
        if (CartJS.cart.items[i].handle == 'click-collect') {
          if (CartJS.cart.items[i].properties != null && theme.shop.locations.favourite) {
            if (CartJS.cart.items[i].properties['Store'] == theme.shop.locations[theme.shop.locations.favourite].title) {
              shippingProductInCart = true;
              shippingProductLineId = CartJS.cart.items[i].id;
            }
          } else {
            CartJS.updateItemById(CartJS.cart.items[i].id, 0, {});
          }
        }
      }

      if (!shippingProductInCart && theme.shop.clickAndCollect.selected && theme.shop.locations.favourite) {
        CartJS.addItem(39641715736755, 1, lineProperties, {
          "success": function (data, textStatus, jqXHR) {
            CartJS.setAttributes({
              'cnc-fulfilment-method': 'store',
              'cnc-outlet': theme.shop.locations[theme.shop.locations.favourite].id,
            }, {
              "success": function (data, textStatus, jqXHR) {
                $('.cart-drawer__submit').attr('disabled', false).removeClass('loading');
                theme.shop.clickAndCollect.isUpdating = false;
                if (typeof callback == "function") {
                  callback();
                }
              },
              "error": function (jqXHR, textStatus, errorThrown) {
                alert('Error: ' + errorThrown + '!');
              }
            });
          }
        });
      } else {
        if (shippingProductInCart && shippingProductLineId) {
          CartJS.updateItemById(shippingProductLineId, 0, {}, {
            "success": function (data, textStatus, jqXHR) {
              CartJS.setAttributes({
                'cnc-fulfilment-method': 'home',
                'cnc-outlet': '',
              }, {
                "success": function (data, textStatus, jqXHR) {
                  theme.shop.clickAndCollect.isUpdating = false;
                  $('.cart-drawer__submit').attr('disabled', false).removeClass('loading');
                },
                "error": function (jqXHR, textStatus, errorThrown) {
                  alert('Error: ' + errorThrown + '!');
                }
              });
            }
          });
        }
        if (theme.shop.clickAndCollect.selected && theme.shop.locations.favourite) {
          CartJS.addItem(39641715736755, 1, lineProperties, {
            "success": function (data, textStatus, jqXHR) {
              CartJS.setAttributes({
                'cnc-fulfilment-method': 'store',
                'cnc-outlet': theme.shop.locations[theme.shop.locations.favourite].id,
              }, {
                "success": function (data, textStatus, jqXHR) {
                  theme.shop.clickAndCollect.isUpdating = false;
                  $('.cart-drawer__submit').attr('disabled', false).removeClass('loading');
                  if (typeof callback == "function") {
                    callback();
                  }
                },
                "error": function (jqXHR, textStatus, errorThrown) {
                  alert('Error: ' + errorThrown + '!');
                }
              });
            }
          });
        } else {
          $('.cart-drawer__submit').attr('disabled', false).removeClass('loading');
          theme.shop.clickAndCollect.isUpdating = false;
          if (typeof callback == "function") {
            callback();
          }
        }
      }
    }

    window.checkoutStepReady = false;
    $('.cart-drawer__submit').click(function (evt) {

      if (!window.checkoutStepReady) {
        evt.preventDefault();
        $(document.body).addClass('checkout-activated');

        var callback = function () {
          window.checkoutStepReady = true;
          $('.cart-drawer__submit').addClass('loading');
          $('.cart-drawer__actions button').click();
        }

        updateClickCollectProductInCart(callback);


      }

    });

    $(document).on('cart.requestStarted', function (event, cart) {
      cache.previousCartItems = cart.items;
    });

    $(document).on('cart.requestComplete', function (event, cart) {
      $('.cart-loader.loading').removeClass('cart-loader loading').each(function () {
        if ($(this).is('.product-quick-view .btn')) {
          $.featherlight.close();
        }

        var $selectedShippingType = $('.cart-drawer__shipping input[type="radio"]:checked');
        if ($selectedShippingType.length) {
          $selectedShippingType.trigger('change');
        }
      });

      cache.updatedItems = _.differenceWith(cache.previousCartItems, cart.items, _.isEqual);

      theme.shop.cart = cart;

      // #sorry
      for (var e = 0, i = 0; i < cart.items.length; i++)e -= "click-collect" == cart.items[i].handle ? cart.items[i].quantity : 0;
      theme.shop.cartCount = cart.item_count + e;

      if (theme.Favicon !== undefined) {
        if (theme.shop.cartCount > 0) {
          theme.Favicon.set(theme.shop.cartCount);
        } else {
          theme.Favicon.reset();
        }
      }

      if ($('body').is('.cart-loader--opens-cart-drawer')) {
        $('body').removeClass('cart-loader--opens-cart-drawer');
        if (!theme.CartDrawer.drawerIsOpen) {
          theme.CartDrawer.open();
        }
      }

      if (theme.CartDrawer.drawerIsOpen && cart.item_count < 1) {
        window.setTimeout(function () {
          theme.CartDrawer.close();
        }, 2500);
      }

      //check if only click and collection item in cart
      for (var i = 0; i < CartJS.cart.items.length; i++) {
        if (CartJS.cart.items[i].handle == 'click-collect') {
          if (cart.item_count == 1) {
            CartJS.updateItemById(CartJS.cart.items[i].id, 0, {});
            return;
          }
        }
      }

      theme.shop.validateCart();
    });
  }

  function initDrawer() {
    $('#PageContent').addClass('drawer-page-content');
    $('.js-drawer-open-top').attr('aria-controls', 'CartDrawer').attr('aria-expanded', 'false');

    theme.CartDrawer = new theme.Drawers('CartDrawer', 'right', {
      onDrawerOpen: cartDrawerOpen
    });
  }

  function cartDrawerOpen() {
    // $(selectors.cartToggle).addClass(settings.cartDrawerOpen);
    var $selectedShippingType = $('.cart-drawer__shipping input[type="radio"]:checked');
    if ($selectedShippingType.length) {
      $selectedShippingType.trigger('change');
    }

    // Trigger cart validation
    // theme.shop.validCartTime = Date.now();
    window.setTimeout(function () {
      // theme.shop.validCartTime = 1;
      theme.shop.validateCart();
    }, 25);
  }

  function cartDrawerClose() {
    // $(selectors.cartToggle).removeClass(settings.cartDrawerOpen);
  }

  function showFeedback(status, response, $addToCartForm) {
    $('.ajax-cart-feedback').remove();
    var feedback = '<div class="ajax-cart-feedback ' + status + '">' + response + '</div>';



    if ($addToCartForm !== undefined && $addToCartForm.length > 0) {
      switch (settings.feedbackPosition) {
        case 'aboveForm':
          $addToCartForm.before(feedback);
          break;
        case 'belowForm':
          $addToCartForm.after(feedback);
          break;
        case 'afterBody':
          $(document.body).append(feedback);
          break;
        case 'nextButton':
        default:
          $addToCartForm.find(selectors.addToCartBtn).after(feedback);
          break;
      }
    } else {
      iziToast.show({
        message: response,
        color: 'red',
        position: 'bottomCenter'
      });
    }

    var $feedbackElement = $('.ajax-cart-feedback');

    $feedbackElement.offset(); // redraw
    $feedbackElement.addClass('active');
    window.setTimeout(function () {
      $feedbackElement.removeClass('active');
    }, 6500);
  };

  return {
    init: init
  };
})();

theme.AjaxCart.init();



















































window.theme = window.theme || {};

theme.Header = (function () {
  var selectors = {
    body: 'body',
    navigation: '.site-nav',
    siteNavItemHasDropdown: '.site-nav__item--has-dropdown',
    siteNavDropdown: '.site-nav__dropdown',
    siteNavChildLinks: '.site-nav__child-link, .site-nav__grandchild-link, .site-nav__childlist-footer .btn',
    siteNavActiveDropdown: '.site-nav--active-dropdown',
    siteNavItemActiveDropdown: '.site-nav__item--active-dropdown',
    siteNavLinkMain: '.site-nav__link--main',
    siteNavChildLink: '.site-nav__link--last'
  };

  var config = {
    hoverClass: 'site-nav__item--hover',
    activeClass: 'site-nav__item--active-dropdown',
    activeParentClass: 'site-nav--active-dropdown',
    childLinkClass: 'site-nav__child-link',
    submenuVisibleOnHover: true,
    firstParentClickNavigates: true, // Overridden for mobile devices
    secondParentClickClosesSubmenu: false, // Relies on previous option being disabled for non-mobile devices
  };

  var cache = {
    isMobile: mobileCheck()
  };

  function init() {
    cacheSelectors();

    if (config.submenuVisibleOnHover && cache.isMobile == false) {
      cache.$parents.on('mouseenter.siteNav', function (evt) {
        var $el = $(this);
        showDropdown($el);
      });

      cache.$parents.on('mouseleave.siteNav', function (evt) {
        var $el = $(this);
        hideDropdown($el);
      });
    }

    cache.$parents.on('click.siteNav', function (evt) {
      var $el = $(this);

      if (config.firstParentClickNavigates && cache.isMobile == false) {
        return;
      }

      if (config.secondParentClickClosesSubmenu || !config.secondParentClickClosesSubmenu && !$el.hasClass(config.activeClass)) {
        // force stop the click from happening
        evt.preventDefault();
        evt.stopImmediatePropagation();
      }

      if (config.secondParentClickClosesSubmenu && $el.hasClass(config.activeClass)) {
        hideDropdown($el);
        return;
      }

      showDropdown($el);
    });

    // check when we're leaving a dropdown and close the active dropdown
    $(selectors.siteNavChildLink).on('focusout.siteNav', function () {
      setTimeout(function () {
        if ($(document.activeElement).hasClass(config.childLinkClass) || !cache.$activeDropdown.length) {
          return;
        }

        hideDropdown(cache.$activeDropdown);
      });
    });

    // close dropdowns when on top level nav
    cache.$topLevel.on('focus.siteNav', function () {
      if (cache.$activeDropdown.length) {
        hideDropdown(cache.$activeDropdown);
      }
    });

    cache.$subMenuLinks.on('click.siteNav', function (evt) {
      // Prevent click on body from firing instead of link
      evt.stopImmediatePropagation();
    });

    setDropdownPositions(cache.$parents);
  }

  function cacheSelectors() {
    cache = _.assignIn({}, cache, {
      $nav: $(selectors.navigation),
      $topLevel: $(selectors.siteNavLinkMain),
      $parents: $(selectors.navigation).find(selectors.siteNavItemHasDropdown),
      $subMenuLinks: $(selectors.siteNavChildLinks),
      $activeDropdown: $(selectors.siteNavItemActiveDropdown)
    });
  }

  function setDropdownPositions($parentElems) {
    $parentElems.each(function () {
      var $el = $(this);
      var $dropdown = $(selectors.siteNavDropdown, this);
      var $dropdownContent = $dropdown.children().first();
      var dropdownOffsetLeft = Math.max(0, $el.offset().left);
      var dropdownContentWidth = $($dropdownContent).outerWidth();
      var dropdownWidth = parseInt($dropdown.css('padding-left')) + dropdownContentWidth + parseInt($dropdown.css('padding-right'));
      var windowWidth = $(window).width();

      var dropdownOffsetRight = windowWidth;
      if (dropdownWidth < windowWidth) {
        if (dropdownOffsetLeft + dropdownWidth > windowWidth) {
          dropdownOffsetLeft = Math.max(0, windowWidth - dropdownWidth);
        }
        dropdownOffsetRight = Math.min(windowWidth, dropdownOffsetLeft + dropdownWidth);
      }

      $dropdown.css('top', $el[0].getBoundingClientRect().top + $el.height());
      $dropdown.css('left', dropdownOffsetLeft);
      $dropdown.css('right', windowWidth - dropdownOffsetRight);
    });
  }

  function showDropdown($el) {
    $el.addClass(config.hoverClass);
    var dropdownActivationDelay = cache.isMobile ? 0 : 150;

    setDropdownPositions($el);

    setTimeout(function () {
      if ($el.hasClass(config.hoverClass) || cache.isMobile) {
        $el.addClass(config.activeClass);
        $el.parent().addClass(config.activeParentClass);

        // close open dropdowns
        if (cache.$activeDropdown.length) {
          hideDropdown(cache.$activeDropdown);
        }

        cache.$activeDropdown = $el;

        // set expanded on open dropdown
        $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'true');

        $(window).on('keyup.siteNav', function (evt) {
          if (evt.keyCode === 27) {
            hideDropdown($el);
          }
        });

        $(selectors.body).on('click.siteNav', function () {
          hideDropdown($el);
        });
      } else {
        hideDropdown($el);
      }
    }, dropdownActivationDelay);
  }

  function hideDropdown($el) {
    // remove aria on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'false');
    $el.parent().removeClass(config.activeParentClass);
    $el.removeClass(config.activeClass);
    $el.removeClass(config.hoverClass);

    // reset active dropdown
    cache.$activeDropdown = $(selectors.siteNavItemActiveDropdown);

    $(selectors.body).off('click.siteNav');
    $(window).off('keyup.siteNav');
  }

  function unload() {
    $(window).off('.siteNav');
    cache.$parents.off('.siteNav');
    cache.$subMenuLinks.off('.siteNav');
    cache.$topLevel.off('.siteNav');
    $(selectors.siteNavChildLink).off('.siteNav');
    $(selectors.body).off('.siteNav');
  }

  return {
    init: init,
    unload: unload
  };
})();

window.theme = window.theme || {};

theme.MobileNav = (function () {
  var classes = {
    mobileNavOpenIcon: 'mobile-nav--open',
    mobileNavCloseIcon: 'mobile-nav--close',
    navLink: 'mobile-nav__link',
    subNavLink: 'mobile-nav__sublist-link',
    return: 'mobile-nav__return-btn',
    subNavActive: 'is-active',
    subNavClosing: 'is-closing',
    navOpen: 'js-menu--is-open',
    subNavShowing: 'sub-nav--is-open',
    thirdNavShowing: 'third-nav--is-open',
    subNavToggleBtn: 'js-toggle-submenu'
  };
  var cache = {};
  var isTransitioning;
  var $activeSubNav;
  var $activeTrigger;
  var menuLevel = 1;
  // Breakpoints from src/stylesheets/global/variables.scss.liquid
  var mediaQuerySmall = 'screen and (max-width: 767px)';

  function init() {
    cacheSelectors();

    cache.$mobileNavToggle.on('click', toggleMobileNav);
    cache.$subNavToggleBtn.on('click.subNav', toggleSubNav);

    // Close mobile nav when unmatching mobile breakpoint
    enquire.register(mediaQuerySmall, {
      unmatch: function () {
        closeMobileNav();
      }
    });
  }

  function toggleMobileNav() {
    if (cache.$mobileNavToggle.hasClass(classes.mobileNavCloseIcon)) {
      closeMobileNav();
    } else {
      openMobileNav();
    }
  }

  function cacheSelectors() {
    cache = {
      $pageContainer: $('#PageContent'),
      $mobileNavToggle: $('.js-mobile-nav-toggle'),
      $mobileNavContainer: $('.mobile-nav-wrapper'),
      $mobileNav: $('#MobileNav'),
      $sectionHeader: $('#shopify-section-header'),
      $subNavToggleBtn: $('.' + classes.subNavToggleBtn)
    };
  }

  function openMobileNav() {
    var headerHeight = cache.$sectionHeader.outerHeight() + cache.$sectionHeader.offset().top;

    cache.$mobileNavContainer
      .prepareTransition()
      .addClass(classes.navOpen);

    cache.$pageContainer.addClass(classes.navOpen);

    var newContainerHeight = cache.$mobileNav.outerHeight() + cache.$sectionHeader.outerHeight() + cache.$sectionHeader.offset().top;

    cache.$mobileNavContainer.css({
      'height': (newContainerHeight - headerHeight) + 'px',
      'transform': 'translate3d(0, 0, 0)',
      // 'padding-top': headerHeight + 'px'
      'margin-top': headerHeight + 'px'
    });

    cache.$pageContainer.css({
      overflow: 'hidden',
      height: (cache.$mobileNavContainer.outerHeight() + headerHeight) + 'px'
    });

    slate.a11y.trapFocus({
      $container: cache.$sectionHeader,
      $elementToFocus: cache.$mobileNav
        .find('.' + classes.navLinkWrapper + ':first')
        .find('.' + classes.navLink),
      namespace: 'navFocus'
    });

    cache.$mobileNavToggle
      .addClass(classes.mobileNavCloseIcon)
      .removeClass(classes.mobileNavOpenIcon);

    // close on escape
    $(window).on('keyup.mobileNav', function (evt) {
      if (evt.which === 27) {
        closeMobileNav();
      }
    });
  }

  function closeMobileNav() {
    cache.$mobileNavContainer.prepareTransition().removeClass(classes.navOpen);

    cache.$pageContainer.removeClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: 'translate3d(-100%, 0, 0)'
    });

    cache.$pageContainer.css({
      overflow: 'auto',
      height: 'auto'
    });

    cache.$mobileNavContainer.one(
      'TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle',
      function () {
        slate.a11y.removeTrapFocus({
          $container: cache.$mobileNav,
          namespace: 'navFocus'
        });
      }
    );

    cache.$mobileNavToggle
      .addClass(classes.mobileNavOpenIcon)
      .removeClass(classes.mobileNavCloseIcon);

    $(window).off('keyup.mobileNav');
  }

  function toggleSubNav(evt) {
    if (isTransitioning) {
      return;
    }

    var $toggleBtn = $(evt.currentTarget);
    var isReturn = $toggleBtn.hasClass(classes.return);
    isTransitioning = true;

    if (isReturn) {
      // Close all subnavs by removing active class on buttons
      $(
        '.' + classes.subNavToggleBtn + '[data-level="' + (menuLevel - 1) + '"]'
      ).removeClass(classes.subNavActive);

      if ($activeTrigger && $activeTrigger.length) {
        $activeTrigger.removeClass(classes.subNavActive);
      }
    } else {
      $toggleBtn.addClass(classes.subNavActive);
    }

    $activeTrigger = $toggleBtn;

    goToSubnav($toggleBtn.data('target'));
  }

  function goToSubnav(target) {

    /*eslint-disable shopify/jquery-dollar-sign-reference */

    var $targetMenu = target
      ? $('.mobile-nav__dropdown[data-parent="' + target + '"]')
      : cache.$mobileNav;

    menuLevel = $targetMenu.data('level') ? $targetMenu.data('level') : 1;

    if ($activeSubNav && $activeSubNav.length) {
      $activeSubNav
        .prepareTransition()
        .addClass(classes.subNavClosing);
    }

    $activeSubNav = $targetMenu;

    var $elementToFocus = target
      ? $targetMenu.find('.' + classes.subNavLink + ':first')
      : $activeTrigger;

    /*eslint-enable shopify/jquery-dollar-sign-reference */

    // var translateMenuHeight = $targetMenu[0].scrollHeight;
    // if (!target) {
    //   translateMenuHeight = $targetMenu.outerHeight();
    // }

    var openNavClass = menuLevel > 2
      ? classes.thirdNavShowing
      : classes.subNavShowing;

    // var newContainerHeight = translateMenuHeight + cache.$sectionHeader.outerHeight() + cache.$sectionHeader.offset().top;

    cache.$mobileNavContainer
    /*.css('height', newContainerHeight + 'px')*/
    .removeClass(classes.thirdNavShowing)
    .addClass('is-transitioning')
    .addClass(openNavClass);

    if (!target) {
      // Show top level nav
      cache.$mobileNavContainer
        .removeClass(classes.thirdNavShowing)
        .removeClass(classes.subNavShowing);
    }

    // Focusing an item in the subnav early forces element into view and breaks the animation.
    cache.$mobileNavContainer.one(
      'TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle',
      function () {
        if ($elementToFocus.length > 1) {
          slate.a11y.trapFocus({
            $container: $targetMenu,
            $elementToFocus: $elementToFocus,
            namespace: 'subNavFocus'
          });
        } else {
          slate.a11y.trapFocus({
            $container: cache.$sectionHeader,
            $elementToFocus: cache.$mobileNav
              .find('.' + classes.navLinkWrapper + ':first')
              .find('.' + classes.navLink),
            namespace: 'navFocus'
          });
        }

        cache.$mobileNavContainer.off('.subnavToggle');
        cache.$mobileNavContainer.removeClass('is-transitioning');
        isTransitioning = false;
      }
    );

    // Match height of subnav
    // cache.$pageContainer.css({
    //   overflow: 'hidden',
    //   height: newContainerHeight + 'px'
    // });

    $activeSubNav.removeClass(classes.subNavClosing);
  }

  return {
    init: init,
    closeMobileNav: closeMobileNav
  };
})(jQuery);

window.theme = window.theme || {};

theme.Search = (function () {
  var selectors = {
    search: '.search',
    searchSubmit: '.search__submit',
    searchInput: '.search__input',

    siteHeader: '.site-header',
    siteHeaderSearchToggle: '.site-header__search-toggle',
    siteHeaderSearch: '.site-header__search',

    searchDrawer: '.search-bar',
    searchDrawerInput: '.search-bar__input',

    searchHeader: '.search-header',
    searchHeaderInput: '.search-header__input',
    searchHeaderSubmit: '.search-header__submit',

    mobileNavWrapper: '.mobile-nav-wrapper',
    mobileSearchToggle: '.js-mobile-search-toggle',

    pageContent: '#PageContent'
  };

  var classes = {
    focus: 'search--focus',
    mobileNavIsOpen: 'js-menu--is-open',
    mobileSearchIsOpen: 'js-search--is-open'
  };

  function init() {
    if (!$(selectors.siteHeader).length) {
      return;
    }

    initDrawer();
    searchSubmit();

    $(selectors.mobileSearchToggle).on('click', toggleMobileSearch);

    $(selectors.searchHeaderInput).add(selectors.searchHeaderSubmit).on('focus blur', function () {
      $(selectors.searchHeader).toggleClass(classes.focus);
    });

    $(selectors.siteHeaderSearchToggle).on('click', function () {
      var searchHeight = $(selectors.siteHeader).outerHeight();
      var searchOffset = $(selectors.siteHeader).offset().top - searchHeight;

      $(selectors.searchDrawer).css({
        height: searchHeight + 'px',
        top: searchOffset + 'px'
      });
    });
  }

  function initDrawer() {
    // Add required classes to HTML
    $('#PageContent').addClass('drawer-page-content');
    $('.js-drawer-open-top').attr('aria-controls', 'SearchDrawer').attr('aria-expanded', 'false');

    theme.SearchDrawer = new theme.Drawers('SearchDrawer', 'top', {
      onDrawerOpen: searchDrawerFocus
    });
  }

  function searchDrawerFocus() {
    searchFocus($(selectors.searchDrawerInput));

    if ($(selectors.mobileNavWrapper).hasClass(classes.mobileNavIsOpen)) {
      theme.MobileNav.closeMobileNav();
    }
  }

  function toggleMobileSearch() {
    searchFocus($(selectors.searchInput));

    if (!$(selectors.pageContent).hasClass(classes.mobileNavIsOpen)) {
      $(selectors.pageContent).toggleClass(classes.mobileSearchIsOpen);
    }
  }

  function searchFocus($el) {
    $el.focus();
    // set selection range hack for iOS
    $el[0].setSelectionRange(0, $el[0].value.length);
  }

  function searchSubmit() {
    $(selectors.searchSubmit).on('click', function (evt) {
      var $el = $(evt.target);
      var $input = $el.parents(selectors.search).find(selectors.searchInput);
      if ($input.val().length === 0) {
        evt.preventDefault();
        // toggleMobileSearch();
        searchFocus($input);
      }
    });
  }

  return {
    init: init
  };
})();

window.theme = window.theme || {};

theme.Templates = (function () {
  var $templates = $('.js-template[data-template-for]');

  if (!$templates.length) {
    return;
  }

  $templates.each(function () {
    var $template = $(this);
    rivets.components[$template.data('template-for')] = {
      template: function () {
        return $template.html();
      },
      initialize: function (el, data) {
        return data;
      }
    };
  });

})();

window.theme = window.theme || {};

// theme.Slideshow = (function() {
//   this.$slideshow = null;
//   var classes = {
//     wrapper: 'slideshow-wrapper',
//     slideshow: 'slideshow',
//     currentSlide: 'slick-current',
//     video: 'slideshow__video',
//     videoBackground: 'slideshow__video--background',
//     closeVideoBtn: 'slideshow__video-control--close',
//     pauseButton: 'slideshow__pause',
//     isPaused: 'is-paused'
//   };

//   function slideshow(el) {
//     this.$slideshow = $(el);
//     this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
//     this.$pause = this.$wrapper.find('.' + classes.pauseButton);

//     this.settings = {
//       accessibility: true,
//       arrows: true,
//       dots: this.$slideshow.data('dots'),
//       fade: false,
//       draggable: true,
//       touchThreshold: 20,
//       autoplay: this.$slideshow.data('autoplay'),
//       autoplaySpeed: this.$slideshow.data('speed'),
//       prevArrow: this.$slideshow.siblings('.slideshow__prev'),
//       nextArrow: this.$slideshow.siblings('.slideshow__next')
//     };

//     this.$slideshow.on('beforeChange', beforeChange.bind(this));
//     this.$slideshow.on('init', slideshowA11y.bind(this));
//     this.$slideshow.slick(this.settings);

//     this.$pause.on('click', this.togglePause.bind(this));
//   }

//   function slideshowA11y(event, obj) {
//     var $slider = obj.$slider;
//     var $list = obj.$list;
//     var $wrapper = this.$wrapper;
//     var autoplay = this.settings.autoplay;

//     // Remove default Slick aria-live attr until slider is focused
//     $list.removeAttr('aria-live');

//     // When an element in the slider is focused
//     // pause slideshow and set aria-live.
//     $wrapper.on('focusin', function(evt) {
//       if (!$wrapper.has(evt.target).length) {
//         return;
//       }

//       $list.attr('aria-live', 'polite');

//       if (autoplay) {
//         $slider.slick('slickPause');
//       }
//     });

//     // Resume autoplay
//     $wrapper.on('focusout', function(evt) {
//       if (!$wrapper.has(evt.target).length) {
//         return;
//       }

//       $list.removeAttr('aria-live');

//       if (autoplay) {
//         // Manual check if the focused element was the video close button
//         // to ensure autoplay does not resume when focus goes inside YouTube iframe
//         if ($(evt.target).hasClass(classes.closeVideoBtn)) {
//           return;
//         }

//         $slider.slick('slickPlay');
//       }
//     });

//     // Add arrow key support when focused
//     if (obj.$dots) {
//       obj.$dots.on('keydown', function(evt) {
//         if (evt.which === 37) {
//           $slider.slick('slickPrev');
//         }

//         if (evt.which === 39) {
//           $slider.slick('slickNext');
//         }

//         // Update focus on newly selected tab
//         if ((evt.which === 37) || (evt.which === 39)) {
//           obj.$dots.find('.slick-active button').focus();
//         }
//       });
//     }
//   }

//   function beforeChange(event, slick, currentSlide, nextSlide) {
//     var $slider = slick.$slider;
//     var $currentSlide = $slider.find('.' + classes.currentSlide);
//     var $nextSlide = $slider.find('.slideshow__slide[data-slick-index="' + nextSlide + '"]');

//     if (isVideoInSlide($currentSlide)) {
//       var $currentVideo = $currentSlide.find('.' + classes.video);
//       var currentVideoId = $currentVideo.attr('id');
//       theme.SlideshowVideo.pauseVideo(currentVideoId);
//       $currentVideo.attr('tabindex', '-1');
//     }

//     if (isVideoInSlide($nextSlide)) {
//       var $video = $nextSlide.find('.' + classes.video);
//       var videoId = $video.attr('id');
//       var isBackground = $video.hasClass(classes.videoBackground);
//       if (isBackground) {
//         theme.SlideshowVideo.playVideo(videoId);
//       } else {
//         $video.attr('tabindex', '0');
//       }
//     }
//   }

//   function isVideoInSlide($slide) {
//     return $slide.find('.' + classes.video).length;
//   }

//   slideshow.prototype.togglePause = function() {
//     var slideshowSelector = getSlideshowId(this.$pause);
//     if (this.$pause.hasClass(classes.isPaused)) {
//       this.$pause.removeClass(classes.isPaused);
//       $(slideshowSelector).slick('slickPlay');
//     } else {
//       this.$pause.addClass(classes.isPaused);
//       $(slideshowSelector).slick('slickPause');
//     }
//   };

//   function getSlideshowId($el) {
//     return '#Slideshow-' + $el.data('id');
//   }

//   return slideshow;
// })();

window.theme = window.theme || {};

theme.Slideshow = (function () {
  this.$slideshow = null;
  var classes = {
    wrapper: 'slideshow-wrapper',
    slideshow: 'slideshow',
    currentSlide: 'slick-current',
    video: 'slideshow__video',
    videoBackground: 'slideshow__video--background',
    closeVideoBtn: 'slideshow__video-control--close',
    pauseButton: 'slideshow__pause',
    isPaused: 'is-paused'
  };
  // #TODO: Make these more global
  var config = {
    mediaQuerySmall: theme.settings.mediaQuery ? theme.settings.mediaQuery.small : 'screen and (max-width: 599px)',
    mediaQueryMedium: theme.settings.mediaQuery ? theme.settings.mediaQuery.medium : 'screen and (min-width: 600px) and (max-width: 899px)',
    mediaQueryLargeUp: theme.settings.mediaQuery ? theme.settings.mediaQuery.largeUp : 'screen and (min-width: 900px)'
  };
  var defaults = {
    accessibility: true,
    adaptiveHeight: false,
    arrows: false,
    asNavFor: null,
    autoplay: false,
    autoplaySpeed: 7000,
    centerMode: false,
    centerPadding: '40px',
    dots: false,
    draggable: true,
    fade: false,
    infinite: true,
    rows: 0,
    slidesPerRow: 1,
    slidesToScroll: 1,
    slidesToShow: 1,
    swipeToSlide: true,
    touchThreshold: 20,
  };

  function Slider(el) {
    this.$slideshow = $(el);

    if (!this.$slideshow.length) {
      return;
    }

    this.$wrapper = this.$slideshow.closest('.' + classes.wrapper) || this.parent();
    this.$pause = this.$wrapper.find('.' + classes.pauseButton);
    this.sliderActive = false;
    var elementOptions = this.$slideshow.data();

    defaults.prevArrow = '#' + this.$slideshow.attr('id') + ' ~ .slideshow__prev';
    defaults.nextArrow = '#' + this.$slideshow.attr('id') + ' ~ .slideshow__next';

    this.settings = {};
    this.settings.all = {
      adaptiveHeight: elementOptions.adaptiveHeight,
      arrows: elementOptions.arrows,
      asNavFor: elementOptions.asNavFor,
      autoplay: elementOptions.autoplay,
      autoplaySpeed: elementOptions.speed,
      centerMode: elementOptions.centerMode,
      centerPadding: elementOptions.centerPadding,
      dots: elementOptions.dots,
      draggable: elementOptions.draggable,
      fade: elementOptions.fade,
      focusOnSelect: elementOptions.focusOnSelect,
      infinite: elementOptions.infinite,
      nextArrow: elementOptions.nextArrow,
      prevArrow: elementOptions.prevArrow,
      rows: elementOptions.rows,
      slidesPerRow: elementOptions.perRow,
      slidesToScroll: elementOptions.slidesScroll,
      slidesToShow: elementOptions.slidesShow,
      waitForAnimate: elementOptions.waitForAnimate,
    };
    this.settings.desktop = {
      adaptiveHeight: elementOptions.adaptiveHeightDesktop,
      arrows: elementOptions.arrowsDesktop,
      autoplay: elementOptions.autoplayDesktop,
      autoplaySpeed: elementOptions.speedDesktop,
      centerMode: elementOptions.centerModeDesktop,
      centerPadding: elementOptions.centerPaddingDesktop,
      dots: elementOptions.dotsDesktop,
      focusOnSelect: elementOptions.focusOnSelectDesktop,
      infinite: elementOptions.infiniteDesktop,
      rows: elementOptions.rowsDesktop,
      slidesPerRow: elementOptions.perRowDesktop,
      slidesToScroll: elementOptions.slidesScrollDesktop,
      slidesToShow: elementOptions.slidesShowDesktop,
    };
    this.settings.tablet = {
      adaptiveHeight: elementOptions.adaptiveHeightTablet,
      arrows: elementOptions.arrowsTablet,
      autoplay: elementOptions.autoplayTablet,
      autoplaySpeed: elementOptions.speedTablet,
      centerMode: elementOptions.centerModeTablet,
      centerPadding: elementOptions.centerPaddingTablet,
      dots: elementOptions.dotsTablet,
      focusOnSelect: elementOptions.focusOnSelectTablet,
      infinite: elementOptions.infiniteTablet,
      rows: elementOptions.rowsTablet,
      slidesPerRow: elementOptions.perRowTablet,
      slidesToScroll: elementOptions.slidesScrollTablet,
      slidesToShow: elementOptions.slidesShowTablet,
    };
    this.settings.mobile = {
      adaptiveHeight: elementOptions.adaptiveHeightMobile,
      arrows: elementOptions.arrowsMobile,
      autoplay: elementOptions.autoplayMobile,
      autoplaySpeed: elementOptions.speedMobile,
      centerMode: elementOptions.centerModeMobile,
      centerPadding: elementOptions.centerPaddingMobile,
      dots: elementOptions.dotsMobile,
      focusOnSelect: elementOptions.focusOnSelectMobile,
      infinite: elementOptions.infiniteMobile,
      rows: elementOptions.rowsMobile,
      slidesPerRow: elementOptions.perRowMobile,
      slidesToScroll: elementOptions.slidesScrollMobile,
      slidesToShow: elementOptions.slidesShowMobile,
    };

    _.defaults(this.settings.desktop, this.settings.all);
    _.defaults(this.settings.desktop, defaults);

    _.defaults(this.settings.tablet, this.settings.all);
    _.defaults(this.settings.tablet, defaults);

    _.defaults(this.settings.mobile, this.settings.all);
    _.defaults(this.settings.mobile, defaults);

    this.$slideshow.on('beforeChange', beforeChange.bind(this));
    this.$slideshow.on('init', slideshowA11y.bind(this));
    // this.$slideshow.slick(this.settings);

    var self = this;

    enquire.register(config.mediaQuerySmall, {
      match: function () {
        if (!elementOptions.disableMobile) {
          initSlider(self.$slideshow, self.settings.mobile);
        } else {
          destroySlider(self.$slideshow);
        }
      }
    });

    enquire.register(config.mediaQueryMedium, {
      match: function () {
        if (!elementOptions.disableTablet) {
          initSlider(self.$slideshow, self.settings.tablet);
        } else {
          destroySlider(self.$slideshow);
        }
      }
    });

    enquire.register(config.mediaQueryLargeUp, {
      match: function () {
        if (!elementOptions.disableDesktop) {
          initSlider(self.$slideshow, self.settings.desktop);
        } else {
          destroySlider(self.$slideshow);
        }
      }
    });

    function initSlider(sliderObj, args) {
      if (self.sliderActive) {
        sliderObj.slick('unslick');
        self.sliderActive = false;
      }

      sliderObj.on('beforeChange.slideshow', function (event, slick, currentSlide, nextSlide) {
        slick.$slider.addClass('slick-transitioning');
      });

      sliderObj.on('afterChange.slideshow', function (event, slick, currentSlide, nextSlide) {
        slick.$slider.removeClass('slick-transitioning');
      });

      sliderObj.slick(args);
      self.sliderActive = true;
    }

    function destroySlider(sliderObj) {
      if (self.sliderActive) {
        sliderObj.off('.slideshow');
        sliderObj.slick('unslick');
        self.sliderActive = false;
      }
    }

    this.$pause.on('click', this.togglePause.bind(this));
  }

  function slideshowA11y(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    var $wrapper = this.$wrapper;
    var autoplay = this.settings.autoplay;

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');


    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    $wrapper.on('focusin', function (evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.attr('aria-live', 'polite');

      if (autoplay) {
        $slider.slick('slickPause');
      }
    });

    // Resume autoplay
    $wrapper.on('focusout', function (evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.removeAttr('aria-live');

      if (autoplay) {
        // Manual check if the focused element was the video close button
        // to ensure autoplay does not resume when focus goes inside YouTube iframe
        if ($(evt.target).hasClass(classes.closeVideoBtn)) {
          return;
        }

        $slider.slick('slickPlay');
      }
    });

    // Add arrow key support when focused
    if (obj.$dots) {
      obj.$dots.on('keydown', function (evt) {
        if (evt.which === 37) {
          $slider.slick('slickPrev');
        }

        if (evt.which === 39) {
          $slider.slick('slickNext');
        }

        // Update focus on newly selected tab
        if ((evt.which === 37) || (evt.which === 39)) {
          obj.$dots.find('.slick-active button').focus();
        }
      });
    }
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $slider = slick.$slider;
    var $currentSlide = $slider.find('.' + classes.currentSlide);
    var $nextSlide = $slider.find('.slideshow__slide[data-slick-index="' + nextSlide + '"]');

    if (isVideoInSlide($currentSlide)) {
      var $currentVideo = $currentSlide.find('.' + classes.video);
      var currentVideoId = $currentVideo.attr('id');
      theme.SlideshowVideo.pauseVideo(currentVideoId);
      $currentVideo.attr('tabindex', '-1');
    }

    if (isVideoInSlide($nextSlide)) {
      var $video = $nextSlide.find('.' + classes.video);
      var videoId = $video.attr('id');
      var isBackground = $video.hasClass(classes.videoBackground);
      if (isBackground) {
        theme.SlideshowVideo.playVideo(videoId);
      } else {
        $video.attr('tabindex', '0');
      }
    }
  }

  function isVideoInSlide($slide) {
    return $slide.find('.' + classes.video).length;
  }

  Slider.prototype.togglePause = function () {
    var slideshowSelector = getSlideshowId(this.$pause);
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused);
      $(slideshowSelector).slick('slickPlay');
    } else {
      this.$pause.addClass(classes.isPaused);
      $(slideshowSelector).slick('slickPause');
    }
  };

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id');
  }

  return Slider;
})();

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.SlideshowVideo.loadVideos();
}

theme.SlideshowVideo = (function () {
  var autoplayCheckComplete = false;
  var autoplayAvailable = false;
  var playOnClickChecked = false;
  var playOnClick = false;
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    playerVars: {
      // eslint-disable-next-line camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      showinfo: 0,
      wmode: 'opaque',
      branding: 0,
      autohide: 0,
      rel: 0
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange
    }
  };
  var classes = {
    playing: 'video-is-playing',
    paused: 'video-is-paused',
    loading: 'video-is-loading',
    loaded: 'video-is-loaded',
    slideshowWrapper: 'slideshow-wrapper',
    slide: 'slideshow__slide',
    slideBackgroundVideo: 'slideshow__slide--background-video',
    slideDots: 'slick-dots',
    videoChrome: 'slideshow__video--chrome',
    videoBackground: 'slideshow__video--background',
    playVideoBtn: 'slideshow__video-control--play',
    closeVideoBtn: 'slideshow__video-control--close',
    currentSlide: 'slick-current',
    slickClone: 'slick-cloned',
    supportsAutoplay: 'autoplay',
    supportsNoAutoplay: 'no-autoplay'
  };

  /**
    * Public functions
   */
  function init($video) {
    if (!$video.length) {
      return;
    }

    videos[$video.attr('id')] = {
      id: $video.attr('id'),
      videoId: $video.data('id'),
      type: $video.data('type'),
      status: $video.data('type') === 'chrome' ? 'closed' : 'background', // closed, open, background
      videoSelector: $video.attr('id'),
      $parentSlide: $video.closest('.' + classes.slide),
      $parentSlideshowWrapper: $video.closest('.' + classes.slideshowWrapper),
      controls: $video.data('type') === 'background' ? 0 : 1,
      slideshow: $video.data('slideshow')
    };

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  function customPlayVideo(playerId) {
    // Do not autoplay just because the slideshow asked you to.
    // If the slideshow asks to play a video, make sure
    // we have done the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return;
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
      privatePlayVideo(playerId);
    }
  }

  function pauseVideo(playerId) {
    if (videoPlayers[playerId] && typeof videoPlayers[playerId].pauseVideo === 'function') {
      videoPlayers[playerId].pauseVideo();
    }
  }

  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var args = $.extend({}, videoOptions, videos[key]);
        args.playerVars.controls = args.controls;
        videoPlayers[key] = new YT.Player(key, args);
      }
    }

    initEvents();
    youtubeLoaded = true;
  }

  function loadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    var args = $.extend({}, videoOptions, videos[key]);
    args.playerVars.controls = args.controls;
    videoPlayers[key] = new YT.Player(key, args);

    initEvents();
  }

  /**
    * Private functions
   */

  function privatePlayVideo(id, clicked) {
    var videoData = videos[id];
    var player = videoPlayers[id];
    var $slide = videos[id].$parentSlide;

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData);
    } else if (clicked || (autoplayCheckComplete && autoplayAvailable)) {
      // Play if autoplay is available or clicked to play
      $slide.removeClass(classes.loading);
      setAsPlaying(videoData);
      player.playVideo();
      return;
    }

    // Check for autoplay if not already done
    if (!autoplayCheckComplete) {
      autoplayCheckFunction(player, $slide);
    }
  }

  function setAutoplaySupport(supported) {
    var supportClass = supported ? classes.supportsAutoplay : classes.supportsNoAutoplay;
    $(document.documentElement).addClass(supportClass);

    if (!supported) {
      playOnClick = true;
    }

    autoplayCheckComplete = true;
  }

  function autoplayCheckFunction(player, $slide) {
    // attempt to play video
    player.playVideo();

    autoplayTest(player)
      .then(function () {
        setAutoplaySupport(true);
      })
      .fail(function () {
        // No autoplay available (or took too long to start playing).
        // Show fallback image. Stop video for safety.
        setAutoplaySupport(false);
        player.stopVideo();
      })
      .always(function () {
        autoplayCheckComplete = true;
        $slide.removeClass(classes.loading);
      });
  }

  function autoplayTest(player) {
    var deferred = $.Deferred();
    var wait;
    var timeout;

    wait = setInterval(function () {
      if (player.getCurrentTime() <= 0) {
        return;
      }

      autoplayAvailable = true;
      clearInterval(wait);
      clearTimeout(timeout);
      deferred.resolve();
    }, 500);

    timeout = setTimeout(function () {
      clearInterval(wait);
      deferred.reject();
    }, 4000); // subjective. test up to 8 times over 4 seconds

    return deferred;
  }

  function playOnClickCheck() {
    // Bail early for a few instances:
    // - small screen
    // - device sniff mobile browser

    if (playOnClickChecked) {
      return;
    }

    if ($(window).width() < 750) {
      playOnClick = true;
    } else if (isMobile.any) {
      playOnClick = true;
    }

    if (playOnClick) {
      // No need to also do the autoplay check
      setAutoplaySupport(false);
    }

    playOnClickChecked = true;
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality('hd1080');
    var videoData = getVideoOptions(evt);

    playOnClickCheck();

    // Prevent tabbing through YouTube player controls until visible
    $('#' + videoData.id).attr('tabindex', '-1');

    sizeBackgroundVideos();

    // Customize based on options from the video ID
    switch (videoData.type) {
      case 'background-chrome':
      case 'background':
        evt.target.mute();
        // Only play the video if it is in the active slide
        if (videoData.$parentSlide.hasClass(classes.currentSlide)) {
          privatePlayVideo(videoData.id);
        }
        break;
    }

    videoData.$parentSlide.addClass(classes.loaded);
  }

  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);

    switch (evt.data) {
      case 0: // ended
        setAsFinished(videoData);
        break;
      case 1: // playing
        setAsPlaying(videoData);
        break;
      case 2: // paused
        setAsPaused(videoData);
        break;
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case 'background':
        videoPlayers[videoData.id].seekTo(0);
        break;
      case 'background-chrome':
        videoPlayers[videoData.id].seekTo(0);
        closeVideo(videoData.id);
        break;
      case 'chrome':
        closeVideo(videoData.id);
        break;
    }
  }

  function setAsPlaying(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    $slide.removeClass(classes.loading);

    // Do not change element visibility if it is a background video
    if (videoData.status === 'background') {
      return;
    }

    $('#' + videoData.id).attr('tabindex', '0');

    switch (videoData.type) {
      case 'chrome':
      case 'background-chrome':
        $slideshow
          .removeClass(classes.paused)
          .addClass(classes.playing);
        $slide
          .removeClass(classes.paused)
          .addClass(classes.playing);
        break;
    }

    // Update focus to the close button so we stay within the slide
    $slide.find('.' + classes.closeVideoBtn).focus();
  }

  function setAsPaused(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    if (videoData.type === 'background-chrome') {
      closeVideo(videoData.id);
      return;
    }

    // YT's events fire after our click event. This status flag ensures
    // we don't interact with a closed or background video.
    if (videoData.status !== 'closed' && videoData.type !== 'background') {
      $slideshow.addClass(classes.paused);
      $slide.addClass(classes.paused);
    }

    if (videoData.type === 'chrome' && videoData.status === 'closed') {
      $slideshow.removeClass(classes.paused);
      $slide.removeClass(classes.paused);
    }

    $slideshow.removeClass(classes.playing);
    $slide.removeClass(classes.playing);
  }

  function closeVideo(playerId) {
    var videoData = videos[playerId];
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;
    var classesToRemove = [classes.pause, classes.playing].join(' ');

    $('#' + videoData.id).attr('tabindex', '-1');

    videoData.status = 'closed';

    switch (videoData.type) {
      case 'background-chrome':
        videoPlayers[playerId].mute();
        setBackgroundVideo(playerId);
        break;
      case 'chrome':
        videoPlayers[playerId].stopVideo();
        setAsPaused(videoData); // in case the video is already paused
        break;
    }

    $slideshow.removeClass(classesToRemove);
    $slide.removeClass(classesToRemove);
  }

  function getVideoOptions(evt) {
    return videos[evt.target.h.id];
  }

  function startVideoOnClick(playerId) {
    var videoData = videos[playerId];
    // add loading class to slide
    videoData.$parentSlide.addClass(classes.loading);

    videoData.status = 'open';

    switch (videoData.type) {
      case 'background-chrome':
        unsetBackgroundVideo(playerId, videoData);
        videoPlayers[playerId].unMute();
        privatePlayVideo(playerId, true);
        break;
      case 'chrome':
        privatePlayVideo(playerId, true);
        break;
    }

    // esc to close video player
    $(document).on('keydown.videoPlayer', function (evt) {
      if (evt.keyCode === 27) {
        closeVideo(playerId);
      }
    });
  }

  function sizeBackgroundVideos() {
    $('.' + classes.videoBackground).each(function (index, el) {
      sizeBackgroundVideo($(el));
    });
  }

  function sizeBackgroundVideo($player) {
    var $slide = $player.closest('.' + classes.slide);
    // Ignore cloned slides
    if ($slide.hasClass(classes.slickClone)) {
      return;
    }
    var slideWidth = $slide.width();
    var playerWidth = $player.width();
    var playerHeight = $player.height();

    // when screen aspect ratio differs from video, video must center and underlay one dimension
    if (slideWidth / videoOptions.ratio < playerHeight) {
      playerWidth = Math.ceil(playerHeight * videoOptions.ratio); // get new player width
      $player.width(playerWidth).height(playerHeight).css({
        left: (slideWidth - playerWidth) / 2,
        top: 0
      }); // player width is greater, offset left; reset top
    } else { // new video width < window width (gap to right)
      playerHeight = Math.ceil(slideWidth / videoOptions.ratio); // get new player height
      $player.width(slideWidth).height(playerHeight).css({
        left: 0,
        top: (playerHeight - playerHeight) / 2
      }); // player height is greater, offset top; reset left
    }

    $player
      .prepareTransition()
      .addClass(classes.loaded);
  }

  function unsetBackgroundVideo(playerId) {
    // Switch the background-chrome to a chrome-only player once played
    $('#' + playerId)
      .removeAttr('style')
      .removeClass(classes.videoBackground)
      .addClass(classes.videoChrome);

    videos[playerId].$parentSlideshowWrapper
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].$parentSlide
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].status = 'open';
  }

  function setBackgroundVideo(playerId) {
    // Switch back to background-chrome when closed
    var $player = $('#' + playerId)
      .addClass(classes.videoBackground)
      .removeClass(classes.videoChrome);

    videos[playerId].$parentSlide
      .addClass(classes.slideBackgroundVideo);

    videos[playerId].status = 'background';
    sizeBackgroundVideo($player);
  }

  function initEvents() {
    $(document).on('click.videoPlayer', '.' + classes.playVideoBtn, function (evt) {
      var playerId = $(evt.currentTarget).data('controls');
      startVideoOnClick(playerId);
    });

    $(document).on('click.videoPlayer', '.' + classes.closeVideoBtn, function (evt) {
      var playerId = $(evt.currentTarget).data('controls');
      closeVideo(playerId);
    });

    // Listen to resize to keep a background-size:cover-like layout
    $(window).on('resize.videoPlayer', _.debounce(function () {
      if (youtubeLoaded) {
        sizeBackgroundVideos();
      }
    }, 250));
  }

  function removeEvents() {
    $(document).off('.videoPlayer');
    $(window).off('.videoPlayer');
  }

  return {
    init: init,
    loadVideos: loadVideos,
    loadVideo: loadVideo,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents
  };
})();


// Youtube API callback
// eslint-disable-next-line no-unused-vars
// function onYouTubeIframeAPIReady() {
//   theme.SlideshowVideo.loadVideos();
// }

theme.SlideshowVideo = (function () {
  var autoplayCheckComplete = false;
  var autoplayAvailable = false;
  var playOnClickChecked = false;
  var playOnClick = false;
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    playerVars: {
      // eslint-disable-next-line camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      showinfo: 0,
      wmode: 'opaque',
      branding: 0,
      autohide: 0,
      rel: 0
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange
    }
  };
  var classes = {
    playing: 'video-is-playing',
    paused: 'video-is-paused',
    loading: 'video-is-loading',
    loaded: 'video-is-loaded',
    slideshowWrapper: 'slideshow-wrapper',
    slide: 'slideshow__slide',
    slideBackgroundVideo: 'slideshow__slide--background-video',
    slideDots: 'slick-dots',
    videoChrome: 'slideshow__video--chrome',
    videoBackground: 'slideshow__video--background',
    playVideoBtn: 'slideshow__video-control--play',
    closeVideoBtn: 'slideshow__video-control--close',
    currentSlide: 'slick-current',
    slickClone: 'slick-cloned',
    supportsAutoplay: 'autoplay',
    supportsNoAutoplay: 'no-autoplay'
  };

  /**
    * Public functions
   */
  function init($video) {
    if (!$video.length) {
      return;
    }

    videos[$video.attr('id')] = {
      id: $video.attr('id'),
      videoId: $video.data('id'),
      type: $video.data('type'),
      status: $video.data('type') === 'chrome' ? 'closed' : 'background', // closed, open, background
      videoSelector: $video.attr('id'),
      $parentSlide: $video.closest('.' + classes.slide),
      $parentSlideshowWrapper: $video.closest('.' + classes.slideshowWrapper),
      controls: $video.data('type') === 'background' ? 0 : 1,
      slideshow: $video.data('slideshow')
    };

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  function customPlayVideo(playerId) {
    // Do not autoplay just because the slideshow asked you to.
    // If the slideshow asks to play a video, make sure
    // we have done the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return;
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
      privatePlayVideo(playerId);
    }
  }

  function pauseVideo(playerId) {
    if (videoPlayers[playerId] && typeof videoPlayers[playerId].pauseVideo === 'function') {
      videoPlayers[playerId].pauseVideo();
    }
  }

  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var args = $.extend({}, videoOptions, videos[key]);
        args.playerVars.controls = args.controls;
        videoPlayers[key] = new YT.Player(key, args);
      }
    }

    initEvents();
    youtubeLoaded = true;
  }

  function loadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    var args = $.extend({}, videoOptions, videos[key]);
    args.playerVars.controls = args.controls;
    videoPlayers[key] = new YT.Player(key, args);

    initEvents();
  }

  /**
    * Private functions
   */

  function privatePlayVideo(id, clicked) {
    var videoData = videos[id];
    var player = videoPlayers[id];
    var $slide = videos[id].$parentSlide;

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData);
    } else if (clicked || (autoplayCheckComplete && autoplayAvailable)) {
      // Play if autoplay is available or clicked to play
      $slide.removeClass(classes.loading);
      setAsPlaying(videoData);
      player.playVideo();
      return;
    }

    // Check for autoplay if not already done
    if (!autoplayCheckComplete) {
      autoplayCheckFunction(player, $slide);
    }
  }

  function setAutoplaySupport(supported) {
    var supportClass = supported ? classes.supportsAutoplay : classes.supportsNoAutoplay;
    $(document.documentElement).addClass(supportClass);

    if (!supported) {
      playOnClick = true;
    }

    autoplayCheckComplete = true;
  }

  function autoplayCheckFunction(player, $slide) {
    // attempt to play video
    player.playVideo();

    autoplayTest(player)
      .then(function () {
        setAutoplaySupport(true);
      })
      .fail(function () {
        // No autoplay available (or took too long to start playing).
        // Show fallback image. Stop video for safety.
        setAutoplaySupport(false);
        player.stopVideo();
      })
      .always(function () {
        autoplayCheckComplete = true;
        $slide.removeClass(classes.loading);
      });
  }

  function autoplayTest(player) {
    var deferred = $.Deferred();
    var wait;
    var timeout;

    wait = setInterval(function () {
      if (player.getCurrentTime() <= 0) {
        return;
      }

      autoplayAvailable = true;
      clearInterval(wait);
      clearTimeout(timeout);
      deferred.resolve();
    }, 500);

    timeout = setTimeout(function () {
      clearInterval(wait);
      deferred.reject();
    }, 4000); // subjective. test up to 8 times over 4 seconds

    return deferred;
  }

  function playOnClickCheck() {
    // Bail early for a few instances:
    // - small screen
    // - device sniff mobile browser

    if (playOnClickChecked) {
      return;
    }

    if ($(window).width() < 750) {
      playOnClick = true;
    } else if (window.mobileCheck()) {
      playOnClick = true;
    }

    if (playOnClick) {
      // No need to also do the autoplay check
      setAutoplaySupport(false);
    }

    playOnClickChecked = true;
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality('hd1080');
    var videoData = getVideoOptions(evt);

    playOnClickCheck();

    // Prevent tabbing through YouTube player controls until visible
    $('#' + videoData.id).attr('tabindex', '-1');

    sizeBackgroundVideos();

    // Customize based on options from the video ID
    switch (videoData.type) {
      case 'background-chrome':
      case 'background':
        evt.target.mute();
        // Only play the video if it is in the active slide
        if (videoData.$parentSlide.hasClass(classes.currentSlide)) {
          privatePlayVideo(videoData.id);
        }
        break;
    }

    videoData.$parentSlide.addClass(classes.loaded);
  }

  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);

    switch (evt.data) {
      case 0: // ended
        setAsFinished(videoData);
        break;
      case 1: // playing
        setAsPlaying(videoData);
        break;
      case 2: // paused
        setAsPaused(videoData);
        break;
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case 'background':
        videoPlayers[videoData.id].seekTo(0);
        break;
      case 'background-chrome':
        videoPlayers[videoData.id].seekTo(0);
        closeVideo(videoData.id);
        break;
      case 'chrome':
        closeVideo(videoData.id);
        break;
    }
  }

  function setAsPlaying(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    $slide.removeClass(classes.loading);

    // Do not change element visibility if it is a background video
    if (videoData.status === 'background') {
      return;
    }

    $('#' + videoData.id).attr('tabindex', '0');

    switch (videoData.type) {
      case 'chrome':
      case 'background-chrome':
        $slideshow
          .removeClass(classes.paused)
          .addClass(classes.playing);
        $slide
          .removeClass(classes.paused)
          .addClass(classes.playing);
        break;
    }

    // Update focus to the close button so we stay within the slide
    $slide.find('.' + classes.closeVideoBtn).focus();
  }

  function setAsPaused(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    if (videoData.type === 'background-chrome') {
      closeVideo(videoData.id);
      return;
    }

    // YT's events fire after our click event. This status flag ensures
    // we don't interact with a closed or background video.
    if (videoData.status !== 'closed' && videoData.type !== 'background') {
      $slideshow.addClass(classes.paused);
      $slide.addClass(classes.paused);
    }

    if (videoData.type === 'chrome' && videoData.status === 'closed') {
      $slideshow.removeClass(classes.paused);
      $slide.removeClass(classes.paused);
    }

    $slideshow.removeClass(classes.playing);
    $slide.removeClass(classes.playing);
  }

  function closeVideo(playerId) {
    var videoData = videos[playerId];
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;
    var classesToRemove = [classes.pause, classes.playing].join(' ');

    $('#' + videoData.id).attr('tabindex', '-1');

    videoData.status = 'closed';

    switch (videoData.type) {
      case 'background-chrome':
        videoPlayers[playerId].mute();
        setBackgroundVideo(playerId);
        break;
      case 'chrome':
        videoPlayers[playerId].stopVideo();
        setAsPaused(videoData); // in case the video is already paused
        break;
    }

    $slideshow.removeClass(classesToRemove);
    $slide.removeClass(classesToRemove);
  }

  function getVideoOptions(evt) {
    return videos[evt.target.h.id];
  }

  function startVideoOnClick(playerId) {
    var videoData = videos[playerId];
    // add loading class to slide
    videoData.$parentSlide.addClass(classes.loading);

    videoData.status = 'open';

    switch (videoData.type) {
      case 'background-chrome':
        unsetBackgroundVideo(playerId, videoData);
        videoPlayers[playerId].unMute();
        privatePlayVideo(playerId, true);
        break;
      case 'chrome':
        privatePlayVideo(playerId, true);
        break;
    }

    // esc to close video player
    $(document).on('keydown.videoPlayer', function (evt) {
      if (evt.keyCode === 27) {
        closeVideo(playerId);
      }
    });
  }

  function sizeBackgroundVideos() {
    $('.' + classes.videoBackground).each(function (index, el) {
      sizeBackgroundVideo($(el));
    });
  }

  function sizeBackgroundVideo($player) {
    var $slide = $player.closest('.' + classes.slide);
    // Ignore cloned slides
    if ($slide.hasClass(classes.slickClone)) {
      return;
    }
    var slideWidth = $slide.width();
    var playerWidth = $player.width();
    var playerHeight = $player.height();

    // when screen aspect ratio differs from video, video must center and underlay one dimension
    if (slideWidth / videoOptions.ratio < playerHeight) {
      playerWidth = Math.ceil(playerHeight * videoOptions.ratio); // get new player width
      $player.width(playerWidth).height(playerHeight).css({
        left: (slideWidth - playerWidth) / 2,
        top: 0
      }); // player width is greater, offset left; reset top
    } else { // new video width < window width (gap to right)
      playerHeight = Math.ceil(slideWidth / videoOptions.ratio); // get new player height
      $player.width(slideWidth).height(playerHeight).css({
        left: 0,
        top: (playerHeight - playerHeight) / 2
      }); // player height is greater, offset top; reset left
    }

    $player
      .prepareTransition()
      .addClass(classes.loaded);
  }

  function unsetBackgroundVideo(playerId) {
    // Switch the background-chrome to a chrome-only player once played
    $('#' + playerId)
      .removeAttr('style')
      .removeClass(classes.videoBackground)
      .addClass(classes.videoChrome);

    videos[playerId].$parentSlideshowWrapper
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].$parentSlide
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].status = 'open';
  }

  function setBackgroundVideo(playerId) {
    // Switch back to background-chrome when closed
    var $player = $('#' + playerId)
      .addClass(classes.videoBackground)
      .removeClass(classes.videoChrome);

    videos[playerId].$parentSlide
      .addClass(classes.slideBackgroundVideo);

    videos[playerId].status = 'background';
    sizeBackgroundVideo($player);
  }

  function initEvents() {
    $(document).on('click.videoPlayer', '.' + classes.playVideoBtn, function (evt) {
      var playerId = $(evt.currentTarget).data('controls');
      startVideoOnClick(playerId);
    });

    $(document).on('click.videoPlayer', '.' + classes.closeVideoBtn, function (evt) {
      var playerId = $(evt.currentTarget).data('controls');
      closeVideo(playerId);
    });

    // Listen to resize to keep a background-size:cover-like layout
    $(window).on('resize.videoPlayer', $.debounce(250, function () {
      if (youtubeLoaded) {
        sizeBackgroundVideos();
      }
    }));
  }

  function removeEvents() {
    $(document).off('.videoPlayer');
    $(window).off('.videoPlayer');
  }

  return {
    init: init,
    loadVideos: loadVideos,
    loadVideo: loadVideo,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents
  };
})();

(function () {
  var selectors = {
    backButton: '.return-link'
  };

  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one('click', function (evt) {
    evt.preventDefault();

    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);

    if (shopDomain === referrerDomain) {
      history.back();
    }

    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement('a');
    anchor.ref = url;

    return anchor.hostname;
  }
})();

/**
* Module to show Recently Viewed Products
*
* Copyright (c) 2014 Caroline Schnapp (11heavens.com)
* Dual licensed under the MIT and GPL licenses:
* http://www.opensource.org/licenses/mit-license.php
* http://www.gnu.org/licenses/gpl.html
*
*/

window.theme = window.theme || {};

theme.RecentlyViewed = (function () {

  var config = {
    howManyToShow: 4,
    howManyToStoreInMemory: 5,
    wrapperId: 'recently-viewed-products',
    templateId: 'recently-viewed-product-template',
    onComplete: null
  };

  var productHandleQueue = [];
  var wrapper = null;
  var template = null;
  var shown = 0;

  var cookie = {
    configuration: {
      expires: 90,
      path: '/',
      domain: window.location.hostname
    },
    name: 'shopify_recently_viewed',
    write: function (recentlyViewed) {
      jQuery.cookie(this.name, recentlyViewed.join(' '), this.configuration);
    },
    read: function () {
      var recentlyViewed = [];
      var cookieValue = jQuery.cookie(this.name);
      if (cookieValue !== null) {
        recentlyViewed = cookieValue.split(' ');
      }
      return recentlyViewed;
    },
    destroy: function () {
      jQuery.cookie(this.name, null, this.configuration);
    },
    remove: function (productHandle) {
      var recentlyViewed = this.read();
      var position = jQuery.inArray(productHandle, recentlyViewed);
      if (position !== -1) {
        recentlyViewed.splice(position, 1);
        this.write(recentlyViewed);
      }
    }
  };

  var finalize = function () {
    wrapper.show();
    // If we have a callback.
    if (config.onComplete) {
      try { config.onComplete() } catch (error) { }
    }
  };

  var moveAlong = function () {
    if (productHandleQueue.length && shown < config.howManyToShow) {
      jQuery.ajax({
        dataType: 'json',
        url: '/products/' + productHandleQueue[0] + '.js',
        cache: false,
        success: function (product) {
          template.tmpl(product).appendTo(wrapper);
          productHandleQueue.shift();
          shown++;
          moveAlong();
        },
        error: function () {
          cookie.remove(productHandleQueue[0]);
          productHandleQueue.shift();
          moveAlong();
        }
      });
    } else {
      finalize();
    }

  };

  return {

    resizeImage: function (src, size) {
      if (size == null) {
        return src;
      }

      if (size == 'master') {
        return src.replace(/http(s)?:/, "");
      }

      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);

      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];

        return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "")
      } else {
        return null;
      }
    },

    showRecentlyViewed: function (params) {

      var params = params || {};

      // Update defaults.
      jQuery.extend(config, params);

      // Read cookie.
      productHandleQueue = cookie.read();

      // Template and element where to insert.
      template = jQuery('#' + config.templateId);
      wrapper = jQuery('#' + config.wrapperId);

      // How many products to show.
      config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);

      // If we have any to show.
      if (config.howManyToShow && template.length && wrapper.length) {
        // Getting each product with an Ajax call and rendering it on the page.
        moveAlong();
      }

    },

    getConfig: function () {
      return config;
    },

    clearList: function () {
      cookie.destroy();
    },

    recordRecentlyViewed: function (params) {

      var params = params || {};

      // Update defaults.
      jQuery.extend(config, params);

      // Read cookie.
      var recentlyViewed = cookie.read();

      // If we are on a product page.
      if (window.location.pathname.indexOf('/products/') !== -1) {

        // What is the product handle on this page.
        var productHandle = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
        // In what position is that product in memory.
        var position = jQuery.inArray(productHandle, recentlyViewed);
        // If not in memory.
        if (position === -1) {
          // Add product at the start of the list.
          recentlyViewed.unshift(productHandle);
          // Only keep what we need.
          recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
        } else {
          // Remove the product and place it at start of list.
          recentlyViewed.splice(position, 1);
          recentlyViewed.unshift(productHandle);
        }

        // Update cookie.
        cookie.write(recentlyViewed);

      }

    }

  };

})();

(function () {
  var selectors = {
    backButton: '.back-to-top',
  };

  var classes = {
    visible: 'back-to-top--visible',
    fade: 'back-to-top--fade',
  };

  var config = {
    showAfter: 300,
    dimAfter: 1200,
    scrollDuration: 700,
  };

  $backButton = $(selectors.backButton);

  if (!$backButton.length) {
    return;
  }

  $(window).scroll(function () {
    ($(this).scrollTop() > config.showAfter) ? $backButton.addClass(classes.visible) : $backButton.removeClass(classes.visible + ' ' + classes.fade);
    if ($(this).scrollTop() > config.dimAfter) {
      $backButton.addClass(classes.fade);
    }
  });

  $backButton.on('click', function (evt) {
    evt.preventDefault();
    $('body,html').animate({ scrollTop: 0 }, config.scrollDuration);
  });
})();

/*============================================================================
  Favicon cart counter
==============================================================================*/
window.theme = window.theme || {};

theme.Favicon = (function () {

  if (window.Favico === undefined) {
    return;
  }

  var icon = new Favico({
    bgColor: '#ff0066', // #0cbdc9
    textColor: '#fff',
    fontFamily: 'sans-serif', // Arial, Verdana, Times New Roman, serif, sans-serif, ...
    fontStyle: 'bold', // normal, italic, oblique, bold, bolder, lighter, 100, 200, 300, 400, 500, 600, 700, 800, 900
    type: 'circle', // circle, rectangle
    position: 'down', // up, down, left, upleft
    animation: 'none', // slide, fade, pop, popFade, none
    elementId: false, // Image element ID if there is need to attach badge to regular image
    element: false, // DOM element where to change "href" attribute (useful in case of multiple link icon elements)
    dataUrl: false, // Method that will be called for each animation from with data URI parameter
  });

  if (theme.shop !== undefined && theme.shop.cart !== undefined && theme.shop.cart.item_count > 0) {
    set(theme.shop.cart.item_count);
  }

  function set(value) {
    icon.badge(value);
  }

  function reset() {
    icon.reset();
  }

  return {
    set: set,
    reset: reset
  };
})();

/*
 * Adapted from Currency tools by Caroline Schnapp
 *
 * Copyright (c) 2015 Caroline Schnapp (mllegeorgesand@gmail.com)
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/mit-license.php
 *
 */

window.theme = window.theme || {};

theme.CurrencySelectors = (function () {

  function init() {
    Currency.format = shop.currencyFormat;

    var shopCurrency = shop.currency;

    /* Sometimes merchants change their shop currency, let's tell our JavaScript file */
    Currency.moneyFormats[shopCurrency].money_with_currency_format = shop.moneyWithCurrencyFormat;
    Currency.moneyFormats[shopCurrency].money_format = shop.moneyFormat;

    /* Default currency */
    var defaultCurrency = shop.defaultCurrency;

    /* Cookie currency */
    var cookieCurrency = Currency.cookie.read();

    /* Fix for customer account pages */
    $('span.money span.money').each(function () {
      $(this).parents('span.money').removeClass('money');
    });

    /* Saving the current price */
    $('span.money').each(function () {
      $(this).attr('data-currency-' + shop.currency, $(this).html());
    });

    // If there's no cookie.
    if (cookieCurrency == null) {
      if (shopCurrency !== defaultCurrency) {
        Currency.convertAll(shopCurrency, defaultCurrency);
      }
      else {
        Currency.currentCurrency = defaultCurrency;
      }
    }
    // If the cookie value does not correspond to any value in the currency dropdown.
    else if ($('[name=currencies]').length && $('[name=currencies] option[value=' + cookieCurrency + ']').length === 0) {
      Currency.currentCurrency = shopCurrency;
      Currency.cookie.write(shopCurrency);
    }
    else if (cookieCurrency === shopCurrency) {
      Currency.currentCurrency = shopCurrency;
    }
    else {
      Currency.convertAll(shopCurrency, cookieCurrency);
    }

    $('[name=currencies]').val(Currency.currentCurrency).change(function () {
      var newCurrency = $(this).val();
      Currency.convertAll(Currency.currentCurrency, newCurrency);
      $('.selected-currency').text(Currency.currentCurrency);
    });

    var original_selectCallback = window.selectCallback;
    var selectCallback = function (variant, selector) {
      original_selectCallback(variant, selector);
      Currency.convertAll(shopCurrency, $('[name=currencies]').val());
      $('.selected-currency').text(Currency.currentCurrency);
    };

    $(document).on('cart.requestComplete', function (event, cart) {
      Currency.convertAll(shopCurrency, $('[name=currencies]').val());
      $('.selected-currency').text(Currency.currentCurrency);
    });

    $('.selected-currency').text(Currency.currentCurrency);
    $('.currency-picker__wrapper').removeClass('loading');
  }

  return {
    init: init,
  };
})();

window.theme = window.theme || {};

theme.QuickView = (function () {
  var cache = {
    products: {},
    currentView: false
  };

  let quickViewModal = {};

  var selectors = {
    quickViewTrigger: '.product-grid-item__quick-view',
    productGridItem: '.product-grid-item',
  };

  if (rivets.components['product-quick-view'] === undefined) {
    return;
  }

  rivets.components['product-quick-view'].initialize = function (el, attributes) {
    return new productQuickView(el, attributes);
  };

  $quickViewTriggers = $(selectors.quickViewTrigger);

  if ($quickViewTriggers.length) {
    $(document).on('click', selectors.quickViewTrigger, function (evt) {
      var productHandle = $(this).parents(selectors.productGridItem).data('product-handle');
      view(productHandle);
    });
  }

  function productQuickView(el, attributes) {
    theme.QuantitySelectors.init($('input[type="number"]', el));
    return attributes;
  }

  function view(productHandle) {
    quickViewModal = $.featherlight($('<div class="quick-view" data-product-handle="' + productHandle + '"></div>'), {
      namespace: 'od-modal',
      variant: 'od-modal--fade-up-in od-modal--loading product-quick-view',
      afterContent: function () {
        var element = this.$content.get(0);
        var $container = $(this.$instance);
        $container.find('.product-form').on('submit', function(e){
          e.preventDefault();
          e.stopPropagation();
        })
        // if (theme.current.products[productHandle]) {
        //   cache.currentView = bindProduct(element, productHandle);
        //   $container.removeClass('od-modal--loading');
        // } else {
          $.ajax({
            type: 'GET',
            url: '/products/' + productHandle + '?view=json',
            success: function(response) {
               theme.current.products[productHandle] = JSON.parse(response).product;
                 if (theme.current.products[productHandle].featured_image == null && theme.default.placeholderImage != null) {
                   theme.current.products[productHandle].featured_image = theme.default.placeholderImage;
                 }
                 var variantIds = [];
                 for (var key in theme.current.products[productHandle].variants) {
                   if (theme.current.products[productHandle].variants.hasOwnProperty(key)) {
                     variantIds.push(theme.current.products[productHandle].variants[key].id);
                   }
                 }
                 var adjustProductStock = function (data) {
                   var product = theme.current.products[productHandle];
                   product = theme.utils.addStockInformation(product, data);
                   theme.current.products[productHandle] = product;
                   // theme.Product.variants = new slate.Variants(options);

                   

                   cache.currentView = bindProduct(element, productHandle);
                   var options = {
                     $container: $(element),
                     enableHistoryState: false,
                     singleOptionSelector: '[data-single-option-selector]',
                     originalSelectorId: '[data-product-select]',
                     product: theme.current.products[productHandle]
                   };

                   new slate.Variants(options);

                   var inventoryString = '';
                   for (var key in data) {
                     if (data.hasOwnProperty(key) && key == theme.current.products[productHandle].variants[0].sku) {
                       inventoryString += key;
                       inventoryString += '##';
                       for (var store in data[key]) {
                         if (data[key].hasOwnProperty(store)) {
                           inventoryString += store;
                           inventoryString += ':';
                           inventoryString += data[key][store];
                           inventoryString += ',';
                         }
                       }
                       inventoryString += '__';
                     }
                   }
                   inventoryString = inventoryString == '' ? '[]' : inventoryString;
                   $('input[name="properties[_inventory]"]', element).attr('value', inventoryString);
                   $('input[name="properties[_inventoryJSON]"]', element).attr('value', JSON.stringify(data));
                   theme.shop.validateCart();
                   if (window._swat) {
                     $('.quick-view .swym-button-bar .btn', element).addClass('product_' + product.id);
                     window._swat.initializeActionButtons('.quick-view');
                   } else {
                     $('.swym-button-bar', element).hide();
                   }
                   $container.removeClass('od-modal--loading');
                   $('.product-form__cart-submit').removeClass('loading');
                 };
               $('.product-form__cart-submit').addClass('loading');
               var variantStock = theme.utils.getProductInventory(_.uniq(variantIds).join(','), adjustProductStock);
            }
       });
        // }
      },
      afterClose: function () {

        cache.currentView.unbind();
      }
    });
  }

  function bindProduct($el, productHandle) {
    return rivets.init('product-quick-view', $el, { product: theme.current.products[productHandle], methods: {
      openStorePicker: function(){
        quickViewModal.close();
        theme.StoreLocator.open();
      },
      updateSelectedVariant: function(event,binding){
       
      }
    } });
  }

  return {
    view: view,
    cache: cache,
  };
})();

window.theme = window.theme || {};

theme.ProductBadges = (function () {

  var selectors = {
    productBadge: '[data-product-badge]',
  };

  function ProductBadges() {

    var productBadgesData = window.theme.settings.product_badges;
    if (!productBadgesData) {
      return;
    }

    var productGridItemBadges = document.querySelectorAll(selectors.productBadge);

    for (var i = 0; i < productGridItemBadges.length; i++) {

      var productBadgePlaceholder = productGridItemBadges[i];
      var tag = productGridItemBadges[i].dataset.productBadge;

      var badge = _.find(productBadgesData, { tag: tag });

      if (badge && badge.html) {
        var productBadge = document.createElement('span');
        productBadge.innerHTML = badge.html;

        productBadgePlaceholder.append(productBadge);
      }

    }
  }

  return ProductBadges;
})();

// .quick-view {
//   min-height: 1.75em;
//   min-width: 10em;
//   position: relative;
// }

window.theme = window.theme || {};

theme.StoreLocator = (function () {
  var selectors = {
    storeLocationData: '[data-store-locator-json]',
    storeLocatorTriggerLinks: 'a[href="#store-locator"], a[href="#storelocator"]',
  };
  var cache = {
    lightboxCreated: false,
  };

  if (!theme.shop || !$(selectors.storeLocationData).length) {
    return;
  }

  var storeLocations = JSON.parse($(selectors.storeLocationData).html());
  $.extend(theme.shop.locations, storeLocations);
  theme.shop.locations['count'] = Object.keys(storeLocations).length;

  if (!theme.shop.locations && google !== undefined && google.maps !== undefined) {
    return;
  }

  theme.shop.locationsByGroup = {};
  _.each(storeLocations, function (location, key) {
    theme.shop.locationsByGroup[location.group] = theme.shop.locationsByGroup[location.group] || {};
    theme.shop.locationsByGroup[location.group][key] = location;
  });

  if (Cookies !== undefined) {
    theme.shop.locations.favourite = Cookies.get('storeLocation') || false;
  }

  rivets.formatters.replace = function (a,b,c) {
    return a.replace(b,c);
  }

  rivets.formatters.storeTitle = function (storeCode) {
    var storeTitle;
    if (storeCode !== undefined && storeCode) {
      storeCode = storeCode.replace(' ', '_');
    }
    if (theme.shop.locations !== undefined && theme.shop.locations[storeCode] !== undefined) {
      storeTitle = theme.shop.locations[storeCode].title;
    } else {
      storeTitle = '';
    }

    return storeTitle;
  };

  $(selectors.storeLocatorTriggerLinks).on('click', function (evt) {
    evt.preventDefault();
    theme.StoreLocator.open();
  });

  rivets.formatters.clickCollectStoreEnabled = function (storeCode) {
    if (storeCode !== undefined && storeCode) {
      storeCode = storeCode.replace(' ', '_');
   

      if (theme.shop.locations !== undefined && theme.shop.locations[storeCode] !== undefined && theme.current.variant.inventory_details && theme.current.variant.inventory_details[storeCode] !== undefined && theme.current.variant.inventory_details[storeCode] > 0) {
        return true;
      }
    }
    $(`li[data-location='${storeCode}']`).addClass('hide-li');
    return false;
  };

  rivets.formatters.telLink = function (phone) {
    return '<a href="tel:' + phone.split(' ').join('').replace('(', '').replace(')', '') + '">' + phone + '</a>';
  };

  rivets.formatters.get = function (t, e) {
    return t[e];
  };

  rivets.formatters.log = function (a) {
    console.log(a);
    return a;
  };

  $(selectors.storeLocatorTriggerLinks).on('click', function (evt) {
    evt.preventDefault();
    // $('html').addClass('no-scroll');
    theme.StoreLocator.open();
  });

  function open() {
    if (cache.lightboxCreated) {
      cache.lightbox.open();
    } else {
      cache.lightbox = $.featherlight($('[data-store-locator-content]'), {
        namespace: 'od-modal',
        variant: 'od-modal--store-locator',
        persist: true,
        afterContent: function () {
          if (!cache.lightboxCreated) {
            var $container = $('.row', this.$content);
            $container.css('height', this.$content.innerHeight());

            var map = initStoreLocator(this.$content, 10, true);

            cache.lightboxCreated = true;
          }
        },
        beforeOpen: function () {
          $(document.documentElement).addClass('with-featherlight');
        },
        afterClose: function () {
          $(document.documentElement).removeClass('with-featherlight');
          if (!theme.shop.locations.favourite) {
            theme.shop.clickAndCollect.selected = "";
            $('#shippingMethod-delivery').trigger('change');
          }
        }
      });
    }
  }

  /**
   * Initialises the store locator inside given container
   */
  function initStoreLocator($container, visibleStoreLimit, sortByDistance, dataObject, geolocationEnabled, autocompleteOptions) {
    cache.map = new google.maps.Map($('#store-locator-map-canvas', $container).get(0), {
      center: new google.maps.LatLng(-28, 135),
      zoom: 4,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: [{ "featureType": "administrative", "elementType": "labels.text.fill", "stylers": [{ "color": "#004343" }] }, { "featureType": "landscape.man_made", "elementType": "geometry.fill", "stylers": [{ "color": "#dae3e3" }] }, { "featureType": "landscape.natural", "elementType": "geometry.fill", "stylers": [{ "visibility": "on" }, { "color": "#e3eded" }] }, { "featureType": "poi", "elementType": "geometry.fill", "stylers": [{ "visibility": "on" }, { "color": "#d1e4e4" }] }, { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [{ "color": "#004343" }] }, { "featureType": "road", "elementType": "geometry", "stylers": [{ "lightness": 100 }, { "visibility": "simplified" }] }, { "featureType": "road", "elementType": "labels", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit", "elementType": "geometry.fill", "stylers": [{ "color": "#dee1e1" }] }, { "featureType": "transit.line", "elementType": "geometry", "stylers": [{ "visibility": "on" }, { "lightness": 700 }] }, { "featureType": "water", "elementType": "all", "stylers": [{ "color": "#bfe0e0" }] }]
    });

    var storeData = theme.shop.locations;
    if (dataObject && dataObject != undefined) {
      storeData = dataObject;
    }

    var data = new StoreLocatorDataSource(storeData);

    var view = new storeLocator.View(cache.map, data, {
      geolocation: false,
      features: data.getFeatures(),
      markerIcon: theme.default.mapMarkerIcon,
    });

    google.maps.event.addListener(view, 'selectedStore_changed', function (evt) {
      if (evt != null && evt.id_ !== undefined) {
        // check if you are on the store locator page 
        if ($(window).width() < 767 && $container.is('#MainContent .store-locator')) {
          window.location.href = theme.shop.locations[evt.id_].url;
        } else {
          $(`.store-list li.store.highlighted`).removeClass('highlighted');
          $(`.store-list li.store#store-${evt.id_}`).addClass('highlighted');
          $container.addClass('store-locator--actions-enabled').attr('data-selected-store', evt.id_);
          $('[data-store-locator-content]').addClass('store-locator--actions-enabled').attr('data-selected-store', evt.id_);
          $container.find('#store-locator-actions a').attr('href', theme.shop.locations[evt.id_].url);
          $container.find('#store-locator-actions-popup a').attr('href', theme.shop.locations[evt.id_].url);
        }
      }
    });

    if (autocompleteOptions === undefined) {
      autocompleteOptions = {
        types: ['(regions)'],
        componentRestrictions: {
          country: 'au'
        }
      };
    }

    cache.storeLocator = new storeLocator.Panel($('#store-locator-panel', $container).get(0), {
      view: view,
      maxPanelListings: visibleStoreLimit,
      autocomplete: autocompleteOptions
    });

    if (geolocationEnabled === undefined) {
      geolocationEnabled = true;
    }

    if (geolocationEnabled && "geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        cache.map.setCenter({ lat: position.coords.latitude, lng: position.coords.longitude });
        cache.map.setZoom(12);
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({
          'latLng': { lat: position.coords.latitude, lng: position.coords.longitude }
        }, function (results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            if (results[0]) {
              var city = $.grep(results[0].address_components, function (x) {
                return $.inArray('locality', x.types) != -1;
              })[0].short_name;

              var state = $.grep(results[0].address_components, function (x) {
                return $.inArray('administrative_area_level_1', x.types) != -1;
              })[0].short_name;

              $('.location-search input', $container).val(city + ', ' + state);
            }
          }
        });
      });
    }

    var $list = $('#store-locator-list', $container),
      locationDetails = [],
      groupSortExceptions = { "Victoria": 1 };

    if ($list.length) {
      for (var key in theme.shop.locations) {
        if (theme.shop.locations.hasOwnProperty(key)) {
          if (theme.shop.locations[key].title !== undefined) {
            locationDetails.push({
              group: theme.shop.locations[key].group,
              title: theme.shop.locations[key].title,
              content: '<li class=""><a href="#" data-location="' + key + '" data-url="' + theme.shop.locations[key].url + '">' + theme.shop.locations[key].title + '</a></li>',
            });
          }
        }
      }

      locationDetails.sort(function (a, b) { return a.title - b.title; });
      locationDetails.sort(function (a, b) {
        if (groupSortExceptions[a.group] && groupSortExceptions[b.group]) {
          return groupSortExceptions[a.group] - groupSortExceptions[b.group];
        } else if (groupSortExceptions[a.group]) {
          return -1;
        } else if (groupSortExceptions[b.group]) {
          return 1;
        } else {
          return a.group.localeCompare(b.group);
        }
      });

      var appendString = '', currentGroup, prevGroup = false;
      for (var i = 0; i < locationDetails.length; i++) {
        currentGroup = locationDetails[i].group;
        if (currentGroup != prevGroup) {
          if (prevGroup !== false) appendString += '</ul>';
          appendString += '<h4 data-toggle-self data-toggle=".store-group-' + theme.utils.handleize(currentGroup) + '"';
          if (i == 0) appendString += ' class="active"';
          appendString += '>' + currentGroup + '</h4><ul class="';
          if (prevGroup === false) appendString += 'active ';
          appendString += 'store-group-' + theme.utils.handleize(currentGroup) + '">';
        }
        appendString += locationDetails[i].content;
        if (i == locationDetails.length - 1) {
          appendString += '</ul>';
        }
        prevGroup = currentGroup;
      }

      $list.append(appendString);
    }

    $('.store-locator__set-default', $container).on('click', function () {
      var selectedStore = $container.attr('data-selected-store');
      Cookies.set('storeLocation', selectedStore);
      theme.shop.locations.favourite = selectedStore;

      var $selectedShippingType = $('.cart-drawer__shipping input[type="radio"]:checked');
      if ($selectedShippingType.length) {
        $selectedShippingType.trigger({
          type: 'change',
          store: selectedStore
        });
      }

      cache.lightbox.close();

      // Trigger product variant change to update location inventory
      $('[data-section-type="product"]').trigger({
        type: 'variantChange',
        variant: theme.current.variant
      });

      // $('#shippingMethod-click_collect').trigger({
      //   type: 'change',
      //   store: selectedStore
      // });
    });

    return cache.map;
  }

  /**
   * @extends storeLocator.StaticDataFeed
   * @constructor
   */
  function StoreLocatorDataSource(storeData) {
    $.extend(this, new storeLocator.StaticDataFeed());
    this.setStores(this.parse_(storeData));

  }

  /**
   * @const
   * @type {!storeLocator.FeatureSet}
   * @private
   */
  StoreLocatorDataSource.prototype.FEATURES_ = new storeLocator.FeatureSet(
    // new storeLocator.Feature('Wheelchair-YES', 'Wheelchair access'),
    // new storeLocator.Feature('Audio-YES', 'Audio')
  );

  /**
   * @return {!storeLocator.FeatureSet}
   */
  StoreLocatorDataSource.prototype.getFeatures = function () {
    return this.FEATURES_;
  };

  /**
   * @private
   * @param {string} csv
   * @return {!Array.<!storeLocator.Store>}
   */
  StoreLocatorDataSource.prototype.parse_ = function (data) {
    var stores = [];

    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        if (data[key].lat !== undefined && data[key].long !== undefined) {
          var features = new storeLocator.FeatureSet();

          var position = new google.maps.LatLng(data[key].lat, data[key].long);

          var store = new storeLocator.Store(key, position, features, {
            title: data[key].title,
            address: data[key].address,
            hours: data[key].hours
          });

          stores.push(store);
        }
      }
    }

    return stores;
  };

  /**
   * Joins elements of an array that are non-empty and non-null.
   * @private
   * @param {!Array} arr array of elements to join.
   * @param {string} sep the separator.
   * @return {string}
   */
  StoreLocatorDataSource.prototype.join_ = function (arr, sep) {
    var parts = [];
    for (var i = 0, ii = arr.length; i < ii; i++) {
      arr[i] && parts.push(arr[i]);
    }
    return parts.join(sep);
  };

  /**
   * Very rudimentary CSV parsing - we know how this particular CSV is formatted.
   * IMPORTANT: Don't use this for general CSV parsing!
   * @private
   * @param {string} row
   * @return {Array.<string>}
   */
  StoreLocatorDataSource.prototype.parseRow_ = function (row) {
    // Strip leading quote.
    if (row.charAt(0) == '"') {
      row = row.substring(1);
    }
    // Strip trailing quote. There seems to be a character between the last quote
    // and the line ending, hence 2 instead of 1.
    if (row.charAt(row.length - 2) == '"') {
      row = row.substring(0, row.length - 2);
    }

    row = row.split('","');

    return row;
  };

  /**
   * Creates an object mapping headings to row elements.
   * @private
   * @param {Array.<string>} headings
   * @param {Array.<string>} row
   * @return {Object}
   */
  StoreLocatorDataSource.prototype.toObject_ = function (headings, row) {
    var result = {};
    for (var i = 0, ii = row.length; i < ii; i++) {
      result[headings[i]] = row[i];
    }
    return result;
  };

  $('body').on('click', '.storelocator-panel-popup .store', function(evt) {
    $('.storelocator-panel-popup').animate({scrollTop: $('.storelocator-panel-popup .storelocator-filter').offset().top-150}, 350);
  });

  return {
    open: open,
    init: initStoreLocator,
  };

})();


/*================ Sections ================*/
window.theme = window.theme || {};

theme.Cart = (function () {
  var selectors = {
    edit: '.js-edit-toggle'
  };
  var config = {
    showClass: 'cart__update--show',
    showEditClass: 'cart__edit--active',
    cartNoCookies: 'cart--no-cookies'
  };

  function Cart(container) {
    this.$container = $(container);
    this.$edit = $(selectors.edit, this.$container);

    if (!this.cookiesEnabled()) {
      this.$container.addClass(config.cartNoCookies);
    }

    this.$edit.on('click', this._onEditClick.bind(this));
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    onUnload: function () {
      this.$edit.off('click', this._onEditClick);
    },

    _onEditClick: function (evt) {
      var $evtTarget = $(evt.target);
      var $updateLine = $('.' + $evtTarget.data('target'));

      $evtTarget.toggleClass(config.showEditClass);
      $updateLine.toggleClass(config.showClass);
    },

    cookiesEnabled: function () {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
      }
      return cookieEnabled;
    }
  });

  return Cart;
})();

window.theme = window.theme || {};

theme.Filters = (function () {
  var constants = {
    SORT_BY: 'sort_by'
  };
  var selectors = {
    filterSelection: '.collection-filters__dropdown--filter',
    sortSelection: '.collection-filters__dropdown--sort',
    defaultSort: '.collection-filters__default-sort',
    filterPlaceholderDesktop: '.collection-filters-placeholder--desktop',
    filterPlaceholderMobile: '.collection-filters-placeholder--mobile',
    filterContentDesktop: '.collection-filters-content--desktop',
    filterContentMobile: '.collection-filters-content--mobile',
    filterSection: '[data-section-type="collection-filters"]',
    filterSectionWrapper: '#shopify-section-collection-filters',
  };

  function Filters(container) {
    var $container = this.$container = $(container);

    this.initFilters();

    this.$filterSelects = $(selectors.filterSelection, $container);
    this.$sortSelect = $(selectors.sortSelection, $container);
    this.$selects = $(selectors.filterSelection, $container).add($(selectors.sortSelection, $container));

    this.defaultSort = this._getDefaultSortValue();
    this._resizeSelect(this.$selects);
    this.$selects.removeClass('hidden');

    this.$filterSelects.on('change', this._onFilterChange.bind(this));
    this.$sortSelect.on('change', this._onSortChange.bind(this));
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {

    /**
     * Initialises filters
     */
    initFilters: function () {
      var self = this;
      var $filterSectionWrapper = $(selectors.filterSectionWrapper);

      var $filterContentMobile = $(selectors.filterContentMobile, $filterSectionWrapper).html();
      var $filterContentDesktop = $(selectors.filterContentDesktop, $filterSectionWrapper).html();

      $(selectors.filterPlaceholderMobile, this.$container).replaceWith($filterContentMobile);
      $(selectors.filterPlaceholderDesktop, this.$container).replaceWith($filterContentDesktop);
    },

    _onSortChange: function (evt) {
      var sort = this._sortValue();
      if (sort.length) {
        window.location.search = sort;
      } else {
        // clean up our url if the sort value is blank for default
        window.location.href = window.location.href.replace(window.location.search, '');
      }
      this._resizeSelect($(evt.target));
    },

    _onFilterChange: function (evt) {
      // window.location.href = $(evt.target).val() + window.location.search;
      var newLocation = $(evt.target).val();
      if (window.location.search != '') {
        var currentQueryParams = theme.utils.getQueryParams();
        for (var k in currentQueryParams) {
          if (currentQueryParams.hasOwnProperty(k)) {
            newLocation = theme.utils.updateQueryStringParameter(k, currentQueryParams[k], newLocation);
          }
        }
        var newQueryParams = theme.utils.getQueryParams(newLocation);
        for (var k in newQueryParams) {
          if (newQueryParams.hasOwnProperty(k)) {
            newLocation = theme.utils.updateQueryStringParameter(k, newQueryParams[k], newLocation);
          }
        }
        window.location.href = newLocation;
      }
      this._resizeSelect($(evt.target));
    },

    _getSortValue: function () {
      return this.$sortSelect.val() || this.defaultSort;
    },

    _getDefaultSortValue: function () {
      return $(selectors.defaultSort, this.$container).val();
    },

    _sortValue: function () {
      var sort = this._getSortValue();
      var query = '';

      if (sort !== this.defaultSort) {
        query = constants.SORT_BY + '=' + sort;
      }

      return query;
    },

    _resizeSelect: function ($selection) {
      $selection.each(function () {
        var $this = $(this);
        var arrowWidth = 10;
        // create test element
        var text = $this.find('option:selected').text();
        var $test = $('<span>').html(text);

        // add to body, get width, and get out
        $test.appendTo('body');
        var width = $test.width();
        $test.remove();

        // set select width
        $this.width(width + 5 + arrowWidth);
      });
    },

    onUnload: function () {
      this.$filterSelects.off('change', this._onFilterChange);
      this.$sortSelect.off('change', this._onSortChange);
    }
  });

  return Filters;
})();

theme.HeaderSection = (function () {

  function Header() {
    theme.Header.init();
    theme.MobileNav.init();
    theme.Search.init();
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function () {
      theme.Header.unload();
    }
  });

  return Header;
})();

theme.Maps = (function () {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];
  var key = theme.mapKey ? theme.mapKey : '';

  function Map(container) {
    this.$container = $(container);

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript('https://maps.googleapis.com/maps/api/js?key=' + key)
            .then(function () {
              apiStatus = 'loaded';
              initAllMaps();
            });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function (index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function (results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function () {
      var $map = this.$container.find('.map-section__container');

      return geolocate($map)
        .then(function (results) {
          var mapOptions = {
            zoom: config.zoom,
            center: results[0].geometry.location,
            disableDefaultUI: true
          };

          var map = this.map = new google.maps.Map($map[0], mapOptions);
          var center = this.center = map.getCenter();

          //eslint-disable-next-line no-unused-vars
          var marker = new google.maps.Marker({
            map: map,
            position: map.getCenter()
          });

          google.maps.event.addDomListener(window, 'resize', $.debounce(250, function () {
            google.maps.event.trigger(map, 'resize');
            map.setCenter(center);
          }));
        }.bind(this))
        .fail(function () {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = theme.strings.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = theme.strings.addressQueryLimit;
              break;
            default:
              errorMessage = theme.strings.addressError;
              break;
          }

          $map
            .parent()
            .addClass('page-width map-section--load-error')
            .html('<div class="errors text-center">' + errorMessage + '</div>');
        });
    },

    onUnload: function () {
      google.maps.event.clearListeners(this.map, 'resize');
    }
  });

  return Map;
})();

// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
// eslint-disable-next-line camelcase, no-unused-vars
function gm_authFailure() {
  $('.map-section').addClass('map-section--load-error');
  $('.map-section__container').remove();
  $('.map-section__link').remove();
  $('.map-section__overlay').after('<div class="errors text-center">' + theme.strings.authError + '</div>');
}

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function () {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json-main]',
    productSku: '[data-product-sku]',
    productPrice: '[data-product-price]',
    productImageContainer: '[data-product-images]',
    productImages: '[data-product-image]',
    productActiveImage: '[data-product-active-image]',
    productThumbContainer: '[data-product-thumbnails]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    productQtyWrapper: '.product-form__item--quantity',
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');

    this.settings = {
      // Breakpoints from src/styles/settings/variables.scss.liquid // $grid-breakpoints
      mediaQueryMediumUp: 'screen and (min-width: 768px)',
      mediaQuerySmall: 'screen and (max-width: 767px)',
      enableHistoryState: this.$container.data('enable-history-state') || false,
      sectionId: sectionId,
      sliderActive: false,
      bpSmall: false,
      zoomEnabled: false
    };
    this.namespace = '.product';

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());
    this.settings.imageSize = slate.Image.imageSize($(selectors.productFeaturedImage, this.$container).attr('src'));
    this.settings.zoomEnabled = $(selectors.productFeaturedImage).hasClass('js-zoom-enabled');

    // slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

    this.initBreakpoints();
    this.initImageSlider();
    this.initGallery();
    this.initVariants();

    var readMoreLink = '<button aria-hidden="true" focusable="false" role="presentation" class="read-more">Read more <svg class="icon icon-fa-caret-down" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1408 704q0 26-19 45l-448 448q-19 19-45 19t-45-19L403 749q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45z"/></svg></button>';

    if ($('.product-single__description').innerHeight() >= 500) {
      $('.product-single__description').readmore({
        speed: 75,
        collapsedHeight: 420,
        heightMargin: 20,
        moreLink: readMoreLink,
        lessLink: false,
        beforeToggle: function (trigger, element, expanded) {
          $(element).toggleClass('readmore-expanded');
        }
      });
    }

    if ($('.product-single__specifications').innerHeight() >= 480) {
      $('.product-single__specifications').readmore({
        speed: 75,
        collapsedHeight: 400,
        heightMargin: 20,
        moreLink: readMoreLink,
        lessLink: false,
        beforeToggle: function (trigger, element, expanded) {
          $(element).toggleClass('readmore-expanded');
        }
      });
    }

    $('.js-gift-message').on('click', function (e) {
      e.preventDefault();
      var message = $(this).attr('data-text');
      var currentMessage = $('textarea#message').val();
      $('textarea#message').val(currentMessage + ' ' + message);
    });

  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Uses enquire.js to handle breakpoint related actions
     */
    initBreakpoints: function () {
      // var self = this;

      // enquire.register(this.settings.mediaQuerySmall, {
      //   match: function() {
      //     self.settings.bpSmall = true;
      //   },
      //   unmatch: function() {
      //       self.settings.bpSmall = false;
      //   }
      // });

      // enquire.register(this.settings.mediaQueryMediumUp, {
      //   match: function() {

      //   }
      // });
    },

    /**
     * Creates linked sliders for product main and thumb images
     */
    initImageSlider: function () {
      var thumbOptions = {
        slidesToShow: 5,
        swipeToSlide: true,
        infinite: true,
        asNavFor: selectors.productImageContainer,
        focusOnSelect: true,
        responsive: [{
          breakpoint: 992,
          settings: {
            slidesToShow: 5
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 5
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3
          }
        }
        ]
      };

      var mainOptions = {
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: true,
        arrows: true,
        infinite: true,
        focusOnSelect: true,
        fade: true,
        adaptiveHeight: true,
        prevArrow: selectors.productImageContainer + ' ~ .product-single__images__prev',
        nextArrow: selectors.productImageContainer + ' ~ .product-single__images__next',
        responsive: [{
          breakpoint: 768,
          settings: {
            arrows: true
          }
        }]
      };

      $activeProductImage = $(selectors.productActiveImage).first();
      if ($activeProductImage.length > 0) {
        var firstSlide = $activeProductImage.index() || 0;
        mainOptions.initialSlide = firstSlide;
      }

      if (this.productSingleObject.images.length > 1) {
        $(selectors.productThumbContainer).slick(thumbOptions);
      }

      $(selectors.productImageContainer).slick(mainOptions);

      this.settings.sliderActive = true;
    },
    /**
     * Sets up product image lightbox with Photoswipe.js
     */
    initGallery: function () {
      var self = this;

      if (self.settings.zoomEnabled) {
        var pswpElement = document.querySelectorAll('.pswp')[0];
        var items = $('[data-pswp-items]').data('pswp-items');

        $('.zoom-js').click(function (e) {
          e.preventDefault();
          var thumbnail = $(this).find('img')[0];
          options = {
            index: $(this).data('index'),
            barsSize: { top: 0, bottom: 0 },
            captionEl: false,
            fullscreenEl: false,
            shareEl: false,
            bgOpacity: 0.96,
            tapToClose: true,
            tapToToggleControls: false,
            history: false,
            getThumbBoundsFn: function (index) {
              var pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                rect = thumbnail.getBoundingClientRect();
              return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
            }
          };

          var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

          var realViewportWidth,
            useLargeImages = false,
            firstResize = true,
            imageSrcWillChange;

          // gettingData event fires each time PhotoSwipe retrieves image source & size
          gallery.listen('gettingData', function (index, item) {

            realViewportWidth = gallery.viewportSize.x * window.devicePixelRatio;

            // Set image source & size based on real viewport width
            if (useLargeImages) {
              item.src = item.originalImage.src;
              item.w = item.originalImage.w;
              item.h = item.originalImage.h;
              item.msrc = item.originalImage.msrc;
            } else {
              if (realViewportWidth > 1024) {
                item.w = 1600;
              } else if (realViewportWidth > 768) {
                item.w = 1024;
              } else if (realViewportWidth > 640) {
                item.w = 768;
              } else if (realViewportWidth > 480) {
                item.w = 640;
              } else {
                item.w = 480;
              }
              item.w = Math.min(item.w, item[index].originalWidth);
              item.h = Math.round(item.w / item[index].ratio);

              var itemSrcTemplate = decodeURI(item[index].src);
              item.src = itemSrcTemplate.replace('{width}', item.w);
              // item.msrc = itemSrcTemplate.replace('{width}', 180);

              var $imageElem = $(selectors.productImageContainer + ' [data-slick-index="' + index + '"]:not(.slick-cloned) img');
              item.msrc = $imageElem.prop('currentSrc') || $imageElem.attr('src') || item[index].msrc;
            }

            // It doesn't really matter what will you do here,
            // as long as item.src, item.w and item.h have valid values.
            //
            // Just avoid http requests in this listener, as it fires quite often

          });

          gallery.listen('close', function () {
            $(selectors.productImageContainer).slick('slickGoTo', this.getCurrentIndex());
          });

          gallery.init();

        });
      }
    },

    /**
     * Handles change events from the variant inputs
     */
    initVariants: function () {
      var options = {
        $container: this.$container,
        enableHistoryState: this.$container.data('enable-history-state') || false,
        singleOptionSelector: selectors.singleOptionSelector,
        originalSelectorId: selectors.originalSelectorId,
        product: this.productSingleObject
      };

      var variantIds = [];
      for (var key in options.product.variants) {
        if (options.product.variants.hasOwnProperty(key)) {
          variantIds.push(options.product.variants[key].id);
        }
      }

      var adjustProductStock = function (data) {
        options.product = theme.utils.addStockInformation(options.product, data);

        if (options.product.type == "Gift Card") {
          data[theme.current.variant.sku] = {
            "INTERNET": 999
          };
        }

        theme.current.product = options.product;

        theme.Product.variants = new slate.Variants(options);

        var inventoryString = '';
        for (var key in data) {
          if (data.hasOwnProperty(key) && key == theme.current.variant.sku) {
            inventoryString += key;
            inventoryString += '##';
            for (var store in data[key]) {
              if (data[key].hasOwnProperty(store)) {
                inventoryString += store;
                inventoryString += ':';
                inventoryString += data[key][store];
                inventoryString += ',';
              }
            }
            inventoryString += '__';
          }
        }
        inventoryString = inventoryString == '' ? '[]' : inventoryString;
        $('input[name="properties[_inventory]"]').attr('value', inventoryString);
        $('input[name="properties[_inventoryJSON]"]').attr('value', JSON.stringify(data));

        //called on product page
        theme.shop.validateCart();
        $('.product-form__cart-submit').removeClass('loading');
      };

      this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
      this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
      this.$container.on('variantSKUChange' + this.namespace, this.updateSKU.bind(this));
      
      var variantStock = theme.utils.getProductInventory(_.uniq(variantIds).join(','), adjustProductStock);
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function (evt) {
      var variant = evt.variant;


      const physicalStores = variant.inventory_details;
      let isInStoreAvalible = false

      for (let key in physicalStores) {
        if (physicalStores[key] > 0) {
          isInStoreAvalible = true
          break;
        }
      }


      if (variant) {
        if (variant.inventory_details || theme.current.product.type == "Gift Card") {

          theme.current.variant = variant;

          var selectedStore, onlineStoreName = 'INTERNET';
          if (theme.shop.locations.favourite) {
            selectedStore = theme.shop.locations.favourite.replace(' ', '_');
          }

          if (variant.inventory_details[selectedStore] === undefined) {
            selectedStore = onlineStoreName;
          }

          if (variant.inventory_source != selectedStore) {
            var sku = variant.sku;

            // if (variant.inventory_quantity <= 0 && selectedStore != onlineStoreName) {
            //   selectedStore = onlineStoreName;
            // }

            variant.inventory_quantity = parseInt(variant.inventory_details[selectedStore]) > 0 ? parseInt(variant.inventory_details[selectedStore]) : parseInt(variant.inventory_details[onlineStoreName]);
            variant.inventory_quantity = theme.current.product.type == "Gift Card" ? 999 : variant.inventory_quantity;
            variant.inventory_source = parseInt(variant.inventory_details[selectedStore]) > 0 ? selectedStore : onlineStoreName;
            variant.available = variant.inventory_quantity > 0 && variant.inventory_details[onlineStoreName] > 0 ? true : false;
          }
          $(selectors.priceWrapper, this.$container).removeClass('hide');
        } else {
          // No data returned from inventory feed
          variant.available = false;
          variant.inventory_quantity = 0;
        }


      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        document.getElementById("add_shippingMethod-click_collect").style.display = "none"
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.inventory_details[selectedStore] > 0 || variant.inventory_details[onlineStoreName] > 0 || theme.current.product.type == "Gift Card") {
        $(selectors.addToCart, this.$container).css("display", "block");
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
        this.$container.removeClass('sold-out');
        document.getElementById("add_shippingMethod-click_collect").style.display = "none"
      }

      // 
      // If store there is a store that has click and collect #691787858
      // 
      else if (isInStoreAvalible) {

        document.getElementById("add_shippingMethod-click_collect").style.display = "flex"
        $(selectors.addToCart, this.$container).css("display", "none");
        document.getElementById("add_shippingMethod-click_collect").addEventListener("click", (function () {
          theme.StoreLocator.open()
        }));
        // $(selectors.addToCart, this.$container).onClick = function(){console.log("Find store")}
        this.$container.removeClass('sold-out');
      }
      else {
        document.getElementById("add_shippingMethod-click_collect").style.display = "none"
        $(selectors.addToCart, this.$container).css("display", "block");
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
        this.$container.addClass('sold-out');
      }

      theme.shop.validateCart();

      // Update current variant for view bindings
      theme.current.variant = variant;
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function (evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);
      var comparePrefixString = $comparePrice.data('prefix-string') || '';
      var compareSuffixString = $comparePrice.data('suffix-string') || '';

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(comparePrefixString + slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat) + compareSuffixString);
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function (evt) {
      var self = this;
      var variant = evt.variant;

      if (self.settings.sliderActive) {
        var imageIndex = $('[data-image-id="' + variant.id + '"]:not(.slick-cloned)').data('slick-index');
        $(selectors.productImageContainer).slick('slickGoTo', imageIndex);
      } else {
        var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
        $(selectors.productFeaturedImage, this.$container).attr('src', sizedImgUrl);
      }
    },

    /**
     * Updates the DOM with specified Variant SKU
     */
    updateSKU: function (evt) {
      var variant = evt.variant;

      // Update the sku
      $(selectors.productSku, this.$container).html(variant.sku);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function () {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();
theme.Quotes = (function () {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 767px)',
    mediaQueryMediumUp: 'screen and (min-width: 768px)',
    slideCount: 0
  };
  var defaults = {
    arrows: false,
    dots: true,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 3,
    slidesToScroll: 3
  };

  function Quotes(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var wrapper = this.wrapper = '.quotes-wrapper';
    var slider = this.slider = '#Quotes-' + sectionId;
    var $slider = $(slider, wrapper);

    var sliderActive = false;
    var mobileOptions = $.extend({}, defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });

    config.slideCount = $slider.data('count');

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount;
      defaults.slidesToScroll = config.slideCount;
    }

    $slider.on('init', this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function () {
        initSlider($slider, mobileOptions);
      }
    });

    enquire.register(config.mediaQueryMediumUp, {
      match: function () {
        initSlider($slider, defaults);
      }
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    onUnload: function () {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);

      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function (evt) {
      // Ignore the cloned version
      var $slide = $('.quotes-slide--' + evt.detail.blockId + ':not(.slick-cloned)');
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    a11y: function (event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return Quotes;
})();

theme.slideshows = {};

theme.SlideshowSection = (function () {
  function SlideshowSection(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#Slideshow-' + sectionId;

    $('.slideshow__video', slideshow).each(function () {
      var $el = $(this);
      theme.SlideshowVideo.init($el);
      theme.SlideshowVideo.loadVideo($el.attr('id'));
    });

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn({}, theme.SlideshowSection.prototype, {
  onUnload: function () {
    delete theme.slideshows[this.slideshow];
  },

  onBlockSelect: function (evt) {
    var $slideshow = $(this.slideshow);

    // Ignore the cloned version
    var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
  },

  onBlockDeselect: function () {
    // Resume autoplay
    $(this.slideshow).slick('slickPlay');
  }
});

window.theme = window.theme || {};

theme.brandValueSliders = (function () {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 991px)',
    mediaQueryMediumUp: 'screen and (min-width: 992px)',
    slideCount: 0,
    anchorPosition: 'above', // above, below
    anchorElement: '.site-header-lower',
    anchorElementSmall: '.site-header-lower-mob',
    anchorViewport: 'small' // large, small

  };

  var cache = {
    anchorMarginBottom: 0,
    anchorMarginTop: 0,
    anchorOffset: 0
  }
  var $slider = $('.brand-values');
  var defaults = {
    dots: false,
    autoplay: false,
    touchThreshold: 20,
    swipeToSlide: true,
    arrows: true,
    variableWidth: true,
    slidesToShow: 1,

    slidesToScroll: 1,
    slidesToShow: $slider.data('slides-show-desktop'),
    autoplay: $slider.data('autoplay-mobile'),
    autoplaySpeed: $slider.data('speed'),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          variableWidth: false

        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          variableWidth: false
        }
      }
    ]
  };

  $slider.slick(defaults);

})();

window.theme = window.theme || {};

theme.featuredCollections = (function () {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 767px)',
    mediaQueryMediumUp: 'screen and (min-width: 768px)',
    slideCount: 0
  };

  var sliderOptions = {
    arrows: true,
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    infinite: true,
  };

  function featuredCollections(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var wrapper = this.wrapper = '.featured-collection-wrap';
    var slider = this.slider = '#featured-collection-' + sectionId;
    var $slider = $(slider, wrapper);
    var sliderActive = false;

    var options = $.extend({}, sliderOptions, {
      prevArrow: slider + ' ~ .featured-collection__prev',
      nextArrow: slider + ' ~ .featured-collection__next',
      autoplay: $slider.data('autoplay'),
      autoplaySpeed: $slider.data('speed'),
      responsive: [
        {
          breakpoint: 1480,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            swipeToSlide: true,
            // dots: true,
            autoplay: $slider.data('autoplay-mobile'),
          }
        },
        {
          breakpoint: 512,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            swipeToSlide: true,
            // dots: true
          }
        }
      ]
    });

    $slider.on('init', this.a11y.bind(this));

    initSlider($slider, options);

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }
  }

  featuredCollections.prototype = _.assignIn({}, featuredCollections.prototype, {
    onUnload: function () {
      $(this.slider, this.wrapper).slick('unslick');
    },

    a11y: function (event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return featuredCollections;
})();

// window.theme = window.theme || {};

// theme.featuredProducts = (function() {
//   var config = {
//     mediaQuerySmall: 'screen and (max-width: 767px)',
//     mediaQueryMediumUp: 'screen and (min-width: 768px)',
//     slideCount: 0
//   };

//   var sliderOptions = {
//     autoplay: false,
//     arrows: true,
//     dots: false,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     infinite: true
//   };

//   function featuredProducts(container) {
//     var $container = this.$container = $(container);
//     var sectionId = $container.attr('data-section-id');
//     var wrapper = this.wrapper = '.featured-product-wrap';
//     var slider = this.slider = '#featured-product-' + sectionId;
//     var $slider = $(slider, wrapper);
//     var sliderActive = false;

//     var options = $.extend({}, sliderOptions, {
//       prevArrow: slider + ' ~ .featured-product__prev',
//       nextArrow: slider + ' ~ .featured-product__next'
//     });

//     $slider.on('init', this.a11y.bind(this));

//     initSlider($slider, options);

//     function initSlider(sliderObj, args) {
//       if (sliderActive) {
//         sliderObj.slick('unslick');
//         sliderActive = false;
//       }

//       sliderObj.slick(args);
//       sliderActive = true;
//     }
//   }

//   featuredProducts.prototype = _.assignIn({}, featuredProducts.prototype, {
//     onUnload: function() {
//       $(this.slider, this.wrapper).slick('unslick');
//     },

//     a11y: function(event, obj) {
//       var $list = obj.$list;
//       var $wrapper = $(this.wrapper, this.$container);

//       // Remove default Slick aria-live attr until slider is focused
//       $list.removeAttr('aria-live');

//       // When an element in the slider is focused set aria-live
//       $wrapper.on('focusin', function(evt) {
//         if ($wrapper.has(evt.target).length) {
//           $list.attr('aria-live', 'polite');
//         }
//       });

//       // Remove aria-live
//       $wrapper.on('focusout', function(evt) {
//         if ($wrapper.has(evt.target).length) {
//           $list.removeAttr('aria-live');
//         }
//       });
//     }
//   });

//   return featuredProducts;
// })();

window.theme = window.theme || {};

theme.contentSliders = (function () {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 600px)',
    mediaQueryMedium: 'screen and (min-width: 601px) and (max-width: 991px)',
    mediaQueryLargeUp: 'screen and (min-width: 992px)'
  };

  function contentSliders(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var wrapper = this.wrapper = '.content-slider-wrap';
    var slider = this.slider = '#content-slider-' + sectionId;
    var $slider = $(slider, wrapper);
    var sliderActive = false;

    var options = {
      infinite: $slider.data('infinite'),
      prevArrow: slider + ' ~ .content-slider__prev',
      nextArrow: slider + ' ~ .content-slider__next',
      arrows: $slider.data('arrows'),
      dots: $slider.data('dots'),
      autoplay: $slider.data('autoplay'),
      autoplaySpeed: $slider.data('speed'),
      slidesToShow: $slider.data('slides-show-desktop'),
      slidesToScroll: $slider.data('slides-scroll-desktop'),
      rows: $slider.data('rows-desktop'),
      slidesPerRow: $slider.data('per-row-desktop')
    };

    var tabletOptions = $.extend({}, options, {
      slidesToShow: $slider.data('slides-show-tablet'),
      slidesToScroll: $slider.data('slides-scroll-tablet'),
      rows: $slider.data('rows-tablet'),
      slidesPerRow: $slider.data('per-row-tablet')
    });

    var mobileOptions = $.extend({}, options, {
      arrows: $slider.data('arrows-mobile'),
      dots: $slider.data('dots-mobile'),
      autoplay: $slider.data('autoplay-mobile'),
      slidesToShow: $slider.data('slides-show-mobile'),
      slidesToScroll: $slider.data('slides-scroll-mobile'),
      rows: $slider.data('rows-mobile'),
      slidesPerRow: $slider.data('per-row-mobile')
    });

    $slider.on('init', this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function () {
        initSlider($slider, mobileOptions);
      }
    });

    enquire.register(config.mediaQueryMedium, {
      match: function () {
        initSlider($slider, tabletOptions);
      }
    });

    enquire.register(config.mediaQueryLargeUp, {
      match: function () {
        initSlider($slider, options);
      }
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }

    $('.slideshow__video', wrapper).each(function () {
      var $el = $(this);
      theme.SlideshowVideo.init($el);
      theme.SlideshowVideo.loadVideo($el.attr('id'));
    });
  }

  contentSliders.prototype = _.assignIn({}, contentSliders.prototype, {
    onUnload: function () {
      $(this.slider, this.wrapper).slick('unslick');
    },

    a11y: function (event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return contentSliders;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function () {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function () {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function () {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function () {
    var formId = $(this).data('form-id');
    var $form = $('#EditAddress_' + formId);
    $form.toggleClass('hide');
    $('body,html').animate({ scrollTop: $form.offset().top }, 1000);
  });

  $('.address-delete').on('click', function () {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, { parameters: { _method: 'delete' } });
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function () {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

window.theme = window.theme || {};

theme.RegisterPage = (function () {
  var selectors = {
    registerPage: '.register-page',
  };

  if (!$(selectors.registerPage).length) {
    return;
  }

  var validateABN = function (abn) {
    var isValid = true;
    abn = abn.replace(/[^0-9]/g, '');
    isValid &= abn && /^\d{11}$/.test(abn);

    if (isValid) {
      var weightedSum = 0;
      var weight = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
      for (var i = 0; i < weight.length; i++) {
        weightedSum += (parseInt(abn[i]) - ((i === 0) ? 1 : 0)) * weight[i];
      }
      isValid &= ((weightedSum % 89) === 0);
    }

    return isValid;
  };

  var abnField = document.getElementById('CustomerFormABN');
  if (abnField !== undefined && abnField !== null) {
    abnField.addEventListener('input', function (event) {
      if (abnField.validity.typeMismatch || validateABN(abnField.value) != true) {
        abnField.setCustomValidity('Please enter a valid ABN.');
      } else {
        abnField.setCustomValidity('');
      }
    });
  }

  if ($('#CustomerFormCustomerType').length) {
    updateRegisterFormFields($('#CustomerFormCustomerType').val());

    $('#CustomerFormCustomerType').on('change', function () {
      updateRegisterFormFields($(this).val());
    });
  }

  $('.form-element--product-interest label:last-child input').on('change', function () {
    $('.form-element--product-interest label input').not(this).prop('checked', this.checked);
  });

  $('.form-element--product-interest label:not(:last-child) input').on('change', function () {
    $('.form-element--product-interest label:last-child input').prop('checked', false);
  });

  function updateRegisterFormFields(selector) {
    var activeGroup = theme.utils.handleize(selector);
    var activeSelector = '.form-element--' + activeGroup;

    $('.form-element--toggles').not(activeSelector).hide();
    $('.form-element--toggles').not(activeSelector).removeClass('form-element--visible');
    $('.form-element--toggles').not(activeSelector).prop('disabled', true);

    $(activeSelector).show();
    $(activeSelector).addClass('form-element--visible');
    $(activeSelector).prop('disabled', false);

    $('input[name="tags"]').val(activeGroup);
  };

})();

window.theme = window.theme || {};

theme.Password = (function () {
  var selectors = {
    passwordPage: '.password-page',
    loginModal: '#LoginModal',
    focusOnOpen: '#Password'
  };

  if (!$(selectors.passwordPage).length) {
    return;
  }

  initModal();

  function initModal() {

    var $loginModal = $(selectors.loginModal);

    if (!$loginModal.length) {
      return;
    }

    var passwordModal = new theme.Modals(selectors.loginModal, 'login-modal', {
      focusOnOpen: selectors.focusOnOpen
    });

    // Open modal if errors exist
    if ($loginModal.find('.errors').length) {
      passwordModal.open();
    }

  }
})();

/* Blogs */
(function () {
  var $filterBy = $('#BlogTagFilter');

  if (!$filterBy.length) {
    return;
  }

  $filterBy.on('change', function () {
    location.href = $(this).val();
  });
})();

(function () {
  var $blogSearchInput = $('.blog__search .input-group__field');

  function updateHistoryState(query) {
    if (!history.replaceState) {
      return;
    }

    query = query ? encodeURIComponent(query) : '';
    var newurl = theme.utils.updateQueryStringParameter('s', query);
    window.history.replaceState({ path: newurl }, '', newurl);
  }


  if ($blogSearchInput.length) {
    var queryParams = theme.utils.getQueryParams();

    var searchStringPrefix = '';
    if (theme.current.template && theme.current.template.suffix != 'all') {
      searchStringPrefix += 'tag:';
      searchStringPrefix += window.location.pathname.split('/').pop();
      searchStringPrefix += ' ';
    }

    var $blogSearchResults = $('.blog__search-results');
    var $blogSearchResultsList = $('.blog__search-results-list');
    var timer, previousValue;

    $blogSearchInput.on('input change', function () {
      if (this.value && this.value != '' && this.value.length >= 3) {
        if (this.value != previousValue) {
          previousValue = this.value;
          $blogSearchResults.removeClass('hide').addClass('loading');
          $blogSearchResultsList.html('');
          var searchQuery = this.value;

          if (timer) {
            window.clearTimeout(timer);
          }

          var searchString = searchStringPrefix + searchQuery;
          $.get('/search?q=' + encodeURIComponent(searchString) + '&type=article&view=article-grid-items', function (data) {
            if (data.length) {
              $blogSearchResultsList.html(data);
              updateHistoryState(searchQuery);
            } else {
              $blogSearchResultsList.html('<div class="col-xs-12 blog__search-no-results text-center">No results found</div>');
              updateHistoryState();
            }

            timer = window.setTimeout(function () {
              $blogSearchResults.removeClass('loading');
            }, 1500);
          });
        }
      } else {
        $blogSearchResults.removeClass('loading').addClass('hide');
      }
    });

    if (queryParams && queryParams['s']) {
      $blogSearchInput.val(decodeURIComponent(queryParams['s']));
      $($blogSearchInput).trigger('change');
    }

  }

})();


window.theme = window.theme || {};

theme.ProductFilterAndSearch = (function () {

  var selectors = {
    collectionTitle: '[data-collection-title]',
    collectionDescriptionTitle: '[data-collection-description-title]',
    collectionDescription: '[data-collection-description]',
    collectionFooterDescription: '[data-collection-footer-description]',
    pageHeader: '.collection-siderbar-info'
  };

  var options = {
    displayCollectionDescription: true,
    animateHeaderHeight: false
  };

  var cache = {
    headerHeightCurrent: 0,
    headerHeightNew: 0
  };

  function init() {
    if (theme.current.type.indexOf('collection') > -1 || theme.current.type.indexOf('search') > -1) {
      theme.shop.vendorHandles = [];
      for (var i = 0; i < theme.shop.vendors.length; i++) {
        theme.shop.vendorHandles[theme.utils.handleize(theme.shop.vendors[i])] = theme.shop.vendors[i];
      }

      var $currentLink = $('.site-nav__link[href="' + window.location.pathname + '"]');
      var $parentCategoryLink = $currentLink.eq(0).parents('.site-nav__item').children('.site-nav__link--main') || $currentLink.eq(0);

      var bcSfFilterMainConfigGeneralOverrides, currentHandle;
      var newurl = false;
      var queryParams = theme.utils.getQueryParams() || {};

      if ($parentCategoryLink.length) {
        $('[data-collection-parent-title]').text($parentCategoryLink.attr('title'));

        bcSfFilterMainConfigGeneralOverrides = {
          collection_id: $parentCategoryLink.data('collection-id'),
          collection_handle: $parentCategoryLink.data('collection-handle'),
          collection_count: $parentCategoryLink.data('collection-count'),
        };
      } else {
        bcSfFilterMainConfigGeneralOverrides = {
          collection_id: theme.current.collection.id,
          collection_handle: theme.current.collection.handle,
          collection_count: theme.current.collection.count,
        };
      }

      if (theme.shop.vendors.indexOf(theme.current.collection.title) > -1) {
        var $brandsLinkParent = $('.site-nav__link--main[href="/collections"]');
        $('[data-collection-parent-title]').text($('span:first-child', $brandsLinkParent).eq(0).text());

        bcSfFilterMainConfigGeneralOverrides = {
          collection_id: theme.shop.allCollection.id,
          collection_handle: theme.shop.allCollection.handle,
          collection_count: theme.shop.allCollection.count,
        };

        if (!queryParams['_'] && !queryParams['pf_v_brand']) {
          var newurl = theme.utils.updateQueryStringParameter('_', 'pf', window.location.href);
          newurl = theme.utils.updateQueryStringParameter('pf_v_brand', encodeURIComponent(theme.current.collection.title), newurl);
        }
      } else if (!$currentLink.is('.site-nav__link--main') && $currentLink.length) {
        currentHandle = $currentLink.data('handle');

        var newurl;
        if (!queryParams['_']) {
          newurl = theme.utils.updateQueryStringParameter('_', 'pf', window.location.href);
        }

        if (!queryParams['pf_t_collection']) {
          newurl = theme.utils.updateQueryStringParameter('pf_t_collection', currentHandle, newurl);
        }
      }

      if (queryParams['view_all'] && queryParams['view_all'] == 1) {
        bcSfFilterMainConfigGeneralOverrides.paginationType = 'infinite';
        bcSfFilterMainConfigGeneralOverrides.limit = 60;
        $('.collection__header-pages').html('Viewing all products');
      }

      if (typeof window.bcSfFilterMainConfig !== 'undefined') {
        window.bcSfFilterMainConfig.general = _.extend(window.bcSfFilterMainConfig.general, bcSfFilterMainConfigGeneralOverrides);
      }

      $('.collection, [data-collection-parent-title]').addClass('loaded');

      if (typeof window.bcSfFilterConfig !== 'undefined') {
        window.bcSfFilterConfig = _.extend(window.bcSfFilterConfig, window.bcSfFilterMainConfig);
      } else {
        window.bcSfFilterConfig = _.extend({}, window.bcSfFilterMainConfig);
      }

      if (newurl) {
        if (window.history.replaceState) {
          window.history.replaceState({}, '', newurl);
        } else {
          window.location.href = newurl;
        }
      }
    }

    window.bcsffilter = new BCSfFilter();
    window.bcsffilter.init();
    window.bcsffilter.initFilter();
    window.bcsffilter.initSearchBox();

    if (theme.current.type.indexOf('collection') > -1 || theme.current.type.indexOf('search') > -1) {
      bcsffilter.collectionId = bcSfFilterMainConfigGeneralOverrides.collection_id;

      if (newurl && newurl.indexOf('pf_v_brand') > -1) {
        $(document).on('click', '.bc-sf-filter-selected-items a', function (evt) {
          if (this.href.indexOf('pf_v_brand') == -1 && this.href.indexOf('pf_t_collection') == -1) {
            clearAllFilterOptions(evt);
          }
        });
      }

      // Remove parent/child category filters on first filter interaction
      // If $currentLink is a child category AND isn't an 'others' link, or $currentLink is a special collection link (Sale, etc.)
      if ($currentLink.is('.site-nav__child-link--parent') && $('.site-nav__grandchildlist a', $currentLink.parent()).length > 0 || $currentLink.is('[data-collection-handle]') && bcsffilter.queryParams.pf_t_collection !== undefined && $('a.site-nav__child-link--parent[data-handle="' + bcsffilter.queryParams.pf_t_collection[0] + '"]', $currentLink.parent()).length > 0) {
        // Store the original BC Filter change function, then redefine our own
        var _originalOptionChange = window.onInteractWithFilterOptionValue;

        window.onInteractWithFilterOptionValue = function (a, b, c, d, e, f) {
          var result;

          // Remove the filter on first change if changing to another category
          if (c == 'tag') {
            bcsffilter.queryParams.pf_t_collection.shift();
            window.history.replaceState({}, '', theme.utils.removeQueryStringParameter('pf_t_collection', window.location.href));
            result = _originalOptionChange.apply(this, arguments);
            // After the first change, revert the function back to its original state
            window.onInteractWithFilterOptionValue = _originalOptionChange;
          } else {
            result = _originalOptionChange.apply(this, arguments);
          }

          return result;
        }
      }

      $('.collection').on('click', '#bc-sf-filter-tree-mobile-close-button', function () {
        $('#bc-sf-filter-tree-mobile-close-button').addClass('inactive');
        $('body,html').animate({ scrollTop: $(this).parents('.collection').offset().top }, 300);
        window.setTimeout(function () {
          $('#bc-sf-filter-tree-mobile-button').click();
        }, 200);
      });
    }
  }

  function getGridItemTemplate() {
    return document.querySelectorAll('[data-template-for="product-grid-item"]')[0].innerHTML;
  }

  function buildCollectionPage(data) {

    var collection = JSON.parse(data);

    // Prep page title section transition
    if (options.animateHeaderHeight) {
      cache.headerHeightCurrent = $(selectors.pageHeader).height();
      $(selectors.pageHeader).css('height', cache.headerHeightCurrent);
    }

    // Perform page title section transition
    if (options.animateHeaderHeight) {
      cache.headerHeightNew = $(selectors.pageHeader).css('height', 'auto').get(0).scrollHeight;
      $(selectors.pageHeader)
        .height(cache.headerHeightCurrent)
        .animate({
          height: cache.headerHeightNew
        }, 750, 'swing', function () {
          $(selectors.pageHeader).css('height', 'auto');
        });
    }

  }

  return {
    getGridItemTemplate: getGridItemTemplate,
    buildCollectionPage: buildCollectionPage,
    init: init
  };

})();

theme.ProductFilterAndSearch.init();

window.theme = window.theme || {};
theme.slideshows = theme.slideshows || {};

theme.LatestBlogPosts = (function () {
  function LatestBlogPosts(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#Slideshow-' + sectionId;

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return LatestBlogPosts;
})();

theme.LatestBlogPosts.prototype = _.assignIn({}, theme.LatestBlogPosts.prototype, {
  onUnload: function () {
    delete theme.slideshows[this.slideshow];
  },

  onBlockSelect: function (evt) {
    var $slideshow = $(this.slideshow);

    // Ignore the cloned version
    var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
  },

  onBlockDeselect: function () {
    // Resume autoplay
    $(this.slideshow).slick('slickPlay');
  }
});

theme.FeaturedBrands = (function () {
  function FeaturedBrands(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#Slideshow-' + sectionId;

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return FeaturedBrands;
})();

theme.FeaturedBrands.prototype = _.assignIn({}, theme.FeaturedBrands.prototype, {
  onUnload: function () {
    delete theme.slideshows[this.slideshow];
  },

  onBlockSelect: function (evt) {
    var $slideshow = $(this.slideshow);

    // Ignore the cloned version
    var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
  },

  onBlockDeselect: function () {
    // Resume autoplay
    $(this.slideshow).slick('slickPlay');
  }
});

theme.FeaturedProducts = (function () {
  function FeaturedProducts(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#Slideshow-' + sectionId;

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return FeaturedProducts;
})();

theme.FeaturedProducts.prototype = _.assignIn({}, theme.FeaturedProducts.prototype, {
  onUnload: function () {
    delete theme.slideshows[this.slideshow];
  },

  onBlockSelect: function (evt) {
    var $slideshow = $(this.slideshow);

    // Ignore the cloned version
    var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
  },

  onBlockDeselect: function () {
    // Resume autoplay
    $(this.slideshow).slick('slickPlay');
  }
});

theme.FeaturedOffers = (function () {
  function FeaturedOffers(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#Slideshow-' + sectionId;

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return FeaturedOffers;
})();

theme.FeaturedOffers.prototype = _.assignIn({}, theme.FeaturedOffers.prototype, {
  onUnload: function () {
    delete theme.Slider[this.slideshow];
  },

  onBlockSelect: function (evt) {
    var $slideshow = $(this.slideshow);

    // Ignore the cloned version
    var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
  },

  onBlockDeselect: function () {
    // Resume autoplay
    $(this.slideshow).slick('slickPlay');
  }
});



$(document).ready(function () {

  $('[data-current-view]').each(function () {
    rivets.bind($(this), theme);
  });

  // Object-fit polyfill initialise
  objectFitImages();

  var sections = new slate.Sections();
  sections.register('cart-template', theme.Cart);
  sections.register('product', theme.Product);
  sections.register('collection-template', theme.Filters);
  sections.register('product-template', theme.Product);
  sections.register('header-section', theme.HeaderSection);
  sections.register('map', theme.Maps);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('quotes', theme.Quotes);
  sections.register('brand-values', theme.brandValueSliders);
  sections.register('featured-collection', theme.featuredCollections);
  sections.register('featured-product', theme.featuredProducts);
  sections.register('content-slider', theme.contentSliders);
  sections.register('product-badges', theme.ProductBadges);
  sections.register('latest-blog-posts', theme.LatestBlogPosts);
  sections.register('featured-brands', theme.FeaturedBrands);
  sections.register('featured-products', theme.FeaturedProducts);
  sections.register('featured-offers', theme.FeaturedOffers);


  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function (evt) {
    evt.preventDefault();
  });

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // Video Lightboxes
  $('.video-lightbox__trigger, .rte a[href*="youtube.com"], .rte a[href*="youtu.be"]').yu2fvl({
    minPaddingX: 60, // the space you want on *top and bottom when centering the video (value is divided by 2)
    minPaddingY: 60, // the space you want on *left and right when centering the video (value is divided by 2)
    ratio: 16 / 9, // choose the ration you want for your video
    cssClass: "video-lightbox", // set a namespace / global css class
    overlayCssClass: "__overlay", // give a suffix css class for the overlay
    iframeCssClass: "__iframe", // give a suffix css class for the iframe
    closeCssClass: "__close", // give a suffix css class for the close button
    // #TODO: Handle the SVG close button a little more nicely
    closeText: "<svg viewBox=\"0 0 64 64\" xmlns=\"http://www.w3.org/2000/svg\"><g transform=\"translate(381 231)\"><path d=\"M-370.7-174.7l-2.3-2.3 46-46 2.3 2.3-46 46\"/><path d=\"M-327-174.7l-46-46 2.3-2.3 46 46-2.3 2.3\"/></g></svg>", // give some text for the close button
    vid: false, // set directly a youtube video id (though using an anchor is cool for SEO !)
    open: false // Open the lightbox immediately from JavaScript. Requires vid to be set to work properly.
  });

  // $('.collection-filters a').click(function(e){
  //   e.preventDefault();
  //   var $this = $(this);
  //   $gridContainer = $('.collection-grid .row');

  //   $gridContainer.empty().addClass('loading');

  //   $.ajax({
  //     url: $this.attr('href') + '?view=json'
  //   }).done(function(data) {
  //     var products = JSON.parse(data);
  //     template = $('#collection_grid_tpl').html();
  //     for (var i = 0; i < products.length; i++) {
  //       var newProduct = template;
  //       product = products[i];

  //       newProduct = newProduct.replace(/\{url\}/g, product.url);
  //       newProduct = newProduct.replace(/\{title\}/g, product.title);
  //       newProduct = newProduct.replace(/\{price\}/g, product.price);
  //       newProduct = newProduct.replace(/\{image\}/g, product.featured_image);
  //       $gridContainer.append(newProduct);
  //     }
  //   });

  // });

  // #TODO Replace this with some nicer logic - Rivets, slick, etc.
  theme.RecentlyViewed.showRecentlyViewed({ howManyToShow: 4 });

  // $(document).on('click', '.pagination a', function(e) {
  //   var $this = $(this);

  //   if (!$this.hasClass('pagination__view-all')) {
  //     var $paginationElem = $this.parents('.pagination');
  //     var targetContainer = $paginationElem.data('target-container');
  //     var targetContainerOffset = $paginationElem.data('offset') || 0;

  //     if (targetContainer) {
  //       e.preventDefault();
  //       var $parentElem = $(targetContainer).parent();
  //       var targetURL = $this.attr('href');
  //       var match = RegExp('[?&]page=([^&]*)').exec(targetURL);
  //       var targetPage = match && decodeURIComponent(match[1].replace(/\+/g, ' ')) || 1;

  //       $('.collection .top-row .coll-top-detail .current_page').text(targetPage);

  //       $parentElem.addClass('ajax-loading');

  //       $('html, body').animate({ scrollTop: $(targetContainer).offset().top + targetContainerOffset }, 500 );
  //       // If page already exists
  //       if ($(targetContainer+'[data-page="'+targetPage+'"]').length) {
  //         $(targetContainer).not('[data-page="'+targetPage+'"]').fadeOut('slow');
  //         $(targetContainer+'[data-page="'+targetPage+'"]').fadeIn('slow');
  //         history.pushState({}, targetPage, targetURL);
  //         $parentElem.offset().top;
  //         $parentElem.removeClass('ajax-loading');
  //       } else {
  //         $.ajax({
  //           type: 'GET',
  //           dataType: 'html',
  //           url: targetURL + '&view=ajax',
  //           success: function(data) {
  //             $(targetContainer).not('[data-page="'+targetPage+'"]').fadeOut('slow');
  //             history.pushState({}, targetPage, targetURL);
  //             var appendData = $(data).find(targetContainer).prependTo($parentElem).hide();

  //             var $qtyInputs = $('input[type="number"]', appendData);
  //             $qtyInputs.each( function(){
  //               var $el = $(this);
  //               theme.QuantitySelectors.init($el);
  //             });

  //             appendData.fadeIn('slow');
  //             $parentElem.offset().top;
  //             $parentElem.removeClass('ajax-loading');
  //           }
  //         });
  //       }
  //     }
  //   }
  // });

  theme.CurrencySelectors.init();

  $('#MainContent').on('click.quickAddToCart', '.product-grid-item .btn-add-to-cart', function (evt) {
    var $this = $(this);
    var $container = $('#product-grid-item-' + $this.data('product-id'));
    var qty = $('input[name="quantity"]', $container).val();

    if (qty > 0) {
      var variantId = $('#variant-select-' + $this.data('product-id') + ' option:selected').val();

      CartJS.addItem(variantId, qty, {}, {
        "success": function (data, textStatus, jqXHR) {
          iziToast.success({
            title: 'Success!',
            message: 'Added to cart.',
            position: 'bottomCenter',
            theme: 'light',
            buttons: [
              ['<button title="View">View</button>', function (instance, toast) {
                instance.hide(toast);
                theme.CartDrawer.open();
              }]
            ]
          });
        }
      });
    } else {
      $('[data-progress-element]', $container).removeClass('loading');
    }
  });

  $('.product-grid-form__items select').on('change', function () {
    var $selectedOption = $(this).find('option:selected');
    var productId = $(this).parents('.product-grid-form').data('product-id');
    var variantPrice = Currency.formatMoney(Currency.convert($selectedOption.data('price'), shop.currency, Currency.currentCurrency), Currency.currentFormat);

    $('#product-grid-item-' + productId + ' span.money').html(variantPrice);
    $('#product-grid-item-' + productId + ' input[name="quantity"]').val(0);
    $('#product-grid-item-' + productId + ' .btn-add-to-cart').removeClass('active');
    // $(this).attr('data-currency-' + shop.currency, $(this).html());
  });

  $('.product-grid-form__items').on('update.qtySelector', 'input[name="quantity"]', function (evt) {
    // $('.product-grid-form__items').on('click', '.js-qty-select button', function(){
    //   var productId = $(this).parents('.product-grid-form').data('product-id');
    //   var selectedVariantId = $('#variant-select-' + productId + ' option:selected').val();
    //   var variantQuantity = $(this).siblings('input[name="quantity"]').val();
    //   // CartJS.updateItemById({selectedVariantId, variantQuantity});
    var quantity = $(evt.target).val();
    var productId = $(this).parents('.product-grid-form').data('product-id');
    var $addButton = $('#product-grid-item-' + productId + ' .btn-add-to-cart');
    if (quantity > 0) {
      $addButton.addClass('active');
    } else {
      $addButton.removeClass('active');
    }
  });

  $('select[data-auto-size]').on('change', function () {
    var $this = $(this);
    var arrowWidth = 0; // Optional arrow width, currently handled by CSS
    // create test element
    var text = $this.find('option:selected').text();
    var $test = $('<span>').html(text);

    // add to body, get width, and get out
    $test.appendTo('body');
    var width = $test.width();
    $test.remove();

    // set select width
    $this.width(width + 5 + arrowWidth);
  });

  // $(document).on('click', '#show-4-column', function(e) {
  //   e.preventDefault();
  //   $(this).addClass('active');
  //   $('#show-3-column').removeClass('active');
  //   $('.collection-wrap__inner .collection-grid > .row > div').removeClass('col-lg-4').addClass('col-lg-3');
  // });

  // $(document).on('click', '#show-3-column', function(e) {
  //   e.preventDefault();
  //   $(this).addClass('active');
  //   $('#show-4-column').removeClass('active');
  //   $('.collection-wrap__inner .collection-grid > .row > div').removeClass('col-lg-3').addClass('col-lg-4');
  // });

  $('.filter-group__title').on('click', function () {
    var $filterGroup = $(this).parent('.filter-group');
    var $filterList = $(this).next('ul');
    if ($filterGroup.is('.active')) {
      $filterGroup.removeClass('active').removeClass('current');
      $filterList.css('max-height', '0px');
    } else {
      $filterGroup.addClass('active');
      $filterList.css('max-height', $filterList.get(0).scrollHeight);
    }
  });

  $('#MainContent').on('click', '.bc-sf-filter-block-title--custom', function () {
    $('h3 span', this).toggleClass('up');
    $(this).siblings('.bc-sf-filter-block-content').slideToggle();
  });

  $("#accordion").accordion({
    active: false,
    collapsible: true,
    heightStyle: "content",
    header: ":header"
  });

  var $storeLocatorPageElem = $('.template-page-store-locator .store-locator');
  if ($storeLocatorPageElem.length) {
    window.storeLocatorPageMap = theme.StoreLocator.init($storeLocatorPageElem, 999, false);
    var position = new google.maps.LatLng('-37.8136', '144.9631');
    window.storeLocatorPageMap.setCenter(position);
    window.storeLocatorPageMap.setZoom(10);

    $('#store-locator-list').on('click', 'a[data-location]', function (evt) {
      evt.preventDefault();

      var location = $(this).data('location');
      // var position = new google.maps.LatLng(theme.shop.locations[location].lat, theme.shop.locations[location].long);
      // window.storeLocatorPageMap.setCenter(position);
      // window.storeLocatorPageMap.setZoom(13);
      // $storeLocatorPageElem.addClass('store-locator--actions-enabled');

      $storeLocatorPageElem.find('.store#store-' + location).trigger('click');
      $storeLocatorPageElem.find('#store-locator-actions a').attr('href', theme.shop.locations[location].url);
      $storeLocatorPageElem.find('#store-locator-actions-popup a').attr('href', theme.shop.locations[location].url);
    });

    $storeLocatorPageElem.find('.storelocator-filter').on('submit', function () {
      $storeLocatorPageElem.addClass('store-locator--search-enabled');
    });
  }

  var $storePageMap = $('.store-page-map');
  if ($storePageMap.length) {
    var storeUrl = $storePageMap.data('store-url');
    for (var key in theme.shop.locations) {
      if (theme.shop.locations.hasOwnProperty(key)) {
        if (theme.shop.locations[key].url == storeUrl) {
          storeData = { key: theme.shop.locations[key] };
          var autocompleteOptions = {
            componentRestrictions: {
              country: 'au'
            }
          };
          var storePageMap = theme.StoreLocator.init($storePageMap, 10, true, storeData, false, autocompleteOptions);
          storePageMap.setZoom(14);
          google.maps.event.addListenerOnce(storePageMap, 'directions_activated', function () {
            $('.storelocator-filter input').val('');
            $('.storelocator-filter').show();
            //added by gabbie
            $('.storelocator-panel').animate({ scrollTop: $('.storelocator-filter').offset().top - 150 }, 350);
            $('body,html').animate({ scrollTop: $('.storelocator-filter').offset().top - 150 }, 350);
          });
          google.maps.event.addListenerOnce(storePageMap, 'idle', function () {
            $storePageMap.find('.store').trigger('click');
          });
          break;
        }
      }
    }
  }

  $('.template-page-store-locator .store-locator').on('blur', '#store-locator-panel .location-search', function () {
    if ($(window).width() < 768) {
      $('.template-page-store-locator .store-locator #store-locator-panel .store-list').css('display', 'block');
    }
  });

  $('.product-single__availability-accordion').accordion({
    active: false,
    collapsible: true,
    heightStyle: "content"
  });

  $('a[href="#show-click-collect-stores"]').on('click', function (evt) {
    evt.preventDefault();
    $('.availability-accordion__click-collect').click();
  });

  $('a[href="#show-delivery-information"]').on('click', function (evt) {
    evt.preventDefault();
    // $('.availability-accordion__delivery').click();
    var $shippingTabHandle, highlightElements;

    if ($(window).width() < 768) {
      $shippingTabHandle = $('#tab-handle__shipping-mobile');
      highlightElements = '#' + $shippingTabHandle.attr('aria-controls');
    } else {
      $shippingTabHandle = $('#tab-handle__shipping');
      highlightElements = $shippingTabHandle.attr('href');
    }

    $shippingTabHandle.click();
    $('html').animate({
      scrollTop: $shippingTabHandle.offset().top - 100
    }, 600);

    if (highlightElements) {
      theme.utils.flash(highlightElements);
    }
  });

  $('.product-single').on('click', '.product-single__availability-accordion a[href="#set-store"]', function (evt) {
    $('.availability-accordion__click-collect').click();
  });

  $(document).on('click', 'a[href="#set-store"]', function (evt) {
    evt.preventDefault();
    var selectedStore = $(this).attr('data-store');
    Cookies.set('storeLocation', selectedStore);
    theme.shop.locations.favourite = selectedStore;

    var $selectedShippingType = $('.cart-drawer__shipping input[type="radio"]:checked');
    if ($selectedShippingType.length) {
      $selectedShippingType.trigger('change');
    }

    $('[data-section-type="product"]').trigger({
      type: 'variantChange',
      variant: theme.current.variant
    });

    iziToast.success({
      title: 'Success!',
      message: 'Click & collect store set to <b>' + rivets.formatters.storeTitle(selectedStore) + '</b>.',
      position: 'bottomCenter',
      theme: 'dark',
      displayMode: 2,
      id: 'clickCollectUpdated',
    });
  });
  $(document).on('click', 'a[href="#set-store1"]', function (evt) {
    evt.preventDefault();
    var selectedStore = $(this).attr('data-store');
    Cookies.set('storeLocation', selectedStore);
    theme.shop.locations.favourite = selectedStore;

    // var $selectedShippingType = $('.cart-drawer__shipping input[type="radio"]:checked');
    // if ($selectedShippingType.length) {
    //   $selectedShippingType.trigger('change');
    // }

    // $('[data-section-type="product"]').trigger({
    //   type: 'variantChange',
    //   variant: theme.current.variant
    // });


  });
  // SHOW MORE

  // Append 'Show more' button to paragraph before toggle0-this element
  var toggleButton = ' <a href="" class="toggle-button" title="See more">See more</a>';
  var toggleButtonOff = ' <a href="" class="toggle-button--off" title="See less" style="display:none;">See less</a>';
  var $prevElem = $(".toggle-this").prev();

  if ($prevElem.length) {
    $prevElem.append(toggleButton);
    $prevElem.parent().append(toggleButtonOff);
  } else {
    $('.toggle-this').before(toggleButton);
    $('.toggle-this').after(toggleButtonOff);
  }


  // Assign active class to toggle-this element and remove button from DOM
  $('.toggle-button').on('click', function (e) {
    e.preventDefault();
    var $parent = $(this).parents('.toggle-this-container');
    $parent.addClass('toggle-this-active');
    $parent.find('.toggle-this').addClass('active');
    $parent.find('.toggle-button--off').show();
    $(this).hide();
  });

  // Assign active class to toggle-this element and remove button from DOM
  $('.toggle-button--off').on('click', function (e) {
    e.preventDefault();
    var $parent = $(this).parents('.toggle-this-container');
    $parent.removeClass('toggle-this-active');
    $parent.find('.toggle-this').removeClass('active');
    $parent.find('.toggle-button').show();
    $(this).hide();
  });

  var $locationSelects = $('[data-locations-select]');
  if ($locationSelects.length && theme.shop.locations !== undefined) {
    $locationSelects.each(function () {
      var $select = $(this);

      for (var key in theme.shop.locations) {
        if (theme.shop.locations.hasOwnProperty(key)) {
          if (theme.shop.locations[key].title !== undefined) {
            $select.append('<option value="' + theme.shop.locations[key].title + '">' + theme.shop.locations[key].title + '</option>');
          }
        }
      }

      $('option[data-locations-select-placeholder]').remove();
    });
  }

  var $locationList = $('[data-locations-list]');
  if ($locationList.length && theme.shop.locations !== undefined) {
    $locationList.each(function () {
      var $list = $(this);

      for (var key in theme.shop.locations) {
        if (theme.shop.locations.hasOwnProperty(key)) {
          if (theme.shop.locations[key].title !== undefined) {
            $list.append('<li><a href="' + theme.shop.locations[key].url + '">' + theme.shop.locations[key].title + '</a></li>');
          }
        }
      }

      $list.children().detach().sort(function (a, b) {
        return $(a).text().localeCompare($(b).text());
      }).appendTo($list);
    });
  }

  if (location.hash == '#contact_form') {
    setTimeout(function () {
      window.scrollTo(0, 0);
    }, 1);
  }

  $('#MainContent').on('change', 'select.bc-sf-filter-filter-dropdown', function () {
    theme.utils.updateSelectWidth(this);
  });

  //go to reviews tab in product tabs
  $('.stamped-product-reviews-badge').on('click', function (evt) {
    //stop stamped code from running on button
    evt.stopImmediatePropagation();

    //for mobile
    if ($('.product-single__tabs.ui-accordion').length) {
      return;
    }

    //for desktop
    var $container = $('.product-tab-desc .tabs-container');
    $('.tabs-menu li.current', $container).removeClass('current');
    $('.tab-content.active', $container).removeClass('active');
    $('[href="#tab-3"]', $container).parent('li').addClass('current');
    var $tab = $('#tab-3', $container);
    var $tabContentInner = $tab.find('.tab-content__inner');

    $tab.addClass('active');
    $tabContentInner.css('max-height', 'unset');
    $('.tab-content', $container).not($tab).removeClass('active').find('.tab-content__inner').css('max-height', '0px');

    var scrollTo = $('#tab-3').offset().top - 100;
    $('html, body').animate({ scrollTop: scrollTo }, 'medium');

    var lw = $('.tabs-menu li.current', $container).width();
    var lof = $('.tabs-menu li.current', $container).offset().left;
    var low = $container.offset().left;
    var flof = lof - low;
    var $marker = $('li.marker', $container);

    $marker.css({
      'width': lw + 'px',
      'transform': 'translate3d(' + flof + 'px, 0, 0)'
    });



  })


  $(document).on('click', 'a[href="#filter-view-all"]', function (evt) {
    evt.preventDefault();
    evt.stopImmediatePropagation();

    if (typeof applyFilterOption === "function" && bcSfFilterSettings != undefined) {
      bcSfFilterSettings.general.paginationType = 'infinite';
      bcSfFilterSettings.general.limit = 60;
      $('.collection__header-pages').html('Viewing all products');

      var newurl = theme.utils.updateQueryStringParameter('view_all', '1', window.location.href);

      if (window.history.replaceState) {
        window.history.replaceState({}, '', newurl);
      } else {
        window.location.href = newurl;
      }

      applyFilterOption();
    }
  });

  /* IEC Landing Page */
  var $iecAccordionItems = $('.iec-feature-step');
  if ($iecAccordionItems.length && $(window).width() < 768) {
    $iecAccordionItems.on('click', function () {
      $iecAccordionItems.removeClass('active');
      $(this).addClass('active');
    });
  }

  var $iecAccordion = $('.product-single__iec-inner');
  if ($iecAccordion.length) {
    $iecAccordion.accordion({
      active: false,
      collapsible: true,
      heightStyle: "content"
    });
  }

  $('a[data-modal]').on('click', function () {
    var $this = $(this),
      variant = $this.data('modal-variant') || '';

    $.featherlight($($this.data('modal')), {
      namespace: 'od-modal',
      variant: variant,
    });
  });


  // Product Grid Item Wishlist Buttons
  // $('#MainContent').on('click', '[data-add-to-wishlist]', function() {
  //   if (window._swat !== undefined) {
  //     var $this = $(this),
  //         product = JSON.parse($('[data-product-id="' + $this.data('product-id') + '"]').html());

  //     if (product) {
  //       window._swat.addToWishList({
  //         "epi": product.variants[0].id,
  //         "empi": product.id,
  //         "du": '/products/' + product.handle,
  //         "iu": product.featured_image,
  //         "pr": productt.variants[0].id.price,
  //       },function(r) {
  //         console.log('Added to wishlist');
  //       });
  //     }
  //   }
  // });

});


$(".Click-here").on('click', function () {
  $(".custom-model-main").addClass('model-open');
  $("body").addClass("modal-open-body");
  $("#gorgias-chat-container").addClass("modal-open-chat");


  if (!document.querySelector("h4[rv-text='group.key']")) {
    
  }
  else {
    document.querySelector('.tab-collect__store_name').click();
  }
  $('address').each(function () {
    var link = "<a href='http://maps.google.com/maps?q=" + encodeURIComponent($(this).text()) + "' target='_blank'>" + $(this).text() + "</a>";
    $(this).html(link);
  });

});
$(".close-btn, .bg-overlay").click(function () {
  $(".custom-model-main").removeClass('model-open');
  $("body").removeClass("modal-open-body");
  $("#gorgias-chat-container").removeClass("modal-open-chat");
 
});
function log() {
  $(".custom-model-main2").addClass('model-open');
  $(".close-btn").addClass('hidden-btn');

  
}
function close_log() {
  $(".custom-model-main2").removeClass('model-open');
  $(".close-btn").removeClass('hidden-btn');
}


function myFunction() {
  // Declare variables
  var input, filter, ul, li, a, i, txtValue;
  input = document.getElementById('myInput');
  filter = input.value.toUpperCase();
  ul = document.querySelector(".wrapp-ul");
  li = ul.querySelectorAll('li');
  // Loop through all list items, and hide those who don't match the search query
  for (i = 0; i < li.length; i++) {
    a = li[i].querySelector(".tab-collect__store_name");

    console.log(a);
    txtValue = a.textContent || a.innerText;
    if (txtValue.toUpperCase().indexOf(filter) > -1) {
      li[i].style.display = "";
    } else {
      li[i].style.display = "none";
    }
  }
}

$("#myModal").on("show", function () {
  $("body").addClass("modal-open");
  $("#gorgias-chat-container").addClass("modal-open-chat");
  

}).on("hidden", function () {
  $("body").removeClass("modal-open");
  $("#gorgias-chat-container").removeClass("modal-open-chat");

});



rivets.formatters.mapHref = function (value) {
  var href = value.replace(/\n/g, '<br />');
  return 'http://maps.google.com/maps?q=' + href;
}



$(window).on('load', function() {
  if($(".yotpo-text-container.yotpo-center-layout").length>0){
    $(".yotpo-text-container.yotpo-center-layout").prepend("<div id='matchbox_logo_yotpo'></div> ");
  }
  $(".yotpo-background-text-mobile").after("<div id='matchbox_logo_yotpo_mobile'></div> ");

});

window.onscroll = function() {myFunction()};

// Get the header
var header = document.getElementById('shopify-section-header');

// Get the offset position of the navbar
var sticky = header.offsetTop;

// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
function myFunction() {
  if (window.pageYOffset > sticky) {
    header.classList.add("sticky-header");
  } else {
    header.classList.remove("sticky-header");
  }
}

// Get the current URL without the query parameter
const removeQueryParameter = () => {
    const urlWithoutQuery = window.location.href.split('?')[0];
    window.history.replaceState({ path: urlWithoutQuery }, '', urlWithoutQuery);
};
// Check if the query parameter exists and remove it
const checkAndRemoveQueryParameter = () => {
    if (window.location.href.includes('?_=pf&pf_t_collection=')) {
        removeQueryParameter();
    }
};
// Call the function to check and remove the query parameter
checkAndRemoveQueryParameter();
